import { AssetProps } from './index'

export default function HeroLogo({ size, color, className }: AssetProps) {
  return (
    <svg
      width={size ?? '24'}
      height={size ?? '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_486_666)">
        <path
          d="M17.0374 12.9C17.6729 11.325 17.4486 8.625 17.3364 8.025C17.2617 7.5375 16.8505 6.975 16.514 6.675C16.2149 6.45 15.8037 6.4125 15.4299 6.525C15.3177 6.5625 15.2056 6.6375 15.0935 6.7125C15.0561 6.225 14.6449 5.85 14.271 5.7375C13.9346 5.625 13.486 5.6625 13.1495 5.85C13.0748 5.8875 13 5.925 12.9626 6C12.9252 5.55 12.7383 5.0625 11.9533 4.875C11.542 4.8 11.2056 4.8375 10.9813 4.9875C10.8692 5.0625 10.757 5.175 10.6822 5.325C10.5701 5.025 10.3084 4.7625 9.93457 4.6875C9.33644 4.575 8.70093 4.875 8.5514 5.175C8.43925 5.4375 8.3271 6.1125 8.28971 6.3C8.1028 6.3375 7.91588 6.375 7.72897 6.375C7.35513 6.4125 6.9813 6.4875 6.57009 6.6C6.57009 6.6 6.57009 6.6 6.5327 6.6C6.04672 6.975 6.04672 8.5125 6.04672 8.55C6.04672 8.7 6.12149 9.4125 6.15887 10.1625C6.23364 10.8375 6.3084 11.7 6.38317 11.8875C6.45794 12.075 7.13083 13.0125 8.1028 14.2875C8.58878 14.9625 9.11214 15.675 9.18691 15.7875C9.22429 16.275 8.81308 21.75 8.70093 23.4375C8.70093 23.4375 8.70093 23.4375 8.70093 23.475C8.70093 23.475 8.70093 23.475 8.70093 23.5125C8.70093 23.5125 8.70093 23.5125 8.73831 23.5125L8.77569 23.55H8.81308H8.85046C8.85046 23.55 8.88784 23.55 8.88784 23.5125C8.88784 23.475 8.92523 23.475 8.92523 23.475V23.4375V23.4C8.92523 23.4 8.92523 23.3625 8.88784 23.3625L10.9065 18.9375H10.9439C10.9813 18.9375 10.9813 18.9375 11.0187 18.9L15.8411 23.325C15.8411 23.325 15.8411 23.3625 15.8411 23.4C15.8411 23.4375 15.8411 23.4375 15.8785 23.4375L15.9159 23.475C15.9159 23.475 15.9533 23.475 15.9906 23.475H16.028C16.028 23.475 16.028 23.5125 16.0654 23.5125H16.1028H16.1402C16.1402 23.5125 16.1402 23.5125 16.1776 23.5125C16.1776 23.5125 16.1776 23.5125 16.1776 23.475V23.4375C16.0654 21.0375 15.9159 16.4625 15.9159 16.2375C15.9159 15.975 16.2897 14.7 17.0374 12.9ZM15.6168 16.2C15.6168 16.2375 15.6168 16.2375 15.6542 16.275L13.785 17.1C13.785 17.1 13.7477 17.0625 13.7103 17.0625L14.0841 14.1375C14.0841 14.1375 14.0841 14.1375 14.1215 14.1375L15.6542 16.0875L15.6168 16.125C15.6168 16.1625 15.6168 16.1625 15.6168 16.2ZM10.9813 18.675C10.9439 18.675 10.9439 18.675 10.9813 18.675L9.48598 15.9C9.52336 15.9 9.52336 15.8625 9.52336 15.825L12.2523 15.75C12.2523 15.7875 12.2897 15.7875 12.2897 15.825L10.9813 18.675ZM7.01869 7.5375C7.05607 7.5375 7.05607 7.5375 7.09345 7.5C7.13083 7.5 7.13083 7.4625 7.13083 7.425L8.92523 7.8V7.8375L7.84111 8.625C7.84111 8.625 7.80373 8.625 7.76635 8.625H7.72897C7.72897 8.625 7.69158 8.625 7.69158 8.6625L7.6542 8.7V8.7375C7.6542 8.775 7.6542 8.775 7.6542 8.8125L6.42055 9.675C6.42055 9.6375 6.38317 9.6375 6.34579 9.6375L7.01869 7.5375C6.9813 7.5375 6.9813 7.5375 7.01869 7.5375ZM8.51401 6.4875C8.51401 6.45 8.51401 6.45 8.51401 6.4125C8.70093 6.375 8.88784 6.3375 9.07476 6.2625C9.56074 6.075 9.78504 6.0375 9.93457 6.1125L10.0841 6.225C10.0841 6.2625 10.1215 6.2625 10.1215 6.3C10.1589 6.4125 10.2336 6.9375 9.97196 7.4625H9.93457C9.89719 7.4625 9.85981 7.4625 9.85981 7.5C9.82242 7.5375 9.82242 7.5375 9.82242 7.575L9.18691 7.7625L9.14953 7.725C9.14953 7.725 9.11214 7.725 9.07476 7.725L8.51401 6.6L8.5514 6.5625C8.51401 6.525 8.51401 6.525 8.51401 6.4875ZM10.4953 5.7375C10.4953 5.775 10.5327 5.775 10.5701 5.8125C10.6075 5.8125 10.6449 5.8125 10.6449 5.8125C10.6449 5.85 10.6449 5.8875 10.6449 5.925C10.6449 6 10.6449 6.1125 10.6449 6.2625C10.6449 6.375 10.6449 6.4875 10.6449 6.6375C10.6075 6.6375 10.6075 6.6375 10.5701 6.6375L10.2336 6.375C10.2336 6.3375 10.2336 6.3 10.1963 6.2625C10.1215 6.1125 9.97196 6 9.78504 6C9.78504 6 9.78504 6 9.78504 5.9625L10.4953 5.7375ZM12.7009 6.075C12.7009 6.1125 12.7009 6.1125 12.7009 6.15L12.7383 6.1875L12.028 7.3875C11.9906 7.3875 11.9906 7.35 11.9533 7.35H11.9159L10.8318 5.7C10.8692 5.7 10.8692 5.6625 10.8692 5.6625C10.8692 5.6625 10.8692 5.625 10.9065 5.5875L12.7009 6.075ZM16.9252 7.7625C16.9252 7.8 16.9252 7.8 16.9626 7.8L17 7.8375L16.7009 8.7C16.6635 8.7 16.6262 8.7 16.6262 8.7375C16.5888 8.775 16.5888 8.775 16.5888 8.8125V8.85L14.5701 9.975L14.5327 9.9375L15.5421 7.95C15.5794 7.95 15.6168 7.95 15.6168 7.9125C15.6542 7.875 15.6542 7.875 15.6542 7.8375L16.9252 7.7625ZM17.2991 10.4625C17.2991 11.0625 17.2243 11.6625 17.0748 12.225H17.0374C17 12.225 17 12.225 16.9626 12.225L16.9252 12.2625L14.1963 11.4L17.2243 10.425C17.2617 10.4625 17.2617 10.4625 17.2991 10.4625ZM13.9346 14.025V14.0625L12.4392 15.6L13.6355 13.1625L13.972 13.9125L13.9346 13.95C13.9346 13.9875 13.9346 13.9875 13.9346 14.025ZM8.28971 11.8125L10.4206 11.7C10.4206 11.7375 10.4579 11.7375 10.4579 11.775C10.4953 11.775 10.4953 11.8125 10.5327 11.8125L12.2149 15.6L8.28971 11.925C8.25233 11.85 8.28971 11.8125 8.28971 11.8125ZM8.96261 7.9125C8.96261 7.9125 8.99999 7.95 9.03738 7.95C9.07476 7.95 9.07476 7.95 9.11214 7.95C9.14953 7.95 9.14953 7.9125 9.14953 7.9125C9.14953 7.875 9.18691 7.875 9.18691 7.8375L9.82242 7.65C9.82242 7.6875 9.85981 7.6875 9.85981 7.6875C9.52336 8.25 8.85046 8.5875 7.99065 8.6625L8.96261 7.9125ZM12.8131 6.225C12.8131 6.2625 12.8131 6.3 12.8131 6.3375C12.8131 6.525 12.7009 7.4625 12.5514 8.3625L12.0654 7.6125C12.1028 7.575 12.1028 7.575 12.1028 7.5375V7.5L12.8131 6.225ZM13.785 7.875L14.2336 9.9C14.2336 9.9 14.2336 9.9 14.1963 9.9L12.7009 8.55V8.5125V8.475L13.6729 7.8375L13.7103 7.875C13.7477 7.875 13.7477 7.875 13.785 7.875ZM12.3645 15.6C12.3271 15.6 12.3271 15.6 12.2897 15.6375L10.5701 11.775C10.6075 11.775 10.6075 11.7375 10.6449 11.7375L13.5607 13.05V13.0875L13.5981 13.125L12.3645 15.6ZM10.6449 6.825C10.6449 7.5375 10.6449 8.55 10.6075 9.1125L10.0841 7.8C10.1215 7.8 10.1215 7.7625 10.1215 7.7625C10.1215 7.725 10.1215 7.725 10.1215 7.6875C10.1215 7.65 10.1215 7.65 10.0841 7.6125C10.0841 7.575 10.0467 7.575 10.0093 7.575C10.0093 7.575 10.0093 7.575 10.0093 7.5375L10.6449 6.825C10.6075 6.825 10.6449 6.825 10.6449 6.825ZM11.9533 7.6125C11.9906 7.6125 11.9906 7.6125 11.9533 7.6125L12.514 8.4L12.4766 8.4375V8.475V8.5125L10.8692 9.4875L11.9533 7.6125ZM13.5607 12.975L10.6449 11.6625L11.9159 11.25C11.9533 11.2875 11.9533 11.2875 11.9906 11.2875H12.028C12.3271 11.5125 12.6262 11.7375 12.8878 12C13.2991 12.4125 13.486 12.75 13.5607 12.975C13.5981 12.9375 13.5607 12.975 13.5607 12.975ZM9.33644 9.825C9.33644 9.7875 9.33644 9.7875 9.33644 9.825C9.33644 9.7875 9.33644 9.75 9.33644 9.75L9.29906 9.7125L10.0093 7.8375L10.5701 9.2625C10.5701 9.375 10.5327 9.4875 10.5327 9.525C10.4206 9.7875 9.97196 9.975 9.59812 9.9C9.56074 9.9 9.52336 9.9 9.48598 9.8625C9.44859 9.8625 9.37383 9.825 9.33644 9.825ZM10.4579 9.825C10.4579 9.825 10.4579 9.8625 10.4953 9.8625L10.5327 9.9L10.4579 10.2375C10.3084 10.1625 10.1589 10.125 9.97196 10.05C10.1589 10.0125 10.3458 9.9375 10.4579 9.825ZM10.6075 9.9C10.6449 9.9 10.6449 9.9 10.6822 9.8625L11.729 10.8C11.3551 10.575 10.9439 10.3875 10.5327 10.2L10.6075 9.9ZM12.028 11.025C12.028 11.025 11.9906 11.025 12.028 11.025H11.9906L10.9439 10.0875C11.0561 10.125 11.1308 10.2 11.243 10.2C11.3551 10.2375 11.4673 10.2375 11.5794 10.2375C11.8037 10.2375 12.0654 10.1625 12.2149 10.05L12.028 11.025ZM10.9065 9.6C10.9065 9.6 10.9065 9.5625 10.9065 9.6L12.514 8.625C12.4392 9.1125 12.3271 9.5625 12.2149 9.75L12.1776 9.7125C12.1402 9.7125 12.1402 9.7125 12.1028 9.7125C12.0654 9.7125 12.0654 9.7125 12.0654 9.75L12.028 9.7875L10.9065 9.6ZM12.4392 9.9375L14.1589 10.0125C14.1589 10.0125 14.1589 10.05 14.1963 10.05L14.2336 10.0875C14.1963 10.125 14.1589 10.2 14.1215 10.2375C13.9346 10.425 13.4486 10.6125 13 10.5C12.7757 10.4625 12.514 10.3125 12.3645 9.975C12.4019 10.0125 12.4019 9.975 12.4392 9.9375ZM14.1589 9.975L12.4392 9.9C12.4392 9.8625 12.4392 9.8625 12.4392 9.825L12.4019 9.7875C12.514 9.5625 12.5888 9.1125 12.7009 8.625C12.7009 8.625 12.7383 8.625 12.7383 8.5875L14.1589 9.975ZM12.028 9.8625C12.028 9.9 12.0654 9.9375 12.0654 9.9375C11.8785 10.0875 11.542 10.125 11.2804 10.05C11.0935 10.0125 10.9065 9.9 10.7944 9.7125C10.8318 9.7125 10.8318 9.7125 10.8692 9.675L10.9065 9.6375L12.028 9.8625ZM9.93457 7.8L9.22429 9.675L8.70093 8.85L8.73831 8.8125V8.775C8.73831 8.7375 8.73831 8.7375 8.70093 8.7C9.37383 8.475 9.71027 8.1 9.93457 7.8ZM8.62616 8.85L9.18691 9.675C9.18691 9.675 9.14953 9.675 9.14953 9.7125C8.88784 9.525 8.70093 9.225 8.62616 8.85ZM9.26168 9.975C9.33644 10.0125 9.41121 10.05 9.48598 10.05C10.5327 10.3875 11.3178 10.7625 11.8785 11.175V11.2125L10.6075 11.625L10.5701 11.5875C10.5701 11.5875 10.5327 11.5875 10.4953 11.5875H10.4579L9.26168 9.975ZM13.0374 11.8875C12.7757 11.625 12.514 11.4 12.2149 11.175L13.972 11.4375C13.972 11.475 13.972 11.475 13.972 11.5125L14.0093 11.55L13.7103 12.7875C13.5981 12.5625 13.4112 12.2625 13.0374 11.8875ZM14.0841 11.325C14.0467 11.325 14.0467 11.325 14.0093 11.3625L13.972 11.4L12.1402 11.1375C12.1402 11.1 12.1028 11.1 12.1028 11.0625L12.2523 10.125C12.3271 10.275 12.4392 10.3875 12.5514 10.5C12.6635 10.6125 12.8131 10.65 12.9626 10.6875C13.0748 10.725 13.1869 10.725 13.2991 10.725C13.6729 10.725 14.0467 10.6125 14.2336 10.3875C14.271 10.35 14.3084 10.3125 14.3084 10.275L14.3458 10.3125L14.0841 11.325ZM14.6449 10.05L16.6262 8.925C16.3271 9.7875 15.9159 10.65 15.2056 10.5375C14.9439 10.5 14.7196 10.3875 14.6075 10.2375C14.6075 10.2 14.5701 10.1625 14.5701 10.1625L14.6075 10.125C14.6075 10.0875 14.6449 10.05 14.6449 10.05ZM11.9159 7.6125L10.8318 9.4875H10.7944L10.7196 9.4125C10.7944 8.8875 10.8318 7.5375 10.7944 6.225C10.7944 6.075 10.7944 5.9625 10.7944 5.8875C10.7944 5.85 10.7944 5.775 10.7944 5.7375L11.8785 7.3875L11.8411 7.425C11.8411 7.4625 11.8411 7.4625 11.8411 7.5C11.8411 7.5375 11.8411 7.5375 11.8785 7.575C11.8785 7.575 11.8785 7.6125 11.9159 7.6125ZM10.5701 6.7875L10.1589 7.3125C10.271 6.9375 10.3084 6.6 10.271 6.375L10.5327 6.6C10.5327 6.6375 10.4953 6.6375 10.4953 6.675V6.7125C10.4953 6.7125 10.5327 6.7875 10.5701 6.7875ZM7.69158 8.85C7.72897 8.85 7.72897 8.8875 7.76635 8.8875C7.80373 8.8875 7.80373 8.8875 7.84111 8.8875L7.8785 8.85C8.06541 8.85 8.25233 8.8125 8.43925 8.775C8.5514 9.375 8.81308 9.7125 9.07476 9.8625C9.07476 9.8625 9.07476 9.8625 9.07476 9.9L6.5327 9.75L7.69158 8.85ZM9.03738 9.9375V9.975C9.03738 9.975 9.03738 10.0125 9.07476 10.0125C9.11214 10.0125 9.11214 10.05 9.11214 10.05H9.14953C9.18691 10.05 9.18691 10.05 9.22429 10.0125L10.4206 11.55L6.45794 9.75L9.03738 9.9375ZM13.7477 12.8625L14.0841 11.55C14.1215 11.55 14.1215 11.55 14.1589 11.55L14.1963 11.5125L16.8878 12.375L13.8224 13.0125C13.785 12.975 13.785 12.9 13.7477 12.8625ZM17.1495 10.35C17.1495 10.3875 17.1495 10.3875 17.1495 10.425L14.1589 11.4C14.1589 11.3625 14.1215 11.3625 14.0841 11.3625L14.3458 10.35C14.3832 10.35 14.3832 10.35 14.3832 10.35C14.3832 10.35 14.3832 10.3875 14.4206 10.3875C14.5701 10.575 14.7944 10.6875 15.0935 10.7625C15.1308 10.7625 15.2056 10.7625 15.243 10.7625C15.9906 10.7625 16.3645 9.9 16.7009 9.0375L17.1869 10.3125C17.1495 10.3125 17.1495 10.35 17.1121 10.35C17.1869 10.3125 17.1495 10.3125 17.1495 10.35ZM15.5421 7.95L14.5327 9.9375C14.5327 9.8625 14.5327 9.7875 14.5701 9.75C14.8318 8.8875 15.0561 7.5375 15.0935 7.125C15.0935 7.125 15.1308 7.125 15.1308 7.0875L15.5421 7.7625L15.5047 7.8V7.8375C15.5047 7.875 15.5047 7.875 15.5047 7.875C15.5047 7.9125 15.5421 7.9125 15.5421 7.95ZM14.9439 7.05C14.8692 7.6125 14.6449 8.8875 14.4206 9.675C14.3832 9.75 14.3832 9.825 14.3458 9.9H14.3084L13.8598 7.875L13.8972 7.8375C13.8972 7.8375 13.8972 7.8 13.8972 7.7625C13.8972 7.725 13.8972 7.725 13.8972 7.725L14.9439 7.05C14.9439 7.0125 14.9439 7.0125 14.9439 7.05ZM13.6355 7.7625L12.6635 8.4375C12.8131 7.5 12.9252 6.45 12.9252 6.375C12.9252 6.3375 12.9252 6.3375 12.9626 6.3L13.6729 7.6875L13.6355 7.725C13.6729 7.725 13.6355 7.725 13.6355 7.7625ZM10.4206 11.625L8.28971 11.7375C8.28971 11.7 8.25233 11.7 8.25233 11.6625C8.21495 11.6625 8.21495 11.625 8.17756 11.625C8.14018 11.625 8.14018 11.625 8.1028 11.625L6.45794 9.7875L10.4206 11.625ZM12.2523 15.675C12.2523 15.7125 12.2523 15.7125 12.2523 15.675L9.52336 15.7875C9.52336 15.75 9.48598 15.75 9.48598 15.7125C9.44859 15.7125 9.44859 15.675 9.41121 15.675L8.25233 11.925L12.2523 15.675ZM12.4766 15.675L14.0093 14.1L14.0467 14.1375L13.6729 17.0625H13.6355L12.4766 15.825C12.4766 15.7875 12.514 15.7875 12.514 15.75C12.4766 15.7125 12.4766 15.675 12.4766 15.675ZM14.0467 13.875L13.6729 13.1625C13.6729 13.1625 13.6729 13.1625 13.7103 13.1625H13.7477C13.7477 13.1625 13.7477 13.1625 13.785 13.1625H13.8224C13.8224 13.1625 13.8224 13.1625 13.8598 13.125C13.8972 13.0875 13.8598 13.125 13.8598 13.0875C13.8598 13.05 13.8598 13.05 13.8598 13.05C13.8598 13.05 13.8598 13.05 13.8598 13.0125L16.9626 12.375L14.1963 13.9125L14.1589 13.875C14.0841 13.875 14.0841 13.875 14.0467 13.875ZM17.2991 10.2375L16.8131 8.925L16.8505 8.8875V8.85C16.8505 8.8125 16.8505 8.8125 16.8131 8.775C16.8131 8.7375 16.7757 8.7375 16.7757 8.7375L17.0748 7.875C17.1121 7.875 17.1121 7.875 17.1495 7.8375C17.1869 7.9125 17.1869 7.9875 17.2243 8.0625C17.2243 8.25 17.3364 9.15 17.2991 10.2375ZM15.5047 6.675C15.7663 6.6 16.1402 6.5625 16.4392 6.7875C16.6635 6.975 16.8878 7.275 17.0374 7.6125C17 7.6125 17 7.6125 16.9626 7.65C16.9252 7.6875 16.9252 7.6875 16.9252 7.6875L15.729 7.7625C15.729 7.725 15.6916 7.725 15.6916 7.6875C15.6542 7.6875 15.6542 7.65 15.6168 7.65C15.6168 7.65 15.6168 7.65 15.5794 7.65L15.1308 6.9375V6.9V6.8625C15.2056 6.825 15.3551 6.75 15.5047 6.675ZM13.2243 6C13.486 5.85 13.9346 5.8125 14.1963 5.8875C14.5701 6.0375 14.9439 6.375 14.9439 6.8625L14.9065 6.9V6.9375L13.8598 7.65C13.8224 7.65 13.8224 7.6125 13.785 7.6125L13.0374 6.1875C13.0748 6.1125 13.1495 6.0375 13.2243 6ZM11.0561 5.1375C11.2804 4.9875 11.542 4.95 11.9159 5.0625C12.5888 5.2125 12.7757 5.5875 12.8131 6C12.7757 6 12.7757 6 12.7383 6L12.7009 6.0375L10.9065 5.55L10.8692 5.5125C10.8692 5.5125 10.8318 5.5125 10.8318 5.475C10.8692 5.325 10.9439 5.2125 11.0561 5.1375ZM9.89719 4.8375C10.3084 4.9125 10.4953 5.2125 10.6075 5.55C10.5701 5.55 10.5327 5.55 10.5327 5.5875C10.4953 5.625 10.4953 5.625 10.4953 5.6625L9.82242 5.85L9.78504 5.8125C9.78504 5.8125 9.74766 5.8125 9.71027 5.8125C9.67289 5.8125 9.67289 5.8125 9.63551 5.85L8.85046 5.2875V5.25V5.2125C8.85046 5.2125 8.85046 5.175 8.81308 5.175L8.77569 5.1375C9.03738 4.9125 9.48597 4.7625 9.89719 4.8375ZM8.66354 5.325C8.70093 5.325 8.70093 5.3625 8.73831 5.3625C8.77569 5.3625 8.77569 5.3625 8.81308 5.325L9.56074 5.8875C9.56074 5.925 9.52336 5.925 9.52336 5.9625C9.37383 6 9.14953 6.0375 8.92523 6.15C8.77569 6.225 8.58878 6.2625 8.40186 6.3C8.51401 6.075 8.58878 5.55 8.66354 5.325ZM7.76635 6.5625C7.91588 6.525 8.1028 6.525 8.25233 6.4875V6.525C8.25233 6.525 8.25233 6.5625 8.28971 6.5625L8.3271 6.6H8.36448C8.36448 6.6 8.36448 6.6 8.40186 6.6L8.96261 7.725L8.92523 7.7625L7.13083 7.3875C7.13083 7.35 7.13083 7.3125 7.09345 7.3125C7.05607 7.275 7.05607 7.275 7.01869 7.275H6.9813L6.757 6.8625C6.79439 6.8625 6.79439 6.825 6.79439 6.7875C6.79439 6.75 6.79439 6.75 6.79439 6.7125C7.13083 6.6375 7.4299 6.6 7.76635 6.5625ZM6.57009 6.8625L6.60747 6.9H6.64485C6.64485 6.9 6.64485 6.9 6.68224 6.9L6.90654 7.3125L6.86915 7.35V7.3875C6.86915 7.425 6.86915 7.425 6.86915 7.4625L6.90654 7.5L6.3084 9.6C6.27102 9.075 6.23364 8.6625 6.23364 8.55C6.23364 8.25 6.3084 7.2375 6.57009 6.8625ZM6.38317 10.2C6.38317 10.0875 6.34579 9.975 6.34579 9.9C6.38317 9.9 6.38317 9.9 6.42055 9.9L8.06541 11.7375C8.06541 11.7375 8.02803 11.775 8.02803 11.8125L6.71962 11.8875C6.71962 11.85 6.68224 11.85 6.68224 11.85C6.64485 11.85 6.64485 11.8125 6.60747 11.8125H6.57009C6.5327 11.55 6.45794 10.9875 6.38317 10.2ZM8.28971 14.25C7.6542 13.425 6.90654 12.4125 6.68224 12C6.71962 12 6.71962 11.9625 6.71962 11.9625C6.71962 11.925 6.757 11.925 6.757 11.8875L8.06541 11.8125C8.06541 11.85 8.1028 11.85 8.1028 11.8875C8.14018 11.8875 8.14018 11.925 8.17756 11.925L9.29906 15.6375C9.18691 15.45 8.88784 15.0375 8.28971 14.25ZM8.85046 23.325C8.99999 20.925 9.33644 16.65 9.37383 15.9375L10.8692 18.7125L10.8318 18.75V18.7875V18.825C10.8318 18.825 10.8318 18.8625 10.8692 18.8625L8.85046 23.325ZM11.0935 18.8625C11.0935 18.825 11.1308 18.7875 11.0935 18.7875C11.0935 18.75 11.0561 18.75 11.0561 18.7125L12.3645 15.8625C12.3645 15.8625 12.3645 15.8625 12.4019 15.8625H12.4392L13.5981 17.1C13.5981 17.1375 13.5607 17.1375 13.5607 17.175V17.2125C13.5607 17.2125 13.5607 17.25 13.5981 17.25C13.6355 17.25 13.6355 17.2875 13.6355 17.2875H13.6729L15.9159 23.25C15.9159 23.25 15.8785 23.25 15.8785 23.2875L11.0935 18.8625ZM15.9906 23.2125L13.7477 17.25C13.785 17.25 13.785 17.2125 13.785 17.175C13.785 17.1375 13.785 17.1 13.785 17.1L15.6542 16.275C15.6542 16.275 15.6916 16.275 15.729 16.275C15.729 17.0625 15.9533 22.125 15.9906 23.2125ZM15.7663 16.05C15.7663 16.05 15.729 16.05 15.7663 16.05C15.729 16.05 15.729 16.05 15.729 16.05L14.1963 14.0625C14.1963 14.025 14.2336 14.025 14.2336 13.9875L17 12.45L17.0374 12.4875C17 12.6 16.9626 12.7125 16.9252 12.825C16.2149 14.4375 15.8785 15.6 15.7663 16.05Z"
          fill={color ?? '#00FFFF'}
        />
        <path
          d="M22.5701 6.30001L12.8505 0.412506C12.6636 0.300006 12.4393 0.225006 12.215 0.225006C11.9907 0.225006 11.7664 0.300006 11.5794 0.412506L1.85982 6.30001C1.48599 6.52501 1.2243 6.97501 1.2243 7.42501V19.2C1.2243 19.65 1.4486 20.1 1.85982 20.325L7.46729 23.7C7.50468 23.7 7.50468 23.925 7.54206 23.925C7.57944 23.925 7.65421 23.7 7.65421 23.6625C7.69159 23.625 7.69159 23.5875 7.65421 23.55C7.65421 23.5125 7.61683 23.475 7.57944 23.475L1.97197 20.1C1.82244 20.025 1.71029 19.875 1.63552 19.725C1.56075 19.575 1.52337 19.3875 1.52337 19.2375V7.42501C1.52337 7.23751 1.56075 7.08751 1.63552 6.93751C1.71029 6.78751 1.82244 6.67501 1.97197 6.56251L11.729 0.675006C11.8785 0.600006 12.028 0.562506 12.215 0.562506C12.4019 0.562506 12.5514 0.600006 12.7009 0.675006L22.458 6.56251C22.6075 6.63751 22.7196 6.78751 22.7944 6.93751C22.8692 7.08751 22.9065 7.27501 22.9065 7.42501V19.2C22.9065 19.3875 22.8692 19.5375 22.7944 19.6875C22.7196 19.8375 22.6075 19.95 22.458 20.0625L17.2991 23.175C17.2617 23.2125 17.2243 23.2125 17.2243 23.25C17.2243 23.2875 17.2243 23.325 17.2243 23.3625C17.2617 23.4375 17.3365 23.6625 17.4112 23.625L22.6075 20.2875C22.7944 20.175 22.9439 19.9875 23.0561 19.8C23.1682 19.6125 23.2056 19.3875 23.2056 19.1625V7.42501C23.2056 6.97501 22.9439 6.52501 22.5701 6.30001Z"
          fill={color ?? 'url(#paint0_linear_486_666)'}
        />
        <path
          d="M22.7944 6.1875L12.8505 0.1875C12.6636 0.075 12.4393 0 12.215 0C11.9907 0 11.7664 0.075 11.5794 0.1875L1.63551 6.1875C1.26168 6.4125 1 6.8625 1 7.35V19.3875C1 19.875 1.2243 20.2875 1.63551 20.55L7.35514 23.9625C7.39252 23.9625 7.39252 24 7.42991 24C7.46729 24 7.46729 24 7.50467 23.9625C7.54206 23.9625 7.54206 23.925 7.54206 23.925C7.57944 23.8875 7.57944 23.85 7.54206 23.8125C7.54206 23.775 7.50467 23.7375 7.46729 23.7L1.78505 20.25C1.63551 20.175 1.52336 20.025 1.41121 19.875C1.33645 19.725 1.29907 19.5375 1.29907 19.3875V7.35C1.29907 7.1625 1.33645 7.0125 1.41121 6.8625C1.48598 6.7125 1.63551 6.5625 1.78505 6.4875L11.729 0.4875C11.8785 0.4125 12.028 0.3375 12.215 0.3375C12.4019 0.3375 12.5514 0.375 12.7009 0.4875L22.6449 6.4875C22.7944 6.5625 22.9065 6.7125 23.0187 6.8625C23.0935 7.0125 23.1308 7.2 23.1308 7.35V19.3875C23.1308 19.575 23.0935 19.725 23.0187 19.875C22.9439 20.025 22.7944 20.175 22.6449 20.25L17.3738 23.4375C17.3364 23.475 17.2991 23.475 17.2991 23.55C17.2991 23.5875 17.2991 23.625 17.2991 23.6625L17.3364 23.7L17.3738 23.7375C17.4112 23.7375 17.4112 23.7375 17.4486 23.7375C17.486 23.7375 17.486 23.7375 17.486 23.7L22.757 20.5125C23.1308 20.2875 23.3925 19.8375 23.3925 19.35V7.35C23.4299 6.8625 23.1682 6.4125 22.7944 6.1875Z"
          fill={color ?? 'url(#paint1_linear_486_666)'}
        />
        <path
          d="M2.30841 17.1V17.5875H2.23364V17.6625H2.42056V17.5875H2.38317V16.9875H2.30841L2.19626 17.025L2.23364 17.1H2.30841Z"
          fill={color ?? 'url(#paint2_linear_486_666)'}
        />
        <path
          d="M5.2243 17.1V17.5875H5.14954V17.6625H5.33645V17.5875H5.29907V16.9875H5.2243L5.11215 17.025L5.14954 17.1H5.2243Z"
          fill={color ?? 'url(#paint3_linear_486_666)'}
        />
        <path
          d="M2.49532 7.1625L2.45794 7.125C2.42056 7.125 2.42056 7.125 2.38318 7.125C2.34579 7.125 2.34579 7.125 2.30841 7.125C2.27103 7.125 2.27103 7.1625 2.27103 7.1625L2.23364 7.2C2.23364 7.2375 2.23364 7.2375 2.23364 7.275V7.65C2.23364 7.6875 2.23364 7.6875 2.23364 7.725C2.23364 7.7625 2.27103 7.7625 2.27103 7.7625L2.30841 7.8C2.34579 7.8 2.34579 7.8 2.38318 7.8C2.42056 7.8 2.42056 7.8 2.45794 7.8C2.49532 7.8 2.53271 7.7625 2.53271 7.725C2.53271 7.6875 2.53271 7.6875 2.53271 7.65V7.275C2.53271 7.2375 2.53271 7.2375 2.53271 7.2C2.49532 7.2 2.49532 7.2 2.49532 7.1625ZM2.42056 7.65C2.42056 7.6875 2.42056 7.6875 2.38318 7.6875C2.38318 7.6875 2.38318 7.6875 2.34579 7.6875C2.34579 7.6875 2.34579 7.6875 2.30841 7.6875H2.27103L2.23364 7.65C2.23364 7.65 2.23364 7.65 2.23364 7.6125V7.2375V7.2C2.23364 7.2 2.23364 7.2 2.23364 7.1625C2.23364 7.1625 2.23364 7.1625 2.27103 7.1625C2.27103 7.1625 2.27103 7.1625 2.30841 7.1625C2.30841 7.1625 2.30841 7.1625 2.34579 7.1625C2.34579 7.1625 2.34579 7.1625 2.38318 7.1625C2.38318 7.1625 2.38318 7.1625 2.38318 7.2C2.38318 7.2 2.38318 7.2 2.38318 7.2375L2.42056 7.65Z"
          fill={color ?? 'url(#paint4_linear_486_666)'}
        />
        <path
          d="M3.16824 12.6375L3.13085 12.6C3.09347 12.6 3.09347 12.6 3.05609 12.6C3.0187 12.6 3.0187 12.6 2.98132 12.6C2.94394 12.6 2.94394 12.6375 2.94394 12.6375L2.90655 12.675L2.86917 12.75V13.125C2.86917 13.1625 2.86917 13.1625 2.86917 13.2C2.86917 13.2375 2.90655 13.2375 2.90655 13.2375L2.94394 13.275C2.98132 13.275 2.98132 13.275 3.0187 13.275C3.05609 13.275 3.05609 13.275 3.09347 13.275C3.13085 13.275 3.13085 13.2375 3.13085 13.2375L3.16824 13.2C3.16824 13.1625 3.16824 13.1625 3.16824 13.125V12.75C3.16824 12.7125 3.16824 12.7125 3.16824 12.675C3.16824 12.675 3.16824 12.675 3.16824 12.6375ZM3.13085 13.125C3.13085 13.1625 3.13085 13.1625 3.09347 13.1625C3.09347 13.1625 3.09347 13.1625 3.05609 13.1625C3.05609 13.1625 3.05609 13.1625 3.0187 13.1625H2.98132C2.98132 13.1625 2.98132 13.1625 2.94394 13.1625C2.94394 13.1625 2.94394 13.1625 2.94394 13.125C2.94394 13.125 2.94394 13.125 2.94394 13.0875V12.7125V12.675C2.94394 12.675 2.94394 12.675 2.94394 12.6375C2.94394 12.6375 2.94394 12.6375 2.98132 12.6375C2.98132 12.6375 2.98132 12.6375 3.0187 12.6375H3.05609C3.05609 12.6375 3.05609 12.6375 3.09347 12.6375C3.09347 12.6375 3.09347 12.6375 3.09347 12.675C3.09347 12.675 3.09347 12.675 3.09347 12.7125L3.13085 13.125Z"
          fill={color ?? 'url(#paint5_linear_486_666)'}
        />
        <path
          d="M6.68225 6.15001V6.63751C6.71963 6.63751 6.75701 6.63751 6.75701 6.60001V6.03751H6.68225L6.5701 6.07501L6.60748 6.15001H6.68225Z"
          fill={color ?? 'url(#paint6_linear_486_666)'}
        />
        <path
          d="M3.76635 12.7125V13.2H3.69159V13.275H3.8785V13.2H3.84112V12.6H3.76635L3.65421 12.6375L3.69159 12.7125H3.76635Z"
          fill={color ?? 'url(#paint7_linear_486_666)'}
        />
        <path
          d="M3.16824 11.5125H3.09347L2.98132 11.55L3.01871 11.625H3.09347V12.1125H3.01871V12.1875H3.20562V12.1125H3.16824V11.5125Z"
          fill={color ?? 'url(#paint8_linear_486_666)'}
        />
        <path
          d="M6.00934 5.025V5.5125H5.93457V5.625H6.12149V5.55H6.0841V4.95H6.00934L5.89719 4.9875L5.93457 5.0625L6.00934 5.025Z"
          fill={color ?? 'url(#paint9_linear_486_666)'}
        />
        <path
          d="M2.49532 15.9375L2.45794 15.9C2.42056 15.9 2.42056 15.9 2.38318 15.9C2.34579 15.9 2.34579 15.9 2.30841 15.9C2.27103 15.9 2.27103 15.9375 2.27103 15.9375L2.23364 15.975C2.23364 16.0125 2.23364 16.0125 2.23364 16.05V16.425C2.23364 16.4625 2.23364 16.4625 2.23364 16.5C2.23364 16.5 2.23364 16.5 2.27103 16.5L2.30841 16.5375C2.34579 16.5375 2.34579 16.5375 2.38318 16.5375C2.42056 16.5375 2.42056 16.5375 2.45794 16.5375L2.49532 16.5C2.49532 16.5 2.49532 16.5 2.49532 16.4625C2.49532 16.425 2.49532 16.425 2.49532 16.3875V16.0125C2.49532 15.975 2.49532 15.975 2.49532 15.9375C2.49532 15.9375 2.49532 15.975 2.49532 15.9375ZM2.42056 16.3875C2.42056 16.425 2.42056 16.425 2.42056 16.3875C2.42056 16.425 2.42056 16.425 2.38318 16.425C2.38318 16.425 2.38318 16.425 2.34579 16.425C2.34579 16.425 2.34579 16.425 2.30841 16.425H2.27103C2.27103 16.425 2.27103 16.425 2.23364 16.425C2.23364 16.425 2.23364 16.425 2.23364 16.3875C2.23364 16.3875 2.23364 16.3875 2.23364 16.35V15.975V15.9375L2.27103 15.9C2.27103 15.9 2.27103 15.9 2.30841 15.9C2.30841 15.9 2.30841 15.9 2.34579 15.9C2.34579 15.9 2.34579 15.9 2.38318 15.9C2.38318 15.9 2.38318 15.9 2.38318 15.9375C2.38318 15.9375 2.38318 15.9375 2.38318 15.975L2.42056 16.3875Z"
          fill={color ?? 'url(#paint10_linear_486_666)'}
        />
        <path
          d="M2.49532 18.1125L2.45794 18.075C2.42056 18.075 2.38318 18.075 2.34579 18.075C2.30841 18.075 2.27103 18.1125 2.27103 18.15C2.27103 18.1875 2.27103 18.1875 2.27103 18.225V18.6C2.27103 18.6375 2.27103 18.6375 2.27103 18.675C2.27103 18.7125 2.30841 18.7125 2.30841 18.7125L2.34579 18.75C2.38318 18.75 2.38318 18.75 2.42056 18.75C2.45794 18.75 2.45794 18.75 2.49532 18.75L2.53271 18.7125L2.57009 18.675C2.57009 18.6375 2.57009 18.6375 2.57009 18.6V18.225C2.57009 18.1875 2.57009 18.1875 2.57009 18.15C2.49532 18.15 2.49532 18.15 2.49532 18.1125ZM2.42056 18.6C2.42056 18.6375 2.42056 18.6375 2.38318 18.6375C2.38318 18.6375 2.38318 18.6375 2.34579 18.6375C2.34579 18.6375 2.34579 18.6375 2.30841 18.6375H2.27103C2.27103 18.6375 2.27103 18.6375 2.23364 18.6375C2.23364 18.6375 2.23364 18.6375 2.23364 18.6C2.23364 18.6 2.23364 18.6 2.23364 18.5625V18.1875V18.15C2.23364 18.15 2.23364 18.15 2.23364 18.1125C2.23364 18.1125 2.23364 18.1125 2.27103 18.1125C2.27103 18.1125 2.27103 18.1125 2.30841 18.1125C2.30841 18.1125 2.30841 18.1125 2.34579 18.1125L2.38318 18.15C2.38318 18.15 2.38318 18.15 2.38318 18.1875L2.42056 18.6Z"
          fill={color ?? 'url(#paint11_linear_486_666)'}
        />
        <path
          d="M6.83178 4.42501H6.7944V4.16251L6.71963 4.20001V4.42501H6.60748V4.50001H6.7944V4.42501H6.83178Z"
          fill={color ?? 'url(#paint12_linear_486_666)'}
        />
        <path
          d="M3.76635 6.15001V6.63751H3.69159V6.71251H3.8785V6.63751H3.84112V6.03751H3.76635L3.65421 6.07501L3.69159 6.15001H3.76635Z"
          fill={color ?? 'url(#paint13_linear_486_666)'}
        />
        <path
          d="M3.16824 9.3H3.09347L2.98132 9.375L3.01871 9.45L3.09347 9.4125V9.9H3.01871V9.975H3.20562V9.9H3.16824V9.3Z"
          fill={color ?? 'url(#paint14_linear_486_666)'}
        />
        <path
          d="M7.35513 6.45V6.1875V6.15L7.39251 6.1125C7.39251 6.1125 7.39252 6.1125 7.4299 6.1125H7.46728C7.46728 6.1125 7.46728 6.1125 7.50466 6.1125C7.50466 6.1125 7.50466 6.1125 7.50466 6.15C7.50466 6.15 7.50466 6.15 7.50466 6.1875V6.45H7.57943V6.225C7.57943 6.1875 7.57943 6.1875 7.57943 6.15C7.57943 6.1125 7.54205 6.1125 7.54205 6.1125L7.50466 6.075C7.46728 6.075 7.46728 6.075 7.4299 6.075C7.39252 6.075 7.39251 6.075 7.35513 6.075C7.31775 6.075 7.31775 6.1125 7.31775 6.1125L7.28036 6.15C7.28036 6.1875 7.28036 6.1875 7.28036 6.225V6.525L7.35513 6.45Z"
          fill={color ?? 'url(#paint15_linear_486_666)'}
        />
        <path
          d="M3.76635 10.5V10.9875H3.69159V11.0625H3.8785V10.9875H3.84112V10.3875H3.76635L3.65421 10.425L3.69159 10.5H3.76635Z"
          fill={color ?? 'url(#paint16_linear_486_666)'}
        />
        <path
          d="M6.64487 5.55001L6.68225 5.58751C6.71963 5.58751 6.71963 5.58751 6.75702 5.58751C6.7944 5.58751 6.7944 5.58751 6.83178 5.58751C6.86917 5.58751 6.90655 5.55001 6.90655 5.51251C6.90655 5.47501 6.90655 5.47501 6.90655 5.43751V5.06251C6.90655 5.02501 6.90655 5.02501 6.90655 4.98751L6.86917 4.95001L6.83178 4.91251C6.7944 4.91251 6.7944 4.91251 6.75702 4.91251C6.71963 4.91251 6.71963 4.91251 6.68225 4.91251C6.64487 4.91251 6.64487 4.95001 6.64487 4.95001L6.60748 4.98751C6.60748 5.02501 6.60748 5.02501 6.60748 5.06251V5.43751C6.60748 5.47501 6.60748 5.47501 6.60748 5.51251C6.60748 5.55001 6.64487 5.55001 6.64487 5.55001ZM6.68225 5.10001C6.68225 5.10001 6.68225 5.06251 6.68225 5.10001C6.68225 5.06251 6.68225 5.06251 6.71963 5.06251C6.71963 5.06251 6.71963 5.06251 6.75702 5.06251H6.7944H6.83178C6.83178 5.06251 6.83178 5.06251 6.86917 5.06251C6.86917 5.06251 6.86917 5.06251 6.86917 5.10001C6.86917 5.10001 6.86917 5.10001 6.86917 5.13751V5.51251V5.55001C6.86917 5.55001 6.86917 5.55001 6.86917 5.58751C6.86917 5.58751 6.86917 5.58751 6.83178 5.58751C6.83178 5.58751 6.83178 5.58751 6.7944 5.58751C6.75702 5.58751 6.75702 5.58751 6.75702 5.58751C6.75702 5.58751 6.75702 5.58751 6.71963 5.58751C6.71963 5.58751 6.71963 5.58751 6.71963 5.55001V5.51251L6.68225 5.10001Z"
          fill={color ?? 'url(#paint17_linear_486_666)'}
        />
        <path
          d="M2.30841 19.1625L2.19626 19.2L2.23364 19.275L2.30841 19.2375V19.725L2.38317 19.7625V19.125L2.30841 19.1625Z"
          fill={color ?? 'url(#paint18_linear_486_666)'}
        />
        <path
          d="M3.16824 10.4625L3.13085 10.425C3.09347 10.425 3.09347 10.425 3.05609 10.425C3.0187 10.425 3.0187 10.425 2.98132 10.425C2.94394 10.425 2.94394 10.4625 2.94394 10.4625L2.90656 10.5C2.90656 10.5375 2.90656 10.5375 2.90656 10.575V10.95C2.90656 10.9875 2.90656 10.9875 2.90656 11.025C2.90656 11.0625 2.94394 11.0625 2.94394 11.0625L2.98132 11.1C3.0187 11.1 3.0187 11.1 3.05609 11.1C3.09347 11.1 3.09347 11.1 3.13085 11.1C3.16824 11.1 3.16824 11.0625 3.16824 11.0625L3.20562 11.025C3.20562 10.9875 3.20562 10.9875 3.20562 10.95V10.575C3.20562 10.5375 3.20562 10.5375 3.20562 10.5C3.16824 10.5 3.16824 10.4625 3.16824 10.4625ZM3.13085 10.9125C3.13085 10.95 3.13085 10.95 3.13085 10.9125C3.13085 10.95 3.13085 10.95 3.09347 10.95C3.09347 10.95 3.09347 10.95 3.05609 10.95C3.05609 10.95 3.05609 10.95 3.0187 10.95H2.98132C2.98132 10.95 2.98132 10.95 2.94394 10.95C2.94394 10.95 2.94394 10.95 2.94394 10.9125C2.94394 10.9125 2.94394 10.9125 2.94394 10.875V10.5V10.4625C2.94394 10.4625 2.94394 10.4625 2.94394 10.425C2.94394 10.425 2.94394 10.425 2.98132 10.425C2.98132 10.425 2.98132 10.425 3.0187 10.425H3.05609C3.05609 10.425 3.05609 10.425 3.09347 10.425C3.09347 10.425 3.09347 10.425 3.09347 10.4625C3.09347 10.4625 3.09347 10.4625 3.09347 10.5L3.13085 10.9125Z"
          fill={color ?? 'url(#paint19_linear_486_666)'}
        />
        <path
          d="M3.76635 8.32499V8.81249H3.69159V8.88749H3.8785V8.81249H3.84112V8.21249H3.76635L3.65421 8.24999L3.69159 8.32499H3.76635Z"
          fill={color ?? 'url(#paint20_linear_486_666)'}
        />
        <path
          d="M5.2243 8.32499V8.81249H5.14954V8.88749H5.33645V8.81249H5.29907V8.21249H5.2243L5.11215 8.24999L5.14954 8.32499H5.2243Z"
          fill={color ?? 'url(#paint21_linear_486_666)'}
        />
        <path
          d="M2.30841 8.2125L2.19626 8.25L2.23364 8.325L2.30841 8.2875V8.775H2.23364V8.85H2.42056V8.775H2.38317V8.175L2.30841 8.2125Z"
          fill={color ?? 'url(#paint22_linear_486_666)'}
        />
        <path
          d="M5.2243 12.7125V13.2H5.14954V13.275H5.33645V13.2H5.29907V12.6H5.2243L5.11215 12.6375L5.14954 12.7125H5.2243Z"
          fill={color ?? 'url(#paint23_linear_486_666)'}
        />
        <path
          d="M2.30841 14.8875V15.375H2.23364V15.45H2.42056V15.375H2.38317V14.775H2.30841L2.19626 14.8125L2.23364 14.8875H2.30841Z"
          fill={color ?? 'url(#paint24_linear_486_666)'}
        />
        <path
          d="M3.16824 18.075H3.09347L2.98132 18.1125L3.01871 18.1875L3.09347 18.15V18.6375H3.01871V18.75H3.20562V18.675H3.16824V18.075Z"
          fill={color ?? 'url(#paint25_linear_486_666)'}
        />
        <path
          d="M3.16824 17.025L3.13085 16.9875C3.09347 16.9875 3.09347 16.9875 3.05609 16.9875C3.0187 16.9875 3.0187 16.9875 2.98132 16.9875C2.94394 16.9875 2.94394 17.025 2.94394 17.025L2.90656 17.0625C2.90656 17.1 2.90656 17.1 2.90656 17.1375V17.5125C2.90656 17.55 2.90656 17.55 2.90656 17.5875C2.90656 17.625 2.94394 17.625 2.94394 17.625L2.98132 17.6625C3.0187 17.6625 3.0187 17.6625 3.05609 17.6625C3.09347 17.6625 3.09347 17.6625 3.13085 17.6625C3.13085 17.625 3.13085 17.625 3.16824 17.625L3.20562 17.5875C3.20562 17.55 3.20562 17.55 3.20562 17.5125V17.1375C3.20562 17.1 3.20562 17.1 3.20562 17.0625C3.16824 17.0625 3.16824 17.025 3.16824 17.025ZM3.13085 17.5125C3.13085 17.55 3.13085 17.55 3.09347 17.55C3.09347 17.55 3.09347 17.55 3.05609 17.55C3.05609 17.55 3.05609 17.55 3.0187 17.55H2.98132C2.98132 17.55 2.98132 17.55 2.94394 17.55C2.94394 17.55 2.94394 17.55 2.94394 17.5125C2.94394 17.5125 2.94394 17.5125 2.94394 17.475V17.1V17.0625C2.94394 17.0625 2.94394 17.0625 2.94394 17.025C2.94394 17.025 2.94394 17.025 2.98132 17.025C2.98132 17.025 2.98132 17.025 3.0187 17.025H3.05609C3.05609 17.025 3.05609 17.025 3.09347 17.025C3.09347 17.025 3.09347 17.025 3.09347 17.0625C3.09347 17.0625 3.09347 17.0625 3.09347 17.1L3.13085 17.5125Z"
          fill={color ?? 'url(#paint26_linear_486_666)'}
        />
        <path
          d="M3.16824 15.9H3.09347L2.98132 15.9375L3.01871 16.0125L3.09347 15.975V16.4625H3.01871V16.5375H3.20562V16.4625H3.16824V15.9Z"
          fill={color ?? 'url(#paint27_linear_486_666)'}
        />
        <path
          d="M3.76635 14.8875V15.375H3.69159V15.45H3.8785V15.375H3.84112V14.775H3.76635L3.65421 14.8125L3.69159 14.8875H3.76635Z"
          fill={color ?? 'url(#paint28_linear_486_666)'}
        />
        <path
          d="M3.76635 17.1V17.5875H3.69159V17.6625H3.8785V17.5875H3.84112V16.9875H3.76635L3.65421 17.025L3.69159 17.1H3.76635Z"
          fill={color ?? 'url(#paint29_linear_486_666)'}
        />
        <path
          d="M5.2243 10.5V10.9875H5.14954V11.0625H5.33645V10.9875H5.29907V10.3875H5.2243L5.11215 10.4625L5.14954 10.5375L5.2243 10.5Z"
          fill={color ?? 'url(#paint30_linear_486_666)'}
        />
        <path
          d="M2.49532 11.55L2.45794 11.5125C2.42056 11.5125 2.42056 11.5125 2.38318 11.5125C2.34579 11.5125 2.34579 11.5125 2.30841 11.5125C2.27103 11.5125 2.27103 11.55 2.27103 11.55L2.23364 11.5875C2.23364 11.625 2.23364 11.625 2.23364 11.6625V12.0375C2.23364 12.075 2.23364 12.075 2.23364 12.1125C2.23364 12.15 2.27103 12.15 2.27103 12.15L2.30841 12.1875C2.34579 12.1875 2.34579 12.1875 2.38318 12.1875C2.42056 12.1875 2.42056 12.1875 2.45794 12.1875L2.49532 12.15L2.53271 12.1125C2.53271 12.075 2.53271 12.075 2.53271 12.0375V11.6625C2.53271 11.625 2.53271 11.625 2.53271 11.5875C2.49532 11.5875 2.49532 11.55 2.49532 11.55ZM2.42056 12.0375C2.42056 12.075 2.42056 12.075 2.38318 12.075C2.38318 12.075 2.38318 12.075 2.34579 12.075C2.34579 12.075 2.34579 12.075 2.30841 12.075H2.27103C2.27103 12.075 2.27103 12.075 2.23364 12.075C2.23364 12.075 2.23364 12.075 2.23364 12.0375C2.23364 12.0375 2.23364 12.0375 2.23364 12V11.625V11.5875L2.27103 11.55C2.27103 11.55 2.27103 11.55 2.30841 11.55C2.30841 11.55 2.30841 11.55 2.34579 11.55C2.34579 11.55 2.34579 11.55 2.38318 11.55C2.38318 11.55 2.38318 11.55 2.38318 11.5875C2.38318 11.5875 2.38318 11.5875 2.38318 11.625L2.42056 12.0375Z"
          fill={color ?? 'url(#paint31_linear_486_666)'}
        />
        <path
          d="M5.2243 6.0375L5.11215 6.075L5.14954 6.15L5.2243 6.1125V6.6H5.14954V6.675H5.33645V6.6H5.29907V6L5.2243 6.0375Z"
          fill={color ?? 'url(#paint32_linear_486_666)'}
        />
        <path
          d="M2.30841 12.7125V13.2H2.23364V13.275H2.42056V13.2H2.38317V12.6H2.30841L2.19626 12.6375L2.23364 12.7125H2.30841Z"
          fill={color ?? 'url(#paint33_linear_486_666)'}
        />
        <path
          d="M3.16824 13.6875H3.09347L2.98132 13.725L3.01871 13.8L3.09347 13.7625V14.25H3.01871V14.325H3.20562V14.25H3.16824V13.6875Z"
          fill={color ?? 'url(#paint34_linear_486_666)'}
        />
        <path
          d="M2.49532 13.725L2.45794 13.6875C2.42056 13.6875 2.42056 13.6875 2.38318 13.6875C2.34579 13.6875 2.34579 13.6875 2.30841 13.6875C2.27103 13.6875 2.27103 13.725 2.27103 13.725L2.23364 13.7625C2.23364 13.8 2.23364 13.8 2.23364 13.8375V14.2125C2.23364 14.25 2.23364 14.25 2.23364 14.2875C2.23364 14.325 2.27103 14.325 2.27103 14.325L2.30841 14.3625C2.34579 14.3625 2.34579 14.3625 2.38318 14.3625C2.42056 14.3625 2.42056 14.3625 2.45794 14.3625L2.49532 14.325L2.53271 14.2875C2.53271 14.25 2.53271 14.25 2.53271 14.2125V13.8375C2.53271 13.8 2.53271 13.8 2.53271 13.7625C2.49532 13.7625 2.49532 13.7625 2.49532 13.725ZM2.42056 14.2125C2.42056 14.2125 2.42056 14.25 2.42056 14.2125C2.42056 14.25 2.42056 14.25 2.38318 14.25C2.38318 14.25 2.38318 14.25 2.34579 14.25C2.34579 14.25 2.34579 14.25 2.30841 14.25C2.27103 14.25 2.27103 14.25 2.27103 14.25C2.27103 14.25 2.27103 14.25 2.23364 14.25C2.23364 14.25 2.23364 14.25 2.23364 14.2125C2.23364 14.2125 2.23364 14.2125 2.23364 14.175V13.8V13.7625C2.23364 13.7625 2.23364 13.7625 2.23364 13.725C2.23364 13.725 2.23364 13.725 2.27103 13.725C2.27103 13.725 2.27103 13.725 2.30841 13.725C2.30841 13.725 2.30841 13.725 2.34579 13.725L2.38318 13.7625C2.38318 13.7625 2.38318 13.7625 2.38318 13.8L2.42056 14.2125Z"
          fill={color ?? 'url(#paint35_linear_486_666)'}
        />
        <path
          d="M5.8598 6.67501L5.89718 6.71251C5.93457 6.71251 5.93457 6.71251 5.97195 6.71251C6.00933 6.71251 6.00933 6.71251 6.04672 6.71251L6.0841 6.67501C6.12148 6.63751 6.12148 6.60001 6.12148 6.56251V6.18751C6.12148 6.15001 6.12148 6.15001 6.12148 6.11251C6.12148 6.07501 6.0841 6.07501 6.0841 6.07501L6.04672 6.03751C6.00933 6.03751 6.00933 6.03751 5.97195 6.03751C5.93457 6.03751 5.93457 6.03751 5.89718 6.03751C5.8598 6.03751 5.8598 6.07501 5.8598 6.07501L5.82242 6.11251C5.82242 6.15001 5.82242 6.15001 5.82242 6.18751V6.56251C5.82242 6.60001 5.82242 6.60001 5.82242 6.63751C5.82242 6.63751 5.8598 6.63751 5.8598 6.67501ZM5.89718 6.18751C5.89718 6.18751 5.89718 6.15001 5.89718 6.18751C5.89718 6.15001 5.89718 6.15001 5.93457 6.15001C5.93457 6.15001 5.93457 6.15001 5.97195 6.15001C5.97195 6.15001 5.97195 6.15001 6.00933 6.15001H6.04672C6.04672 6.15001 6.04672 6.15001 6.0841 6.15001C6.0841 6.15001 6.0841 6.15001 6.0841 6.18751C6.0841 6.18751 6.0841 6.18751 6.0841 6.22501V6.60001V6.63751C6.0841 6.63751 6.0841 6.63751 6.0841 6.67501C6.0841 6.67501 6.0841 6.67501 6.04672 6.67501C6.04672 6.67501 6.04672 6.67501 6.00933 6.67501H5.97195C5.97195 6.67501 5.97195 6.67501 5.93457 6.67501C5.93457 6.67501 5.93457 6.67501 5.93457 6.63751C5.93457 6.63751 5.93457 6.63751 5.93457 6.60001L5.89718 6.18751Z"
          fill={color ?? 'url(#paint36_linear_486_666)'}
        />
        <path
          d="M2.49532 9.37499L2.45794 9.33749C2.42056 9.33749 2.42056 9.33749 2.38318 9.33749C2.34579 9.33749 2.34579 9.33749 2.30841 9.33749C2.27103 9.33749 2.27103 9.37499 2.27103 9.37499L2.23364 9.41249C2.23364 9.44999 2.23364 9.44999 2.23364 9.48749V9.86249C2.23364 9.89999 2.23364 9.89999 2.23364 9.93749C2.23364 9.97499 2.27103 9.97499 2.27103 9.97499L2.30841 10.0125C2.34579 10.0125 2.34579 10.0125 2.38318 10.0125C2.42056 10.0125 2.42056 10.0125 2.45794 10.0125L2.49532 9.97499L2.53271 9.93749C2.53271 9.89999 2.53271 9.89999 2.53271 9.86249V9.48749C2.53271 9.44999 2.53271 9.44999 2.53271 9.41249C2.49532 9.37499 2.49532 9.37499 2.49532 9.37499ZM2.42056 9.82499C2.42056 9.82499 2.42056 9.86249 2.42056 9.82499C2.42056 9.86249 2.42056 9.86249 2.38318 9.86249C2.38318 9.86249 2.38318 9.86249 2.34579 9.86249C2.34579 9.86249 2.34579 9.86249 2.30841 9.86249H2.27103C2.27103 9.86249 2.27103 9.86249 2.23364 9.86249C2.23364 9.86249 2.23364 9.86249 2.23364 9.82499C2.23364 9.82499 2.23364 9.82499 2.23364 9.78749V9.41249V9.37499C2.23364 9.37499 2.23364 9.37499 2.23364 9.33749C2.23364 9.33749 2.23364 9.33749 2.27103 9.33749C2.27103 9.33749 2.27103 9.33749 2.30841 9.33749C2.30841 9.33749 2.30841 9.33749 2.34579 9.33749C2.34579 9.33749 2.34579 9.33749 2.38318 9.33749C2.38318 9.33749 2.38318 9.33749 2.38318 9.37499C2.38318 9.37499 2.38318 9.37499 2.38318 9.41249L2.42056 9.82499Z"
          fill={color ?? 'url(#paint37_linear_486_666)'}
        />
        <path
          d="M3.16824 19.2L3.13085 19.1625C3.09347 19.1625 3.09347 19.1625 3.05609 19.1625C3.0187 19.1625 3.0187 19.1625 2.98132 19.1625C2.94394 19.1625 2.94394 19.2 2.94394 19.2L2.90656 19.2375C2.90656 19.275 2.90656 19.275 2.90656 19.3125V19.6875C2.90656 19.725 2.90656 19.725 2.90656 19.7625C2.90656 19.8 2.94394 19.8 2.98132 19.8375C3.0187 19.8375 3.05609 19.875 3.05609 19.875C3.09347 19.875 3.09347 19.875 3.13085 19.875C3.16824 19.875 3.16824 19.8375 3.16824 19.8375L3.20562 19.8C3.20562 19.7625 3.20562 19.7625 3.20562 19.725V19.35C3.20562 19.3125 3.20562 19.3125 3.20562 19.275C3.16824 19.2375 3.16824 19.2375 3.16824 19.2ZM3.13085 19.6875C3.13085 19.725 3.13085 19.725 3.09347 19.725C3.09347 19.725 3.09347 19.725 3.05609 19.725C3.05609 19.725 3.05609 19.725 3.0187 19.725H2.98132C2.98132 19.725 2.98132 19.725 2.94394 19.725C2.94394 19.725 2.94394 19.725 2.94394 19.6875C2.94394 19.6875 2.94394 19.6875 2.94394 19.65V19.275V19.2375C2.94394 19.2375 2.94394 19.2375 2.94394 19.2C2.94394 19.2 2.94394 19.2 2.98132 19.2C2.98132 19.2 2.98132 19.2 3.0187 19.2H3.05609C3.05609 19.2 3.05609 19.2 3.09347 19.2C3.09347 19.2 3.09347 19.2 3.09347 19.2375C3.09347 19.2375 3.09347 19.2375 3.09347 19.275L3.13085 19.6875Z"
          fill={color ?? 'url(#paint38_linear_486_666)'}
        />
        <path
          d="M5.8598 8.85L5.89718 8.8875C5.93457 8.8875 5.93457 8.8875 5.97195 8.8875C6.00933 8.8875 6.00933 8.8875 6.04672 8.8875C6.0841 8.8875 6.0841 8.85 6.0841 8.85C6.0841 8.85 6.0841 8.85 6.0841 8.8125C6.0841 8.7 6.0841 8.625 6.0841 8.55C6.0841 8.55 6.0841 8.4375 6.0841 8.25C6.0841 8.25 6.0841 8.25 6.0841 8.2125L6.04672 8.175C6.00933 8.175 5.97195 8.175 5.93457 8.175C5.89718 8.25 5.8598 8.25 5.8598 8.25L5.82242 8.2875C5.82242 8.325 5.82242 8.325 5.82242 8.3625V8.7375C5.82242 8.775 5.82242 8.775 5.82242 8.8125L5.8598 8.85ZM5.89718 8.3625C5.89718 8.325 5.89718 8.325 5.93457 8.325C5.93457 8.325 5.93457 8.325 5.97195 8.325C5.97195 8.325 5.97195 8.325 6.00933 8.325H6.04672L6.0841 8.3625C6.0841 8.3625 6.0841 8.3625 6.0841 8.4V8.775V8.8125C6.0841 8.8125 6.0841 8.8125 6.0841 8.85C6.0841 8.85 6.0841 8.85 6.04672 8.85C6.04672 8.85 6.04672 8.85 6.00933 8.85C5.97195 8.85 5.97195 8.85 5.97195 8.85C5.97195 8.85 5.97195 8.85 5.93457 8.85C5.93457 8.85 5.93457 8.85 5.93457 8.8125C5.93457 8.8125 5.93457 8.8125 5.93457 8.775L5.89718 8.3625Z"
          fill={color ?? 'url(#paint39_linear_486_666)'}
        />
        <path
          d="M3.16824 14.85L3.13085 14.8125C3.09347 14.8125 3.09347 14.8125 3.05609 14.8125C3.0187 14.8125 3.0187 14.8125 2.98132 14.8125C2.94394 14.8125 2.94394 14.85 2.94394 14.85L2.90656 14.8875C2.90656 14.925 2.90656 14.925 2.90656 14.9625V15.3375C2.90656 15.375 2.90656 15.375 2.90656 15.4125C2.90656 15.45 2.94394 15.45 2.94394 15.45L2.98132 15.4875C3.0187 15.4875 3.0187 15.4875 3.05609 15.4875C3.09347 15.4875 3.09347 15.4875 3.13085 15.4875L3.16824 15.45L3.20562 15.4125C3.20562 15.375 3.20562 15.375 3.20562 15.3375V14.9625C3.20562 14.925 3.20562 14.925 3.20562 14.8875C3.16824 14.85 3.16824 14.85 3.16824 14.85ZM3.13085 15.3C3.13085 15.3 3.13085 15.3375 3.13085 15.3C3.13085 15.3375 3.13085 15.3375 3.09347 15.3375C3.09347 15.3375 3.09347 15.3375 3.05609 15.3375C3.05609 15.3375 3.05609 15.3375 3.0187 15.3375H2.98132C2.98132 15.3375 2.98132 15.3375 2.94394 15.3375C2.94394 15.3375 2.94394 15.3375 2.94394 15.3C2.94394 15.3 2.94394 15.3 2.94394 15.2625V14.8875V14.85C2.94394 14.85 2.94394 14.85 2.94394 14.8125C2.94394 14.8125 2.94394 14.8125 2.98132 14.8125C2.98132 14.8125 2.98132 14.8125 3.0187 14.8125H3.05609C3.05609 14.8125 3.05609 14.8125 3.09347 14.8125C3.09347 14.8125 3.09347 14.8125 3.09347 14.85C3.09347 14.85 3.09347 14.85 3.09347 14.8875L3.13085 15.3Z"
          fill={color ?? 'url(#paint40_linear_486_666)'}
        />
        <path
          d="M2.30841 10.5V10.9875H2.23364V11.0625H2.42056V10.9875H2.38317V10.3875H2.30841L2.19626 10.425L2.23364 10.5H2.30841Z"
          fill={color ?? 'url(#paint41_linear_486_666)'}
        />
        <path
          d="M5.2243 14.8875V15.375H5.14954V15.45H5.33645V15.375H5.29907V14.775H5.2243L5.11215 14.85L5.14954 14.925L5.2243 14.8875Z"
          fill={color ?? 'url(#paint42_linear_486_666)'}
        />
        <path
          d="M10.3084 3.3375V3.4125H10.4953V3.3375H10.4579V2.7375H10.3832L10.271 2.775L10.3084 2.85L10.3832 2.8125V3.3H10.3084V3.3375Z"
          fill={color ?? 'url(#paint43_linear_486_666)'}
        />
        <path
          d="M6.68225 14.775L6.5701 14.8125L6.60748 14.8875L6.68225 14.85V15.375H6.60748V15.45H6.7944V15.375H6.75701V14.775H6.68225Z"
          fill={color ?? 'url(#paint44_linear_486_666)'}
        />
        <path
          d="M6.60748 13.2V13.275H6.7944V13.2H6.75701V12.6H6.68225L6.5701 12.6375L6.60748 12.7125L6.68225 12.675V13.1625H6.60748V13.2Z"
          fill={color ?? 'url(#paint45_linear_486_666)'}
        />
        <path
          d="M6.68225 16.9875L6.5701 17.025L6.60748 17.1L6.68225 17.0625V17.55H6.60748V17.625H6.7944V17.55H6.75701V16.95L6.68225 16.9875Z"
          fill={color ?? 'url(#paint46_linear_486_666)'}
        />
        <path
          d="M6.68225 19.1625L6.5701 19.2L6.60748 19.275L6.68225 19.2375V19.725H6.60748V19.8H6.7944V19.725H6.75701V19.125L6.68225 19.1625Z"
          fill={color ?? 'url(#paint47_linear_486_666)'}
        />
        <path
          d="M8.1402 19.1625L8.02805 19.2L8.06543 19.275L8.1402 19.2375V19.725H8.06543V19.8H8.25234V19.725H8.21496V19.125L8.1402 19.1625Z"
          fill={color ?? 'url(#paint48_linear_486_666)'}
        />
        <path
          d="M5.93457 7.725V7.8H6.12149V7.725H6.0841V7.125H6.00934L5.89719 7.1625L5.93457 7.2375L6.00934 7.2V7.6875H5.93457V7.725Z"
          fill={color ?? 'url(#paint49_linear_486_666)'}
        />
        <path
          d="M16.9252 19.1625L16.8131 19.2L16.8505 19.275L16.9252 19.2375V19.725H16.8505V19.8H17.0374V19.725H17V19.125L16.9252 19.1625Z"
          fill={color ?? 'url(#paint50_linear_486_666)'}
        />
        <path
          d="M8.1402 16.9875L8.02805 17.025L8.06543 17.1L8.1402 17.0625V17.55H8.06543V17.625H8.25234V17.55H8.21496V16.95L8.1402 16.9875Z"
          fill={color ?? 'url(#paint51_linear_486_666)'}
        />
        <path
          d="M8.81308 21.525C8.81308 21.4875 8.81308 21.4875 8.81308 21.525C8.81308 21.4875 8.85046 21.4875 8.81308 21.525C8.81308 21.45 8.81308 21.4125 8.81308 21.375C8.81308 21.375 8.77569 21.375 8.77569 21.4125L8.73831 21.45C8.73831 21.4875 8.73831 21.4875 8.73831 21.525V21.9C8.73831 21.9375 8.73831 21.9375 8.73831 21.975C8.73831 21.975 8.73831 22.0125 8.77569 22.0125L8.81308 22.05C8.81308 21.9375 8.85046 21.7875 8.85046 21.6375L8.81308 21.525Z"
          fill={color ?? 'url(#paint52_linear_486_666)'}
        />
        <path
          d="M8.06543 15.375V15.45H8.25234V15.375H8.21496V14.775H8.1402L8.02805 14.8125L8.06543 14.8875L8.1402 14.85V15.375H8.06543Z"
          fill={color ?? 'url(#paint53_linear_486_666)'}
        />
        <path
          d="M14.7944 4.95L14.6823 4.9875L14.7196 5.0625L14.7944 5.025V5.5125H14.7196V5.625H14.9066V5.55H14.8692V4.95H14.7944Z"
          fill={color ?? 'url(#paint54_linear_486_666)'}
        />
        <path
          d="M15.6916 5.43751V5.06251C15.6916 5.02501 15.6916 5.02501 15.6916 4.98751L15.6542 4.95001L15.6168 4.91251C15.5794 4.91251 15.5794 4.91251 15.5421 4.91251C15.5047 4.91251 15.5047 4.91251 15.4673 4.91251C15.4299 4.91251 15.4299 4.95001 15.4299 4.95001L15.3925 4.98751C15.3925 5.02501 15.3925 5.02501 15.3925 5.06251V5.43751C15.3925 5.47501 15.3925 5.47501 15.3925 5.51251C15.3925 5.55001 15.4299 5.55001 15.4299 5.55001L15.4673 5.58751C15.5047 5.58751 15.5047 5.58751 15.5421 5.58751C15.5794 5.58751 15.5794 5.58751 15.6168 5.58751C15.6542 5.58751 15.6916 5.55001 15.6916 5.51251C15.6916 5.51251 15.6916 5.47501 15.6916 5.43751ZM15.6168 5.43751C15.6168 5.47501 15.6168 5.47501 15.6168 5.43751C15.6168 5.47501 15.6168 5.47501 15.5794 5.47501C15.5794 5.47501 15.5794 5.47501 15.5421 5.47501C15.5421 5.47501 15.542 5.47501 15.5047 5.47501H15.4673C15.4673 5.47501 15.4673 5.47501 15.4299 5.47501C15.4299 5.47501 15.4299 5.47501 15.4299 5.43751V5.40001V5.02501V4.98751C15.4299 4.98751 15.4299 4.98751 15.4299 4.95001C15.4299 4.95001 15.4299 4.95001 15.4673 4.95001C15.4673 4.95001 15.4673 4.95001 15.5047 4.95001H15.5421C15.5421 4.95001 15.542 4.95001 15.5794 4.95001C15.5794 4.95001 15.5794 4.95001 15.5794 4.98751C15.5794 4.98751 15.5794 4.98751 15.5794 5.02501L15.6168 5.43751Z"
          fill={color ?? 'url(#paint55_linear_486_666)'}
        />
        <path
          d="M16.1776 5.5125V5.625H16.3645V5.55H16.3271V4.95H16.2523L16.1402 4.9875L16.1776 5.0625L16.2523 5.025V5.5125H16.1776Z"
          fill={color ?? 'url(#paint56_linear_486_666)'}
        />
        <path
          d="M8.85046 18.675V18.75H9.03738V18.675H9V18.075H8.92523L8.81308 18.1125L8.85046 18.1875L8.92523 18.15V18.6375L8.85046 18.675Z"
          fill={color ?? 'url(#paint57_linear_486_666)'}
        />
        <path
          d="M3.16824 8.24999L3.13085 8.21249C3.09347 8.21249 3.05609 8.21249 3.0187 8.21249C2.98132 8.24999 2.94394 8.24999 2.94394 8.24999L2.90656 8.28749C2.90656 8.32499 2.90656 8.32499 2.90656 8.36249V8.73749C2.90656 8.77499 2.90656 8.77499 2.90656 8.81249C2.90656 8.84999 2.94394 8.84999 2.94394 8.84999L2.98132 8.88749C3.0187 8.88749 3.0187 8.88749 3.05609 8.88749C3.09347 8.88749 3.09347 8.88749 3.13085 8.88749C3.16824 8.88749 3.16824 8.84999 3.16824 8.84999L3.20562 8.81249C3.20562 8.77499 3.20562 8.77499 3.20562 8.73749V8.36249C3.20562 8.32499 3.20562 8.32499 3.20562 8.28749C3.16824 8.28749 3.16824 8.28749 3.16824 8.24999ZM3.13085 8.73749C3.13085 8.73749 3.13085 8.77499 3.13085 8.73749C3.13085 8.77499 3.13085 8.77499 3.09347 8.77499C3.09347 8.77499 3.05609 8.77499 3.05609 8.81249H3.0187C3.0187 8.81249 3.0187 8.81249 2.98132 8.81249C2.98132 8.81249 2.98132 8.81249 2.98132 8.77499C2.98132 8.77499 2.98132 8.77499 2.98132 8.73749V8.36249V8.32499C2.98132 8.32499 2.98132 8.32499 2.98132 8.28749C2.98132 8.28749 2.98132 8.28749 3.0187 8.28749C3.0187 8.28749 3.0187 8.28749 3.05609 8.28749H3.09347C3.09347 8.28749 3.09347 8.28749 3.13085 8.28749C3.13085 8.28749 3.13085 8.28749 3.13085 8.32499C3.13085 8.32499 3.13085 8.32499 3.13085 8.36249V8.73749Z"
          fill={color ?? 'url(#paint58_linear_486_666)'}
        />
        <path
          d="M8.81308 20.325L8.85046 20.4L8.88785 20.3625C8.88785 20.325 8.88785 20.2875 8.88785 20.25L8.81308 20.325Z"
          fill={color ?? 'url(#paint59_linear_486_666)'}
        />
        <path
          d="M14.9066 6.225V6.1875V6.15C14.9066 6.1125 14.8692 6.1125 14.8692 6.1125L14.8318 6.075C14.8318 6.075 14.8318 6.075 14.7944 6.075H14.757C14.7944 6.075 14.8692 6.15 14.9066 6.225Z"
          fill={color ?? 'url(#paint60_linear_486_666)'}
        />
        <path
          d="M11.7664 3.3375V3.4125H11.9533V3.3375H11.9159V2.7375H11.8411L11.729 2.775L11.7664 2.85H11.8411V3.3375H11.7664Z"
          fill={color ?? 'url(#paint61_linear_486_666)'}
        />
        <path
          d="M13.2991 4.95L13.1869 4.9875L13.2243 5.0625L13.2991 5.025V5.5125H13.2243V5.625H13.4112V5.55H13.3738V4.95H13.2991Z"
          fill={color ?? 'url(#paint62_linear_486_666)'}
        />
        <path
          d="M16.9252 16.9875L16.8131 17.025L16.8505 17.1L16.9252 17.0625V17.55H16.8505V17.625H17.0374V17.55H17V16.95L16.9252 16.9875Z"
          fill={color ?? 'url(#paint63_linear_486_666)'}
        />
        <path
          d="M13.2617 3.3375V3.4125H13.4486V3.3375H13.4112V2.7375H13.3365L13.2243 2.775L13.2617 2.85L13.3365 2.8125V3.3H13.2617V3.3375Z"
          fill={color ?? 'url(#paint64_linear_486_666)'}
        />
        <path
          d="M8.92523 15.9L8.81308 15.9375L8.85046 16.0125L8.92523 15.975V16.4625H8.85046V16.5375H9.03738V16.4625H9V15.8625L8.92523 15.9Z"
          fill={color ?? 'url(#paint65_linear_486_666)'}
        />
        <path
          d="M19.8037 5.55001L19.8411 5.58751C19.8785 5.58751 19.8785 5.58751 19.9159 5.58751C19.9533 5.58751 19.9533 5.58751 19.9907 5.58751C19.9907 5.58751 20.028 5.58751 20.028 5.55001L20.0654 5.51251L19.9907 5.47501H19.9533C19.9533 5.47501 19.9159 5.47501 19.9159 5.43751C19.9159 5.43751 19.9159 5.43751 19.9159 5.40001V5.36251V5.32501L19.8411 5.28751V5.36251C19.8411 5.40001 19.8411 5.40001 19.8411 5.43751C19.7664 5.55001 19.8037 5.55001 19.8037 5.55001Z"
          fill={color ?? 'url(#paint66_linear_486_666)'}
        />
        <path
          d="M21.2991 17.1V17.5875H21.2243V17.6625H21.4112V17.5875H21.3738V16.9875H21.2991L21.1869 17.025L21.2243 17.1H21.2991Z"
          fill={color ?? 'url(#paint67_linear_486_666)'}
        />
        <path
          d="M19.8411 8.32499V8.81249H19.7664V8.88749H19.9533V8.81249H19.9159V8.21249H19.8411L19.7664 8.24999L19.8037 8.32499H19.8411Z"
          fill={color ?? 'url(#paint68_linear_486_666)'}
        />
        <path
          d="M19.8411 6.15001V6.63751H19.7664V6.71251H19.9533V6.63751H19.9159V6.03751H19.8411L19.729 6.07501L19.7664 6.15001H19.8411Z"
          fill={color ?? 'url(#paint69_linear_486_666)'}
        />
        <path
          d="M21.2991 14.8875V15.375H21.2243V15.45H21.4112V15.375H21.3738V14.775H21.2991L21.1869 14.8125L21.2243 14.8875H21.2991Z"
          fill={color ?? 'url(#paint70_linear_486_666)'}
        />
        <path
          d="M21.2991 8.2125L21.2243 8.25L21.2617 8.325L21.3365 8.2875V8.775H21.2617V8.85H21.4486V8.775H21.4112V8.175L21.2991 8.2125Z"
          fill={color ?? 'url(#paint71_linear_486_666)'}
        />
        <path
          d="M19.8411 10.5V10.9875H19.7664V11.0625H19.9533V10.9875H19.9159V10.3875H19.8411L19.729 10.425L19.7664 10.5H19.8411Z"
          fill={color ?? 'url(#paint72_linear_486_666)'}
        />
        <path
          d="M21.4486 6.6H21.4112V6.3L21.3365 6.2625V6.6H21.2617V6.675H21.4486V6.6Z"
          fill={color ?? 'url(#paint73_linear_486_666)'}
        />
        <path
          d="M21.2991 12.7125V13.2H21.2243V13.275H21.4112V13.2H21.3738V12.6H21.2991L21.1869 12.6375L21.2243 12.7125H21.2991Z"
          fill={color ?? 'url(#paint74_linear_486_666)'}
        />
        <path
          d="M16.9252 14.775L16.8131 14.8125L16.8505 14.8875L16.9252 14.85V15.375H16.8505V15.45H17.0374V15.375H17V14.775H16.9252Z"
          fill={color ?? 'url(#paint75_linear_486_666)'}
        />
        <path
          d="M21.2991 10.5V10.9875H21.2243V11.0625H21.4112V10.9875H21.3738V10.3875H21.2991L21.1869 10.425L21.2243 10.5H21.2991Z"
          fill={color ?? 'url(#paint76_linear_486_666)'}
        />
        <path
          d="M18.3832 12.7125V13.2H18.3084V13.275H18.4953V13.2H18.4579V12.6H18.3832L18.271 12.6375L18.3084 12.7125H18.3832Z"
          fill={color ?? 'url(#paint77_linear_486_666)'}
        />
        <path
          d="M18.3832 14.8875V15.375H18.3084V15.45H18.4953V15.375H18.4579V14.775H18.3832L18.271 14.8125L18.3084 14.8875H18.3832Z"
          fill={color ?? 'url(#paint78_linear_486_666)'}
        />
        <path
          d="M19.8411 12.7125V13.2H19.7664V13.275H19.9533V13.2H19.9159V12.6H19.8411L19.729 12.6375L19.7664 12.7125H19.8411Z"
          fill={color ?? 'url(#paint79_linear_486_666)'}
        />
        <path
          d="M18.3832 19.275V19.7625H18.3084V19.8375H18.4953V19.7625H18.4579V19.1625H18.3832L18.271 19.2L18.3084 19.275H18.3832Z"
          fill={color ?? 'url(#paint80_linear_486_666)'}
        />
        <path
          d="M18.3832 10.5V10.9875H18.3084V11.0625H18.4953V10.9875H18.4579V10.3875H18.3832L18.271 10.425L18.3084 10.5H18.3832Z"
          fill={color ?? 'url(#paint81_linear_486_666)'}
        />
        <path
          d="M18.3832 17.1V17.5875H18.3084V17.6625H18.4953V17.5875H18.4579V16.9875H18.3832L18.271 17.025L18.3084 17.1H18.3832Z"
          fill={color ?? 'url(#paint82_linear_486_666)'}
        />
        <path
          d="M19.8411 14.8875V15.375H19.7664V15.45H19.9533V15.375H19.9159V14.775H19.8411L19.729 14.8125L19.7664 14.8875H19.8411Z"
          fill={color ?? 'url(#paint83_linear_486_666)'}
        />
        <path
          d="M19.8411 17.1V17.5875H19.7664V17.6625H19.9533V17.5875H19.9159V16.9875H19.8411L19.729 17.025L19.7664 17.1H19.8411Z"
          fill={color ?? 'url(#paint84_linear_486_666)'}
        />
        <path
          d="M18.3832 6.0375L18.271 6.075L18.3084 6.15L18.3832 6.1125V6.6H18.3084V6.675H18.4953V6.6H18.4579V6L18.3832 6.0375Z"
          fill={color ?? 'url(#paint85_linear_486_666)'}
        />
        <path
          d="M18.3832 8.32499V8.81249H18.3084V8.88749H18.4953V8.81249H18.4579V8.21249H18.3832L18.271 8.24999L18.3084 8.32499H18.3832Z"
          fill={color ?? 'url(#paint86_linear_486_666)'}
        />
        <path
          d="M17.0374 13.2H17V13.05H16.9626C16.9252 13.0875 16.9252 13.1625 16.8878 13.2C16.8878 13.2375 16.8505 13.275 16.8505 13.275H17.0374V13.2Z"
          fill={color ?? 'url(#paint87_linear_486_666)'}
        />
        <path
          d="M11.6916 2.28749L11.729 2.32499C11.7664 2.32499 11.7664 2.32499 11.8037 2.32499C11.8411 2.32499 11.8411 2.32499 11.8785 2.32499L11.9159 2.28749L11.9533 2.24999C11.9533 2.21249 11.9533 2.21249 11.9533 2.17499V1.79999C11.9533 1.76249 11.9533 1.76249 11.9533 1.72499C11.9533 1.68749 11.9159 1.68749 11.9159 1.68749L11.8785 1.64999C11.8411 1.64999 11.8411 1.64999 11.8037 1.64999C11.7664 1.64999 11.7664 1.64999 11.729 1.64999C11.6916 1.64999 11.6916 1.68749 11.6916 1.68749L11.6542 1.72499C11.6542 1.76249 11.6542 1.76249 11.6542 1.79999V2.17499C11.6542 2.21249 11.6542 2.21249 11.6542 2.24999C11.6916 2.24999 11.6916 2.24999 11.6916 2.28749ZM11.7664 1.79999C11.7664 1.76249 11.7664 1.76249 11.8037 1.76249C11.8037 1.76249 11.8037 1.76249 11.8411 1.76249C11.8411 1.76249 11.8411 1.76249 11.8785 1.76249C11.8785 1.76249 11.8785 1.76249 11.9159 1.76249C11.9159 1.76249 11.9159 1.76249 11.9533 1.76249C11.9533 1.76249 11.9533 1.76249 11.9533 1.79999C11.9533 1.79999 11.9533 1.79999 11.9533 1.83749V2.21249V2.24999C11.9533 2.24999 11.9533 2.24999 11.9533 2.28749C11.9533 2.28749 11.9533 2.28749 11.9159 2.28749C11.9159 2.28749 11.9159 2.28749 11.8785 2.28749H11.8411C11.8411 2.28749 11.8411 2.28749 11.8037 2.28749C11.8037 2.28749 11.8037 2.28749 11.8037 2.24999C11.8037 2.24999 11.8037 2.24999 11.8037 2.21249L11.7664 1.79999Z"
          fill={color ?? 'url(#paint88_linear_486_666)'}
        />
        <path
          d="M11.6916 4.4625L11.729 4.5C11.7664 4.5 11.7664 4.5 11.8037 4.5C11.8411 4.5 11.8411 4.5 11.8785 4.5L11.9159 4.4625L11.9533 4.425C11.9533 4.3875 11.9533 4.3875 11.9533 4.35V3.975C11.9533 3.9375 11.9533 3.9375 11.9533 3.9C11.9533 3.8625 11.9159 3.8625 11.9159 3.8625L11.8785 3.825C11.8411 3.825 11.8411 3.825 11.8037 3.825C11.7664 3.825 11.7664 3.825 11.729 3.825C11.6916 3.825 11.6916 3.8625 11.6916 3.8625L11.6542 3.9C11.6542 3.9375 11.6542 3.9375 11.6542 3.975V4.35C11.6542 4.3875 11.6542 4.3875 11.6542 4.425C11.6916 4.425 11.6916 4.4625 11.6916 4.4625ZM11.7664 4.0125C11.7664 3.975 11.7664 3.975 11.7664 4.0125C11.7664 3.975 11.7664 3.975 11.8037 3.975C11.8037 3.975 11.8037 3.975 11.8411 3.975C11.8411 3.975 11.8411 3.975 11.8785 3.975C11.8785 3.975 11.8785 3.975 11.9159 3.975C11.9159 3.975 11.9159 3.975 11.9533 3.975C11.9533 3.975 11.9533 3.975 11.9533 4.0125C11.9533 4.0125 11.9533 4.0125 11.9533 4.05V4.425V4.4625C11.9533 4.4625 11.9533 4.4625 11.9533 4.5C11.9533 4.5 11.9533 4.5 11.9159 4.5C11.9159 4.5 11.9159 4.5 11.8785 4.5H11.8411C11.8411 4.5 11.8411 4.5 11.8037 4.5C11.8037 4.5 11.8037 4.5 11.8037 4.4625C11.8037 4.4625 11.8037 4.4625 11.8037 4.425L11.7664 4.0125Z"
          fill={color ?? 'url(#paint89_linear_486_666)'}
        />
        <path
          d="M11.0561 1.76249V2.24999H10.9813V2.32499H11.1682V2.24999H11.1309V1.64999H11.0935L10.9813 1.72499L11.0187 1.79999L11.0561 1.76249Z"
          fill={color ?? 'url(#paint90_linear_486_666)'}
        />
        <path
          d="M14.0093 3.9375V4.425H13.9346V4.5H14.1215V4.425H14.0841V3.825H14.0093L13.8972 3.8625L13.9346 3.9375H14.0093Z"
          fill={color ?? 'url(#paint91_linear_486_666)'}
        />
        <path
          d="M12.5514 3.9375V4.425H12.4766V4.5H12.6635V4.425H12.6262V3.825H12.5514L12.4392 3.8625L12.4766 3.9375H12.5514Z"
          fill={color ?? 'url(#paint92_linear_486_666)'}
        />
        <path
          d="M11.0561 3.9375V4.425H10.9813V4.5H11.1682V4.425H11.1309V3.825H11.0561L10.9439 3.8625L10.9813 3.9375H11.0561Z"
          fill={color ?? 'url(#paint93_linear_486_666)'}
        />
        <path
          d="M12.5514 1.76249V2.24999H12.4766V2.32499H12.6635V2.24999H12.6262V1.64999H12.5514L12.4392 1.68749L12.4766 1.76249H12.5514Z"
          fill={color ?? 'url(#paint94_linear_486_666)'}
        />
        <path
          d="M13.1869 2.28749L13.2243 2.32499C13.2617 2.32499 13.2617 2.32499 13.2991 2.32499C13.3365 2.32499 13.3365 2.32499 13.3738 2.32499L13.4112 2.28749L13.4486 2.24999C13.4486 2.21249 13.4486 2.21249 13.4486 2.17499V1.79999C13.4486 1.76249 13.4486 1.76249 13.4486 1.72499C13.4486 1.72499 13.4486 1.68749 13.4112 1.68749L13.3365 1.64999C13.2991 1.64999 13.2617 1.64999 13.2243 1.64999C13.1869 1.64999 13.1869 1.68749 13.1869 1.68749C13.1495 1.72499 13.1495 1.76249 13.1495 1.79999V2.17499C13.1495 2.21249 13.1495 2.21249 13.1495 2.24999C13.1495 2.24999 13.1495 2.24999 13.1869 2.28749ZM13.2243 1.79999C13.2243 1.76249 13.2243 1.76249 13.2617 1.76249C13.2617 1.76249 13.2617 1.76249 13.2991 1.76249C13.2991 1.76249 13.2991 1.76249 13.3365 1.76249H13.3738C13.3738 1.76249 13.3738 1.76249 13.4112 1.76249C13.4112 1.76249 13.4112 1.76249 13.4112 1.79999C13.4112 1.79999 13.4112 1.79999 13.4112 1.83749V2.21249V2.24999C13.4112 2.24999 13.4112 2.24999 13.4112 2.28749C13.4112 2.28749 13.4112 2.28749 13.3738 2.28749C13.3738 2.28749 13.3738 2.28749 13.3365 2.28749H13.2991C13.2991 2.28749 13.2991 2.28749 13.2617 2.28749C13.2617 2.28749 13.2617 2.28749 13.2617 2.24999V2.21249V1.79999H13.2243Z"
          fill={color ?? 'url(#paint95_linear_486_666)'}
        />
        <path
          d="M13.1869 4.4625L13.2243 4.5C13.2617 4.5 13.2617 4.5 13.2991 4.5C13.3365 4.5 13.3365 4.5 13.3738 4.5L13.4112 4.4625L13.4486 4.425C13.4486 4.3875 13.4486 4.3875 13.4486 4.35V3.975C13.4486 3.9375 13.4486 3.9375 13.4486 3.9L13.4112 3.8625L13.3738 3.825C13.3365 3.825 13.3365 3.825 13.2991 3.825C13.2617 3.825 13.2617 3.825 13.2243 3.825C13.1869 3.825 13.1869 3.8625 13.1869 3.8625L13.1495 3.9C13.1495 3.9375 13.1495 3.9375 13.1495 3.975V4.35C13.1495 4.3875 13.1495 4.3875 13.1495 4.425C13.1495 4.425 13.1495 4.4625 13.1869 4.4625ZM13.2243 4.0125C13.2243 3.975 13.2243 3.975 13.2243 4.0125C13.2243 3.975 13.2243 3.975 13.2617 3.975C13.2617 3.975 13.2617 3.975 13.2991 3.975C13.2991 3.975 13.2991 3.975 13.3365 3.975H13.3738C13.3738 3.975 13.3738 3.975 13.4112 3.975C13.4112 3.975 13.4112 3.975 13.4112 4.0125C13.4112 4.0125 13.4112 4.0125 13.4112 4.05V4.425V4.4625C13.4112 4.4625 13.4112 4.4625 13.4112 4.5C13.4112 4.5 13.4112 4.5 13.3738 4.5C13.3738 4.5 13.3738 4.5 13.3365 4.5H13.2991C13.2991 4.5 13.2991 4.5 13.2617 4.5C13.2617 4.5 13.2617 4.5 13.2617 4.4625V4.425V4.0125H13.2243Z"
          fill={color ?? 'url(#paint96_linear_486_666)'}
        />
        <path
          d="M12.5514 2.7375C12.514 2.7375 12.514 2.775 12.514 2.775L12.4766 2.8125C12.4766 2.85 12.4766 2.85 12.4766 2.8875V3.2625C12.4766 3.3 12.4766 3.3 12.4766 3.3375C12.4766 3.375 12.514 3.375 12.514 3.375L12.5514 3.4125C12.5888 3.4125 12.5888 3.4125 12.6262 3.4125C12.6635 3.4125 12.6635 3.4125 12.7009 3.4125C12.7383 3.4125 12.7383 3.375 12.7383 3.375L12.7757 3.3375C12.7757 3.3 12.7757 3.3 12.7757 3.2625V2.8875C12.7757 2.85 12.7757 2.85 12.7757 2.8125C12.7757 2.775 12.7383 2.775 12.7383 2.775L12.7009 2.7375C12.6635 2.7375 12.6635 2.7375 12.6262 2.7375C12.5888 2.7375 12.5514 2.7375 12.5514 2.7375ZM12.6635 2.85L12.7009 2.8875V3.2625V3.3C12.7009 3.3 12.7009 3.3 12.7009 3.3375C12.7009 3.3375 12.7009 3.3375 12.6635 3.3375C12.6635 3.3375 12.6635 3.3375 12.6262 3.3375C12.5888 3.3375 12.5888 3.3375 12.5888 3.3375C12.5888 3.3375 12.5888 3.3375 12.5514 3.3375C12.5514 3.3375 12.5514 3.3375 12.5514 3.3C12.5514 3.3 12.5514 3.3 12.5514 3.2625V2.8875V2.85C12.5514 2.85 12.5514 2.85 12.5514 2.8125C12.5514 2.8125 12.5514 2.8125 12.5888 2.8125C12.5888 2.8125 12.5888 2.8125 12.6262 2.8125C12.6262 2.8125 12.6262 2.8125 12.6635 2.85C12.6262 2.85 12.6635 2.85 12.6635 2.85Z"
          fill={color ?? 'url(#paint97_linear_486_666)'}
        />
        <path
          d="M11.0187 3.375L11.0561 3.4125C11.0934 3.4125 11.0934 3.4125 11.1308 3.4125C11.1682 3.4125 11.1682 3.4125 11.2056 3.4125L11.243 3.375L11.2804 3.3375C11.2804 3.3 11.2804 3.3 11.2804 3.2625V2.8875C11.2804 2.85 11.2804 2.85 11.2804 2.8125L11.243 2.775L11.2056 2.7375C11.1682 2.7375 11.1308 2.7375 11.1308 2.7375C11.0934 2.7375 11.0561 2.775 11.0561 2.775L11.0187 2.8125C11.0187 2.85 11.0187 2.85 11.0187 2.8875V3.2625C11.0187 3.3 11.0187 3.3 11.0187 3.3375V3.375ZM11.0561 2.8875C11.0561 2.85 11.0561 2.85 11.0934 2.85C11.0934 2.85 11.0934 2.85 11.1308 2.85C11.1308 2.85 11.1308 2.85 11.1682 2.85H11.2056C11.2056 2.85 11.2056 2.85 11.243 2.85C11.243 2.85 11.243 2.85 11.243 2.8875C11.243 2.8875 11.243 2.8875 11.243 2.925V3.3V3.3375L11.2056 3.375C11.2056 3.375 11.2056 3.375 11.1682 3.375C11.1308 3.375 11.1308 3.375 11.1308 3.375C11.1308 3.375 11.1308 3.375 11.0934 3.375C11.0934 3.375 11.0934 3.375 11.0934 3.3375V3.3L11.0561 2.8875Z"
          fill={color ?? 'url(#paint98_linear_486_666)'}
        />
        <path
          d="M8.1402 3.9375V4.425H8.06543V4.5H8.25234V4.425H8.21496V3.825H8.1402L8.02805 3.8625L8.06543 3.9375H8.1402Z"
          fill={color ?? 'url(#paint99_linear_486_666)'}
        />
        <path
          d="M8.21496 3.41251C8.25235 3.41251 8.25235 3.41251 8.28973 3.41251L8.32711 3.37501L8.3645 3.33751V3.30001V3.22501L8.28973 3.26251C8.28973 3.26251 8.28973 3.26251 8.28973 3.30001C8.28973 3.30001 8.28973 3.30001 8.25235 3.30001C8.25235 3.30001 8.25235 3.30001 8.21496 3.30001L8.10281 3.37501L8.1402 3.41251C8.17758 3.41251 8.17758 3.41251 8.21496 3.41251Z"
          fill={color ?? 'url(#paint100_linear_486_666)'}
        />
        <path
          d="M7.39252 5.5125V5.625H7.57943V5.55H7.54205V4.95H7.46728L7.35513 4.9875L7.39252 5.0625L7.46728 5.025V5.5125H7.39252Z"
          fill={color ?? 'url(#paint101_linear_486_666)'}
        />
        <path
          d="M8.1402 6.15001V6.33751C8.17758 6.33751 8.21496 6.33751 8.21496 6.33751V6.03751H8.1402L8.02805 6.07501L8.06543 6.15001H8.1402Z"
          fill={color ?? 'url(#paint102_linear_486_666)'}
        />
        <path
          d="M8.7757 4.4625L8.81308 4.5C8.85046 4.5 8.85046 4.5 8.88785 4.5C8.92523 4.5 8.92523 4.5 8.96261 4.5L9 4.4625L9.03738 4.425C9.03738 4.3875 9.03738 4.3875 9.03738 4.35V3.975C9.03738 3.9375 9.03738 3.9375 9.03738 3.9L9 3.8625C8.96261 3.825 8.96261 3.825 8.92523 3.825C8.88785 3.825 8.85046 3.825 8.85046 3.825C8.81308 3.825 8.81308 3.8625 8.81308 3.8625L8.7757 3.9C8.7757 3.9375 8.7757 3.9375 8.7757 3.975V4.35C8.7757 4.3875 8.7757 4.3875 8.7757 4.425V4.4625ZM8.81308 4.0125C8.81308 3.975 8.81308 3.975 8.81308 4.0125C8.81308 3.975 8.81308 3.975 8.85046 3.975C8.85046 3.975 8.85046 3.975 8.88785 3.975C8.88785 3.975 8.88785 3.975 8.92523 3.975H8.96261C8.96261 3.975 8.96261 3.975 9 3.975C9 3.975 9 3.975 9 4.0125C9 4.0125 9 4.0125 9 4.05V4.425V4.4625C9 4.4625 9 4.4625 9 4.5C9 4.5 8.99999 4.5 8.96261 4.5C8.96261 4.5 8.96261 4.5 8.92523 4.5C8.88785 4.5 8.88785 4.5 8.88785 4.5C8.88785 4.5 8.88785 4.5 8.85046 4.5C8.85046 4.5 8.85046 4.5 8.85046 4.4625C8.85046 4.4625 8.85046 4.4625 8.85046 4.425V4.0125H8.81308Z"
          fill={color ?? 'url(#paint103_linear_486_666)'}
        />
        <path
          d="M9.59814 3.9375V4.425H9.52338V4.5H9.71029V4.425H9.67291V3.825H9.59814L9.48599 3.8625L9.52338 3.9375H9.59814Z"
          fill={color ?? 'url(#paint104_linear_486_666)'}
        />
        <path
          d="M10.2336 4.4625L10.271 4.5C10.3084 4.5 10.3084 4.5 10.3458 4.5C10.3832 4.5 10.3832 4.5 10.4206 4.5C10.4579 4.5 10.4579 4.4625 10.4579 4.4625L10.4953 4.425C10.4953 4.3875 10.4953 4.3875 10.4953 4.35V3.975C10.4953 3.9375 10.4953 3.9375 10.4953 3.9C10.4953 3.8625 10.4579 3.8625 10.4579 3.8625L10.4206 3.825C10.3832 3.825 10.3832 3.825 10.3458 3.825C10.3084 3.825 10.3084 3.825 10.271 3.825C10.2336 3.825 10.2336 3.8625 10.2336 3.8625L10.1963 3.9C10.1963 3.9375 10.1963 3.9375 10.1963 3.975V4.35C10.1963 4.3875 10.1963 4.3875 10.1963 4.425C10.2336 4.425 10.2336 4.4625 10.2336 4.4625ZM10.271 4.0125C10.271 3.975 10.271 3.975 10.271 4.0125C10.271 3.975 10.271 3.975 10.3084 3.975C10.3084 3.975 10.3084 3.975 10.3458 3.975C10.3458 3.975 10.3458 3.975 10.3832 3.975H10.4206C10.4206 3.975 10.4206 3.975 10.4579 3.975C10.4579 3.975 10.4579 3.975 10.4579 4.0125C10.4579 4.0125 10.4579 4.0125 10.4579 4.05V4.425V4.4625C10.4579 4.4625 10.4579 4.4625 10.4579 4.5C10.4579 4.5 10.4579 4.5 10.4206 4.5C10.4206 4.5 10.4206 4.5 10.3832 4.5C10.3458 4.5 10.3458 4.5 10.3458 4.5C10.3458 4.5 10.3458 4.5 10.3084 4.5C10.3084 4.5 10.3084 4.5 10.3084 4.4625C10.3084 4.4625 10.3084 4.4625 10.3084 4.425L10.271 4.0125Z"
          fill={color ?? 'url(#paint105_linear_486_666)'}
        />
        <path
          d="M9.56076 3.375L9.59814 3.4125C9.63553 3.4125 9.63553 3.4125 9.67291 3.4125C9.71029 3.4125 9.71029 3.4125 9.74768 3.4125C9.78506 3.4125 9.78506 3.375 9.78506 3.375L9.82244 3.3375C9.82244 3.3 9.82244 3.3 9.82244 3.2625V2.8875C9.82244 2.85 9.82244 2.85 9.82244 2.8125C9.82244 2.775 9.78506 2.775 9.78506 2.775L9.74768 2.7375C9.71029 2.7375 9.71029 2.7375 9.67291 2.7375C9.63553 2.7375 9.63553 2.7375 9.59814 2.7375C9.56076 2.7375 9.56076 2.775 9.56076 2.775L9.52338 2.8125C9.52338 2.85 9.52338 2.85 9.52338 2.8875V3.2625C9.52338 3.3 9.52338 3.3 9.52338 3.3375C9.52338 3.3375 9.56076 3.375 9.56076 3.375ZM9.59814 2.8875C9.59814 2.85 9.59814 2.85 9.63553 2.85C9.63553 2.85 9.63553 2.85 9.67291 2.85C9.67291 2.85 9.67291 2.85 9.71029 2.85H9.74768C9.74768 2.85 9.74768 2.85 9.78506 2.85C9.78506 2.85 9.78506 2.85 9.78506 2.8875C9.78506 2.8875 9.78506 2.8875 9.78506 2.925V3.3V3.3375C9.78506 3.3375 9.78506 3.3375 9.78506 3.375C9.78506 3.375 9.78506 3.375 9.74768 3.375C9.74768 3.375 9.74768 3.375 9.71029 3.375H9.67291C9.67291 3.375 9.67291 3.375 9.63553 3.375C9.63553 3.375 9.63553 3.375 9.63553 3.3375C9.63553 3.3375 9.63553 3.3375 9.63553 3.3L9.59814 2.8875Z"
          fill={color ?? 'url(#paint106_linear_486_666)'}
        />
        <path
          d="M10.1963 2.2125C10.1963 2.25 10.2336 2.25 10.271 2.2875C10.3084 2.2875 10.3458 2.325 10.3458 2.325C10.3832 2.325 10.3832 2.325 10.4206 2.325C10.4579 2.325 10.4579 2.2875 10.4579 2.2875L10.4953 2.25C10.4953 2.2125 10.4953 2.2125 10.4953 2.175V1.9875L10.4206 2.025V2.1375C10.4206 2.175 10.4206 2.175 10.3832 2.175C10.3832 2.175 10.3832 2.175 10.3458 2.175C10.3458 2.175 10.3458 2.175 10.3084 2.175C10.3458 2.25 10.3458 2.25 10.3458 2.25C10.3458 2.25 10.3458 2.25 10.3084 2.25C10.3084 2.25 10.3084 2.25 10.3084 2.2125C10.3084 2.2125 10.3084 2.2125 10.3084 2.175V2.1375L10.2336 2.175L10.1963 2.2125Z"
          fill={color ?? 'url(#paint107_linear_486_666)'}
        />
        <path
          d="M9.07476 3.33751H9.03738V2.85001L8.96261 2.88751V3.30001H8.85046V3.37501H9.03738V3.33751H9.07476Z"
          fill={color ?? 'url(#paint108_linear_486_666)'}
        />
        <path
          d="M14.1215 2.25H14.0841V2.1L14.0093 2.0625V2.25H13.9346V2.325H14.1215V2.25Z"
          fill={color ?? 'url(#paint109_linear_486_666)'}
        />
        <path
          d="M16.9252 3.9375V4.425H16.8505V4.5H17.0374V4.425H17V3.825H16.9252L16.8131 3.8625L16.8505 3.9375H16.9252Z"
          fill={color ?? 'url(#paint110_linear_486_666)'}
        />
        <path
          d="M8.32711 4.9875L8.28973 4.95C8.25235 4.95 8.25235 4.95 8.21496 4.95C8.17758 4.95 8.17758 4.95 8.1402 4.95C8.10281 4.95 8.10281 4.9875 8.10281 4.9875L8.06543 5.025C8.06543 5.0625 8.06543 5.0625 8.06543 5.1V5.475C8.06543 5.5125 8.06543 5.55 8.10281 5.55C8.10281 5.5875 8.1402 5.5875 8.17758 5.625C8.21496 5.625 8.21496 5.625 8.25235 5.625C8.28973 5.625 8.28973 5.625 8.32711 5.625L8.3645 5.5875L8.40188 5.55C8.40188 5.5125 8.40188 5.5125 8.40188 5.475V5.1C8.40188 5.0625 8.40188 5.0625 8.40188 5.025C8.36449 5.025 8.32711 4.9875 8.32711 4.9875ZM8.28973 5.4375C8.28973 5.475 8.28973 5.475 8.28973 5.4375C8.28973 5.475 8.28973 5.475 8.25235 5.475C8.25235 5.475 8.25235 5.475 8.21496 5.475C8.21496 5.475 8.21496 5.475 8.17758 5.475H8.1402C8.1402 5.475 8.1402 5.475 8.10281 5.475C8.10281 5.475 8.10281 5.475 8.10281 5.4375C8.10281 5.4375 8.10281 5.4375 8.10281 5.4V5.025V4.9875C8.10281 4.9875 8.10281 4.9875 8.10281 4.95C8.10281 4.95 8.10281 4.95 8.1402 4.95C8.1402 4.95 8.1402 4.95 8.17758 4.95C8.17758 4.95 8.17758 4.95 8.21496 4.95C8.21496 4.95 8.21496 4.95 8.25235 4.95C8.25235 4.95 8.25235 4.95 8.25235 4.9875C8.25235 4.9875 8.25235 4.9875 8.25235 5.025L8.28973 5.4375Z"
          fill={color ?? 'url(#paint111_linear_486_666)'}
        />
        <path
          d="M8.06543 14.175V14.2125V14.25C8.06543 14.2875 8.10281 14.2875 8.10281 14.2875L8.1402 14.325H8.17758L8.1402 14.2875L8.06543 14.175Z"
          fill={color ?? 'url(#paint112_linear_486_666)'}
        />
        <path
          d="M13.972 3.375L14.0093 3.4125C14.0467 3.4125 14.0467 3.4125 14.0841 3.4125C14.1215 3.4125 14.1215 3.4125 14.1589 3.4125C14.1963 3.4125 14.1963 3.375 14.1963 3.375L14.2336 3.3375C14.2336 3.3 14.2336 3.3 14.2336 3.2625V2.8875C14.2336 2.85 14.2336 2.85 14.2336 2.8125C14.2336 2.775 14.1963 2.775 14.1963 2.775L14.1589 2.7375C14.1215 2.7375 14.1215 2.7375 14.0841 2.7375C14.0467 2.7375 14.0467 2.7375 14.0093 2.7375C13.972 2.7375 13.972 2.775 13.972 2.775L13.9346 2.8125C13.9346 2.85 13.9346 2.85 13.9346 2.8875V3.2625C13.9346 3.3 13.9346 3.3 13.9346 3.3375C13.9346 3.3375 13.9346 3.375 13.972 3.375ZM14.0093 2.8875C14.0093 2.85 14.0093 2.85 14.0467 2.85C14.0467 2.85 14.0467 2.85 14.0841 2.85C14.0841 2.85 14.0841 2.85 14.1215 2.85H14.1589C14.1589 2.85 14.1589 2.85 14.1963 2.85C14.1963 2.85 14.1963 2.85 14.1963 2.8875C14.1963 2.8875 14.1963 2.8875 14.1963 2.925V3.3V3.3375C14.1963 3.3375 14.1963 3.3375 14.1963 3.375C14.1963 3.375 14.1963 3.375 14.1589 3.375C14.1589 3.375 14.1589 3.375 14.1215 3.375H14.0841C14.0841 3.375 14.0841 3.375 14.0467 3.375C14.0467 3.375 14.0467 3.375 14.0467 3.3375C14.0467 3.3375 14.0467 3.3375 14.0467 3.3L14.0093 2.8875Z"
          fill={color ?? 'url(#paint113_linear_486_666)'}
        />
        <path
          d="M16.9252 4.95C16.8878 4.95 16.8878 4.9875 16.8878 4.9875L16.8505 5.025C16.8505 5.0625 16.8505 5.0625 16.8505 5.1V5.475C16.8505 5.5125 16.8505 5.55 16.8878 5.55C16.8878 5.5875 16.9252 5.5875 16.9626 5.625C17 5.625 17 5.625 17.0374 5.625C17.0748 5.625 17.0748 5.625 17.1121 5.625L17.1495 5.5875L17.1869 5.55C17.1869 5.5125 17.1869 5.5125 17.1869 5.475V5.1C17.1869 5.0625 17.1869 5.0625 17.1869 5.025C17.1869 4.9875 17.1495 4.9875 17.1495 4.9875L17.1121 4.95C17.0748 4.95 17.0748 4.95 17.0374 4.95C16.9626 4.95 16.9626 4.95 16.9252 4.95ZM17.0374 5.025C17.0748 5.0625 17.0748 5.0625 17.0748 5.0625V5.1V5.475V5.5125C17.0748 5.5125 17.0748 5.5125 17.0748 5.55C17.0748 5.55 17.0748 5.55 17.0374 5.55C17.0374 5.55 17.0374 5.55 17 5.55C16.9626 5.55 16.9626 5.55 16.9626 5.55C16.9626 5.55 16.9626 5.55 16.9252 5.55C16.9252 5.55 16.9252 5.55 16.9252 5.5125C16.9252 5.5125 16.9252 5.5125 16.9252 5.475V5.1V5.0625C16.9252 5.0625 16.9252 5.0625 16.9252 5.025C16.9252 5.025 16.9252 5.025 16.9626 5.025C16.9626 5.025 16.9626 5.025 17.0374 5.025C17 5.025 17 5.025 17.0374 5.025Z"
          fill={color ?? 'url(#paint114_linear_486_666)'}
        />
        <path
          d="M8.73831 15.375C8.73831 15.4125 8.77569 15.4125 8.77569 15.4125L8.81308 15.45C8.85046 15.45 8.85046 15.45 8.88784 15.45C8.92523 15.45 8.92523 15.45 8.96261 15.45C8.96261 15.45 8.96261 15.45 8.99999 15.45C8.99999 15.4125 8.96261 15.4125 8.96261 15.375C8.96261 15.375 8.96261 15.375 8.92523 15.375C8.88784 15.375 8.88784 15.375 8.88784 15.375C8.88784 15.375 8.88784 15.375 8.85046 15.375C8.85046 15.375 8.85046 15.375 8.85046 15.3375C8.85046 15.3375 8.85046 15.3375 8.85046 15.3V15.225L8.77569 15.1125V15.3C8.73831 15.3375 8.73831 15.3375 8.73831 15.375Z"
          fill={color ?? 'url(#paint115_linear_486_666)'}
        />
        <path
          d="M12.7009 4.9875L12.6635 4.95C12.6262 4.95 12.6262 4.95 12.5888 4.95C12.5514 4.95 12.5514 4.95 12.514 4.95C12.4766 4.95 12.4766 4.9875 12.4766 4.9875L12.4392 5.025V5.0625C12.4766 5.1 12.4766 5.1 12.514 5.1375V5.1V5.0625L12.5514 5.025C12.5514 5.025 12.5514 5.025 12.5888 5.025H12.6262C12.6262 5.025 12.6262 5.025 12.6635 5.025C12.6635 5.025 12.6635 5.025 12.6635 5.0625C12.6635 5.0625 12.6635 5.0625 12.6635 5.1V5.25C12.7009 5.2875 12.7383 5.325 12.7383 5.3625V5.1C12.7383 5.0625 12.7383 5.0625 12.7383 5.025C12.7383 5.025 12.7383 4.9875 12.7009 4.9875Z"
          fill={color ?? 'url(#paint116_linear_486_666)'}
        />
        <path
          d="M8.73831 19.6875C8.73831 19.725 8.73831 19.725 8.73831 19.7625C8.73831 19.8 8.77569 19.8 8.77569 19.8L8.81308 19.8375C8.85046 19.8375 8.85046 19.8375 8.88784 19.8375C8.92523 19.8375 8.92523 19.8375 8.96261 19.8375C8.96261 19.8 8.96261 19.7625 8.96261 19.725H8.92523C8.92523 19.725 8.92523 19.725 8.88784 19.725H8.85046C8.85046 19.725 8.85046 19.725 8.81308 19.725C8.81308 19.725 8.81308 19.725 8.81308 19.6875C8.81308 19.6875 8.81308 19.6875 8.81308 19.65V19.275V19.2375C8.81308 19.2375 8.81308 19.2375 8.81308 19.2C8.81308 19.2 8.81308 19.2 8.85046 19.2H8.88784C8.88784 19.2 8.88784 19.2 8.92523 19.2C8.92523 19.2 8.92523 19.2 8.92523 19.2375H8.96261C8.96261 19.2 8.96261 19.1625 8.96261 19.125L8.92523 19.0875C8.88784 19.0875 8.88784 19.0875 8.85046 19.0875C8.81308 19.0875 8.81308 19.0875 8.77569 19.0875C8.73831 19.0875 8.73831 19.125 8.73831 19.125L8.70093 19.1625C8.70093 19.2 8.70093 19.2 8.70093 19.2375L8.73831 19.6875Z"
          fill={color ?? 'url(#paint117_linear_486_666)'}
        />
        <path
          d="M17.1121 7.1625L17.0748 7.125C17.0374 7.125 17 7.125 16.9626 7.125C16.9626 7.1625 17 7.1625 17 7.2H17.0374C17.0374 7.2 17.0374 7.2 17.0748 7.2C17.0748 7.2 17.0748 7.2 17.0748 7.2375C17.0748 7.2375 17.0748 7.2375 17.0748 7.275V7.35C17.1121 7.3875 17.1121 7.425 17.1495 7.4625H17.1869V7.275C17.1869 7.2375 17.1869 7.2375 17.1869 7.2C17.1495 7.2 17.1121 7.2 17.1121 7.1625Z"
          fill={color ?? 'url(#paint118_linear_486_666)'}
        />
        <path
          d="M14.1963 4.9875L14.1589 4.95C14.1215 4.95 14.1215 4.95 14.0841 4.95C14.0467 4.95 14.0467 4.95 14.0093 4.95C13.972 4.95 13.972 4.9875 13.972 4.9875L13.9346 5.025C13.9346 5.0625 13.9346 5.0625 13.9346 5.1V5.475C13.9346 5.5125 13.9346 5.55 13.972 5.55C13.972 5.5875 14.0093 5.5875 14.0467 5.625C14.0841 5.625 14.0841 5.625 14.1215 5.625C14.1589 5.625 14.1589 5.625 14.1963 5.625C14.2336 5.625 14.2336 5.5875 14.2336 5.5875L14.271 5.55C14.271 5.5125 14.271 5.5125 14.271 5.475V5.1C14.271 5.0625 14.271 5.0625 14.271 5.025C14.1963 5.025 14.1963 4.9875 14.1963 4.9875ZM14.1215 5.4375C14.1215 5.475 14.1215 5.475 14.1215 5.4375C14.1215 5.475 14.1215 5.475 14.0841 5.475C14.0841 5.475 14.0841 5.475 14.0467 5.475C14.0467 5.475 14.0467 5.475 14.0093 5.475C13.972 5.475 13.972 5.475 13.972 5.475C13.972 5.475 13.972 5.475 13.9346 5.475C13.9346 5.475 13.9346 5.475 13.9346 5.4375C13.9346 5.4375 13.9346 5.4375 13.9346 5.4V5.025V4.9875C13.9346 4.9875 13.9346 4.9875 13.9346 4.95C13.9346 4.95 13.9346 4.95 13.972 4.95C13.972 4.95 13.972 4.95 14.0093 4.95C14.0467 4.95 14.0467 4.95 14.0467 4.95C14.0467 4.95 14.0467 4.95 14.0841 4.95C14.0841 4.95 14.0841 4.95 14.0841 4.9875C14.0841 4.9875 14.0841 4.9875 14.0841 5.025L14.1215 5.4375Z"
          fill={color ?? 'url(#paint119_linear_486_666)'}
        />
        <path
          d="M7.31775 4.4625C7.35513 4.5 7.35513 4.5 7.35513 4.5C7.39251 4.5 7.39252 4.5 7.4299 4.5C7.46728 4.5 7.46728 4.5 7.50466 4.5C7.54205 4.5 7.54205 4.4625 7.54205 4.4625L7.57943 4.425C7.57943 4.3875 7.57943 4.3875 7.57943 4.35V3.975C7.57943 3.9375 7.57943 3.9375 7.57943 3.9C7.57943 3.8625 7.54205 3.8625 7.54205 3.8625L7.50466 3.825C7.46728 3.825 7.46728 3.825 7.4299 3.825C7.39252 3.825 7.39251 3.825 7.35513 3.825C7.31775 3.825 7.31775 3.8625 7.31775 3.8625L7.28036 3.9C7.28036 3.9375 7.28036 3.9375 7.28036 3.975V4.35C7.28036 4.3875 7.28036 4.3875 7.28036 4.425C7.28036 4.425 7.31775 4.4625 7.31775 4.4625ZM7.35513 4.0125C7.35513 3.975 7.35513 3.975 7.35513 4.0125C7.35513 3.975 7.35513 3.975 7.39251 3.975C7.39251 3.975 7.39252 3.975 7.4299 3.975C7.4299 3.975 7.4299 3.975 7.46728 3.975C7.46728 3.975 7.46728 3.975 7.50466 3.975C7.50466 3.975 7.50466 3.975 7.54205 3.975L7.57943 4.0125V4.3875V4.425C7.57943 4.425 7.57943 4.425 7.57943 4.4625C7.57943 4.4625 7.57943 4.4625 7.54205 4.4625C7.54205 4.4625 7.54205 4.4625 7.50466 4.4625H7.46728C7.46728 4.4625 7.46728 4.4625 7.4299 4.4625C7.4299 4.4625 7.4299 4.4625 7.4299 4.425C7.4299 4.425 7.4299 4.425 7.4299 4.3875L7.35513 4.0125Z"
          fill={color ?? 'url(#paint120_linear_486_666)'}
        />
        <path
          d="M15.4673 3.9375V4.425H15.3925V4.5H15.5794V4.425H15.542V3.825H15.4673L15.3551 3.8625L15.3925 3.9375H15.4673Z"
          fill={color ?? 'url(#paint121_linear_486_666)'}
        />
        <path
          d="M16.9252 6.15001V6.63751H16.8505V6.71251H17.0374V6.63751H17V6.03751H16.9252L16.8131 6.07501L16.8505 6.15001H16.9252Z"
          fill={color ?? 'url(#paint122_linear_486_666)'}
        />
        <path
          d="M15.4673 6.15001V6.56251C15.5047 6.56251 15.542 6.56251 15.542 6.52501V6.03751H15.4673L15.3551 6.07501L15.3925 6.15001H15.4673Z"
          fill={color ?? 'url(#paint123_linear_486_666)'}
        />
        <path
          d="M8.73831 17.0625C8.73831 17.1 8.73831 17.1 8.73831 17.1375V17.5125C8.73831 17.55 8.73831 17.55 8.73831 17.5875C8.73831 17.625 8.77569 17.625 8.77569 17.625L8.81308 17.6625C8.85046 17.6625 8.85046 17.6625 8.88784 17.6625C8.92523 17.6625 8.92523 17.6625 8.96261 17.6625L8.99999 17.625L9.03738 17.5875C9.03738 17.55 9.03738 17.55 9.03738 17.5125V17.1375C9.03738 17.1 9.03738 17.1 9.03738 17.0625L8.99999 17.025L8.96261 16.9875C8.92523 16.9875 8.92523 16.9875 8.88784 16.9875C8.85046 16.9875 8.85046 16.9875 8.81308 16.9875C8.77569 16.9875 8.77569 17.025 8.77569 17.025C8.77569 17.025 8.77569 17.0625 8.73831 17.0625ZM8.81308 17.1375C8.81308 17.1375 8.81308 17.1 8.81308 17.1375C8.81308 17.1 8.81308 17.1 8.85046 17.1C8.85046 17.1 8.85046 17.1 8.88784 17.1C8.88784 17.1 8.88784 17.1 8.92523 17.1H8.96261C8.96261 17.1 8.96261 17.1 8.99999 17.1C8.99999 17.1 8.99999 17.1 8.99999 17.1375C8.99999 17.1375 8.99999 17.1375 8.99999 17.175V17.55V17.5875C8.99999 17.5875 8.99999 17.5875 8.99999 17.625C8.99999 17.625 8.99999 17.625 8.96261 17.625C8.96261 17.625 8.96261 17.625 8.92523 17.625H8.88784C8.88784 17.625 8.88784 17.625 8.85046 17.625C8.85046 17.625 8.85046 17.625 8.85046 17.5875C8.85046 17.5875 8.85046 17.5875 8.85046 17.55V17.1375H8.81308Z"
          fill={color ?? 'url(#paint124_linear_486_666)'}
        />
        <path
          d="M14.6449 4.4625L14.6822 4.5C14.7196 4.5 14.7196 4.5 14.757 4.5C14.7944 4.5 14.7944 4.5 14.8318 4.5C14.8692 4.5 14.8692 4.4625 14.8692 4.4625L14.9065 4.425C14.9065 4.3875 14.9065 4.3875 14.9065 4.35V3.975C14.9065 3.9375 14.9065 3.9375 14.9065 3.9C14.9065 3.8625 14.8692 3.8625 14.8692 3.8625L14.8318 3.825C14.7944 3.825 14.7944 3.825 14.757 3.825C14.7196 3.825 14.7196 3.825 14.6822 3.825C14.6449 3.825 14.6449 3.8625 14.6449 3.8625L14.6075 3.9C14.6075 3.9375 14.6075 3.9375 14.6075 3.975V4.35C14.6075 4.3875 14.6075 4.3875 14.6075 4.425C14.6075 4.425 14.6075 4.4625 14.6449 4.4625ZM14.6822 4.0125C14.6822 3.975 14.6822 3.975 14.6822 4.0125C14.6822 3.975 14.6822 3.975 14.7196 3.975C14.7196 3.975 14.7196 3.975 14.757 3.975C14.757 3.975 14.757 3.975 14.7944 3.975H14.8318C14.8318 3.975 14.8318 3.975 14.8692 3.975C14.8692 3.975 14.8692 3.975 14.8692 4.0125C14.8692 4.0125 14.8692 4.0125 14.8692 4.05V4.425V4.4625C14.8692 4.4625 14.8692 4.4625 14.8692 4.5C14.8692 4.5 14.8692 4.5 14.8318 4.5C14.8318 4.5 14.8318 4.5 14.7944 4.5H14.757C14.757 4.5 14.757 4.5 14.7196 4.5C14.7196 4.5 14.7196 4.5 14.7196 4.4625C14.7196 4.4625 14.7196 4.4625 14.7196 4.425L14.6822 4.0125Z"
          fill={color ?? 'url(#paint125_linear_486_666)'}
        />
        <path
          d="M14.7944 2.85V3.3375H14.7196V3.4125H14.9066V3.3375H14.8692V2.7375H14.7944L14.6823 2.775L14.7196 2.85H14.7944Z"
          fill={color ?? 'url(#paint126_linear_486_666)'}
        />
        <path
          d="M16.1028 4.4625L16.1402 4.5C16.1776 4.5 16.1776 4.5 16.215 4.5C16.2523 4.5 16.2523 4.5 16.2897 4.5C16.3271 4.5 16.3271 4.4625 16.3271 4.4625L16.3645 4.425C16.3645 4.3875 16.3645 4.3875 16.3645 4.35V3.975C16.3645 3.9375 16.3645 3.9375 16.3645 3.9C16.3645 3.8625 16.3271 3.8625 16.3271 3.8625L16.2897 3.825C16.2523 3.825 16.2523 3.825 16.215 3.825C16.1776 3.825 16.1776 3.825 16.1402 3.825C16.1028 3.825 16.1028 3.8625 16.1028 3.8625L16.0654 3.9C16.0654 3.9375 16.0654 3.9375 16.0654 3.975V4.35C16.0654 4.3875 16.0654 4.3875 16.0654 4.425C16.0654 4.425 16.0654 4.4625 16.1028 4.4625ZM16.1402 4.0125C16.1402 3.975 16.1402 3.975 16.1402 4.0125C16.1402 3.975 16.1402 3.975 16.1776 3.975C16.1776 3.975 16.1776 3.975 16.215 3.975C16.215 3.975 16.215 3.975 16.2523 3.975H16.2897C16.2897 3.975 16.2897 3.975 16.3271 3.975L16.3645 4.0125V4.3875V4.425C16.3645 4.425 16.3645 4.425 16.3645 4.4625C16.3645 4.4625 16.3645 4.4625 16.3271 4.4625C16.3271 4.4625 16.3271 4.4625 16.2897 4.4625H16.2523C16.2523 4.4625 16.2523 4.4625 16.215 4.4625C16.215 4.4625 16.215 4.4625 16.215 4.425C16.215 4.425 16.215 4.425 16.215 4.3875L16.1402 4.0125Z"
          fill={color ?? 'url(#paint127_linear_486_666)'}
        />
        <path
          d="M16.215 3.33749H16.1776V3.41249H16.3645L16.215 3.33749Z"
          fill={color ?? 'url(#paint128_linear_486_666)'}
        />
        <path
          d="M15.4299 3.375L15.4673 3.4125C15.5047 3.4125 15.5047 3.4125 15.5421 3.4125C15.5794 3.4125 15.5794 3.4125 15.6168 3.4125L15.6542 3.375L15.6916 3.3375C15.6916 3.3 15.6916 3.3 15.6916 3.2625V3.0375L15.6168 3V3.3V3.3375L15.5794 3.375C15.5794 3.375 15.5794 3.375 15.5421 3.375C15.5047 3.375 15.5047 3.375 15.5047 3.375C15.5047 3.375 15.5047 3.375 15.4673 3.375C15.4673 3.375 15.4673 3.375 15.4673 3.3375V3.3V2.925L15.3925 2.8875V2.925V3.3C15.3925 3.3375 15.3925 3.3375 15.3925 3.375C15.3925 3.3375 15.3925 3.375 15.4299 3.375Z"
          fill={color ?? 'url(#paint129_linear_486_666)'}
        />
        <path
          d="M16.1402 6.48751V6.18751V6.15001L16.1776 6.11251H16.215H16.2523C16.2523 6.11251 16.2523 6.11251 16.2897 6.11251C16.2897 6.11251 16.2897 6.11251 16.2897 6.15001C16.2897 6.15001 16.2897 6.15001 16.2897 6.18751V6.56251C16.3271 6.56251 16.3271 6.60001 16.3645 6.60001C16.3645 6.60001 16.3645 6.60001 16.3645 6.56251V6.18751C16.3645 6.15001 16.3645 6.15001 16.3645 6.11251C16.3645 6.07501 16.3271 6.07501 16.3271 6.07501L16.2897 6.03751C16.2523 6.03751 16.2523 6.03751 16.215 6.03751C16.1776 6.03751 16.1776 6.03751 16.1402 6.03751C16.1028 6.03751 16.1028 6.07501 16.1028 6.07501L16.0654 6.11251C16.0654 6.15001 16.0654 6.15001 16.0654 6.18751V6.48751C16.0654 6.48751 16.1028 6.48751 16.1402 6.48751Z"
          fill={color ?? 'url(#paint130_linear_486_666)'}
        />
        <path
          d="M22.1589 12.6375C22.1215 12.6 22.1215 12.6 22.0841 12.6C22.0467 12.6 22.0093 12.6 22.0093 12.6C21.972 12.6 21.972 12.6375 21.972 12.6375C21.9346 12.675 21.9346 12.7125 21.9346 12.75V13.125C21.9346 13.1625 21.9346 13.1625 21.9346 13.2C21.9346 13.2375 21.972 13.2375 21.972 13.2375L22.0093 13.275C22.0467 13.275 22.0467 13.275 22.0841 13.275C22.1215 13.275 22.1215 13.275 22.1589 13.275L22.1963 13.2375L22.2336 13.2C22.2336 13.1625 22.2336 13.1625 22.2336 13.125V12.75C22.2336 12.7125 22.2336 12.7125 22.2336 12.675C22.1963 12.675 22.1963 12.675 22.1589 12.6375ZM22.1215 13.125C22.1215 13.1625 22.1215 13.1625 22.0841 13.1625C22.0841 13.1625 22.0841 13.1625 22.0467 13.1625C22.0467 13.1625 22.0467 13.1625 22.0093 13.1625H21.972C21.972 13.1625 21.972 13.1625 21.9346 13.1625C21.9346 13.1625 21.9346 13.1625 21.9346 13.125V13.0875V12.7125V12.675C21.9346 12.675 21.9346 12.675 21.9346 12.6375C21.9346 12.6375 21.9346 12.6375 21.972 12.6375C21.972 12.6375 21.972 12.6375 22.0093 12.6375H22.0467C22.0467 12.6375 22.0467 12.6375 22.0841 12.6375C22.0841 12.6375 22.0841 12.6375 22.0841 12.675C22.0841 12.675 22.0841 12.675 22.0841 12.7125L22.1215 13.125Z"
          fill={color ?? 'url(#paint131_linear_486_666)'}
        />
        <path
          d="M19.243 19.2L19.2056 19.1625C19.1682 19.1625 19.1682 19.1625 19.1309 19.1625C19.0935 19.1625 19.0935 19.1625 19.0561 19.1625C19.0187 19.1625 19.0187 19.2 19.0187 19.2L18.9813 19.2375C18.9813 19.275 18.9813 19.275 18.9813 19.3125V19.6875C18.9813 19.725 18.9813 19.7625 19.0187 19.7625C19.0187 19.8 19.0561 19.8 19.0935 19.8375C19.1309 19.8375 19.1309 19.8375 19.1682 19.8375C19.2056 19.8375 19.2056 19.8375 19.243 19.8375C19.2804 19.8375 19.2804 19.8 19.2804 19.8L19.3178 19.7625C19.3178 19.725 19.3178 19.725 19.3178 19.6875V19.3125C19.3178 19.275 19.3178 19.275 19.3178 19.2375C19.2804 19.2375 19.2804 19.2375 19.243 19.2ZM19.2056 19.6875C19.2056 19.725 19.2056 19.725 19.1682 19.725C19.1682 19.725 19.1682 19.725 19.1309 19.725C19.1309 19.725 19.1309 19.725 19.0935 19.725H19.0561C19.0561 19.725 19.0561 19.725 19.0187 19.725C19.0187 19.725 19.0187 19.725 19.0187 19.6875C19.0187 19.6875 19.0187 19.6875 19.0187 19.65V19.275V19.2375C19.0187 19.2375 19.0187 19.2375 19.0187 19.2C19.0187 19.2 19.0187 19.2 19.0561 19.2C19.0561 19.2 19.0561 19.2 19.0935 19.2H19.1309C19.1309 19.2 19.1309 19.2 19.1682 19.2C19.1682 19.2 19.1682 19.2 19.1682 19.2375C19.1682 19.2375 19.1682 19.2375 19.1682 19.275L19.2056 19.6875Z"
          fill={color ?? 'url(#paint132_linear_486_666)'}
        />
        <path
          d="M19.243 20.25H19.1682L19.0561 20.2875L19.0934 20.3625L19.1682 20.325V20.8125H19.0934V20.8875H19.2804V20.8125H19.243V20.25Z"
          fill={color ?? 'url(#paint133_linear_486_666)'}
        />
        <path
          d="M19.243 17.025L19.2056 16.9875C19.1682 16.9875 19.1682 16.9875 19.1309 16.9875C19.0935 16.9875 19.0935 16.9875 19.0561 16.9875C19.0187 16.9875 19.0187 17.025 19.0187 17.025L18.9813 17.0625C18.9813 17.1 18.9813 17.1 18.9813 17.1375V17.5125C18.9813 17.55 18.9813 17.55 18.9813 17.5875C18.9813 17.625 19.0187 17.625 19.0187 17.625L19.0561 17.6625C19.0935 17.6625 19.0935 17.6625 19.1309 17.6625C19.1682 17.6625 19.1682 17.6625 19.2056 17.6625C19.243 17.6625 19.243 17.625 19.243 17.625L19.2804 17.5875C19.2804 17.55 19.2804 17.55 19.2804 17.5125V17.1375C19.2804 17.1 19.2804 17.1 19.2804 17.0625C19.2804 17.0625 19.2804 17.025 19.243 17.025ZM19.2056 17.5125C19.2056 17.55 19.2056 17.55 19.1682 17.55C19.1682 17.55 19.1682 17.55 19.1309 17.55C19.1309 17.55 19.1309 17.55 19.0935 17.55H19.0561C19.0561 17.55 19.0561 17.55 19.0187 17.55C19.0187 17.55 19.0187 17.55 19.0187 17.5125C19.0187 17.5125 19.0187 17.5125 19.0187 17.475V17.1V17.0625C19.0187 17.0625 19.0187 17.0625 19.0187 17.025C19.0187 17.025 19.0187 17.025 19.0561 17.025C19.0561 17.025 19.0561 17.025 19.0935 17.025H19.1309C19.1309 17.025 19.1309 17.025 19.1682 17.025C19.1682 17.025 19.1682 17.025 19.1682 17.0625C19.1682 17.0625 19.1682 17.0625 19.1682 17.1L19.2056 17.5125Z"
          fill={color ?? 'url(#paint134_linear_486_666)'}
        />
        <path
          d="M18.5701 13.725L18.5327 13.6875C18.4953 13.6875 18.4579 13.6875 18.4206 13.6875C18.3832 13.6875 18.3832 13.725 18.3832 13.725L18.3458 13.7625C18.3458 13.8 18.3458 13.8 18.3458 13.8375V14.2125C18.3458 14.25 18.3458 14.25 18.3458 14.2875C18.3458 14.325 18.3832 14.325 18.3832 14.325L18.4206 14.3625C18.4579 14.3625 18.4579 14.3625 18.4953 14.3625C18.5327 14.3625 18.5327 14.3625 18.5701 14.3625C18.6075 14.3625 18.6075 14.325 18.6075 14.325L18.6449 14.2875C18.6449 14.25 18.6449 14.25 18.6449 14.2125V13.8375C18.6449 13.8 18.6449 13.8 18.6449 13.7625C18.6075 13.7625 18.5701 13.7625 18.5701 13.725ZM18.5327 14.2125C18.5327 14.2125 18.5327 14.25 18.5327 14.2125C18.5327 14.25 18.5327 14.25 18.4953 14.25C18.4953 14.25 18.4579 14.25 18.4579 14.2875H18.4206C18.4206 14.2875 18.4206 14.2875 18.3832 14.2875C18.3832 14.2875 18.3832 14.2875 18.3832 14.25C18.3832 14.25 18.3832 14.25 18.3832 14.2125V13.8375V13.8C18.3832 13.8 18.3832 13.8 18.3832 13.7625C18.3832 13.7625 18.3832 13.7625 18.4206 13.7625H18.4579H18.4953C18.4953 13.7625 18.4953 13.7625 18.5327 13.7625C18.5327 13.7625 18.5327 13.7625 18.5327 13.8C18.5327 13.8 18.5327 13.8 18.5327 13.8375V14.2125Z"
          fill={color ?? 'url(#paint135_linear_486_666)'}
        />
        <path
          d="M19.243 5.1L19.1682 5.0625V5.55H19.0934V5.625H19.2804V5.55H19.243V5.1Z"
          fill={color ?? 'url(#paint136_linear_486_666)'}
        />
        <path
          d="M18.5701 11.55L18.5327 11.5125C18.4953 11.5125 18.4579 11.5125 18.4206 11.5125C18.3832 11.5125 18.3832 11.55 18.3832 11.55L18.3458 11.5875C18.3458 11.625 18.3458 11.625 18.3458 11.6625V12.0375C18.3458 12.075 18.3458 12.075 18.3458 12.1125C18.3458 12.15 18.3832 12.15 18.3832 12.15L18.4206 12.1875C18.4579 12.1875 18.4579 12.1875 18.4953 12.1875C18.5327 12.1875 18.5327 12.1875 18.5701 12.1875C18.6075 12.1875 18.6075 12.15 18.6075 12.15L18.6449 12.1125C18.6449 12.075 18.6449 12.075 18.6449 12.0375V11.6625C18.6449 11.625 18.6449 11.625 18.6449 11.5875C18.6075 11.5875 18.5701 11.55 18.5701 11.55ZM18.5327 12.0375C18.5327 12.075 18.5327 12.075 18.4953 12.075C18.4953 12.075 18.4953 12.075 18.4579 12.075C18.4579 12.075 18.4579 12.075 18.4206 12.075C18.3832 12.075 18.3832 12.075 18.3832 12.075C18.3832 12.075 18.3832 12.075 18.3458 12.075C18.3458 12.075 18.3458 12.075 18.3458 12.0375C18.3458 12.0375 18.3458 12.0375 18.3458 12V11.625V11.5875C18.3458 11.5875 18.3458 11.5875 18.3458 11.55C18.3458 11.55 18.3458 11.55 18.3832 11.55C18.3832 11.55 18.3832 11.55 18.4206 11.55H18.4579C18.4579 11.55 18.4579 11.55 18.4953 11.55C18.4953 11.55 18.4953 11.55 18.4953 11.5875C18.4953 11.5875 18.4953 11.5875 18.4953 11.625L18.5327 12.0375Z"
          fill={color ?? 'url(#paint137_linear_486_666)'}
        />
        <path
          d="M19.243 15.9H19.1682L19.0561 15.9375L19.0934 16.0125L19.1682 15.975V16.4625H19.0934V16.5375H19.2804V16.4625H19.243V15.9Z"
          fill={color ?? 'url(#paint138_linear_486_666)'}
        />
        <path
          d="M18.5701 9.37499L18.5327 9.33749C18.4953 9.33749 18.4579 9.33749 18.4579 9.33749C18.4206 9.33749 18.3832 9.37499 18.3832 9.37499L18.3458 9.41249C18.3458 9.44999 18.3458 9.44999 18.3458 9.48749V9.86249C18.3458 9.89999 18.3458 9.89999 18.3458 9.93749C18.3458 9.97499 18.3832 9.97499 18.3832 9.97499L18.4206 10.0125C18.4579 10.0125 18.4579 10.0125 18.4953 10.0125C18.5327 10.0125 18.5327 10.0125 18.5701 10.0125C18.6075 10.0125 18.6075 9.97499 18.6075 9.97499L18.6449 9.93749C18.6449 9.89999 18.6449 9.89999 18.6449 9.86249V9.48749C18.6449 9.44999 18.6449 9.44999 18.6449 9.41249C18.6075 9.37499 18.5701 9.37499 18.5701 9.37499ZM18.5327 9.82499C18.5327 9.82499 18.5327 9.86249 18.5327 9.82499C18.5327 9.86249 18.5327 9.86249 18.4953 9.86249C18.4953 9.86249 18.4953 9.86249 18.4579 9.86249C18.4579 9.86249 18.4579 9.86249 18.4206 9.86249H18.3832C18.3832 9.86249 18.3832 9.86249 18.3458 9.86249C18.3458 9.86249 18.3458 9.86249 18.3458 9.82499C18.3458 9.82499 18.3458 9.82499 18.3458 9.78749V9.41249V9.37499C18.3458 9.37499 18.3458 9.37499 18.3458 9.33749C18.3458 9.33749 18.3458 9.33749 18.3832 9.33749C18.3832 9.33749 18.3832 9.33749 18.4206 9.33749H18.4579C18.4579 9.33749 18.4579 9.33749 18.4953 9.33749C18.4953 9.33749 18.4953 9.33749 18.4953 9.37499C18.4953 9.37499 18.4953 9.37499 18.4953 9.41249L18.5327 9.82499Z"
          fill={color ?? 'url(#paint139_linear_486_666)'}
        />
        <path
          d="M18.5701 4.9875L18.5327 4.95C18.4953 4.95 18.4953 4.95 18.4579 4.95C18.4206 4.95 18.4206 4.95 18.3832 4.95C18.3458 4.95 18.3458 4.9875 18.3458 4.9875L18.3084 5.025C18.3084 5.0625 18.3084 5.0625 18.3084 5.1V5.475C18.3084 5.5125 18.3084 5.5125 18.3084 5.55C18.3084 5.5875 18.3458 5.625 18.3832 5.625C18.4206 5.625 18.4206 5.625 18.4579 5.625C18.4953 5.625 18.4953 5.625 18.5327 5.625C18.5701 5.625 18.5701 5.5875 18.5701 5.5875L18.6075 5.55C18.6075 5.5125 18.6075 5.5125 18.6075 5.475V5.1C18.6075 5.0625 18.6075 5.025 18.5701 4.9875ZM18.5327 5.4375C18.5327 5.475 18.5327 5.475 18.5327 5.4375C18.5327 5.475 18.5327 5.475 18.4953 5.475C18.4953 5.475 18.4953 5.475 18.4579 5.475C18.4579 5.475 18.4579 5.475 18.4206 5.475C18.3832 5.475 18.3832 5.475 18.3832 5.475C18.3832 5.475 18.3832 5.475 18.3458 5.475C18.3458 5.475 18.3458 5.475 18.3458 5.4375C18.3458 5.4375 18.3458 5.4375 18.3458 5.4V5.025V4.9875C18.3458 4.9875 18.3458 4.9875 18.3458 4.95C18.3458 4.95 18.3458 4.95 18.3832 4.95C18.3832 4.95 18.3832 4.95 18.4206 4.95H18.4579C18.4579 4.95 18.4579 4.95 18.4953 4.95L18.5327 4.9875V5.4375Z"
          fill={color ?? 'url(#paint140_linear_486_666)'}
        />
        <path
          d="M18.5701 7.1625L18.5327 7.125C18.4953 7.125 18.4953 7.125 18.4579 7.125C18.4206 7.125 18.4206 7.125 18.3832 7.125C18.3458 7.125 18.3458 7.1625 18.3458 7.1625L18.3084 7.2C18.3084 7.2375 18.3084 7.2375 18.3084 7.275V7.65C18.3084 7.6875 18.3084 7.725 18.3458 7.7625L18.3832 7.8C18.4206 7.8 18.4206 7.8 18.4579 7.8C18.4953 7.8 18.4953 7.8 18.5327 7.8C18.5701 7.8 18.5701 7.7625 18.5701 7.7625L18.6075 7.725C18.6075 7.6875 18.6075 7.6875 18.6075 7.65V7.275C18.6075 7.2375 18.6075 7.2375 18.6075 7.2C18.6075 7.2 18.5701 7.2 18.5701 7.1625ZM18.5327 7.65C18.5327 7.6875 18.5327 7.6875 18.4953 7.6875C18.4953 7.6875 18.4953 7.6875 18.4579 7.6875C18.4579 7.6875 18.4579 7.6875 18.4206 7.6875H18.3832C18.3832 7.6875 18.3832 7.6875 18.3458 7.6875C18.3458 7.6875 18.3458 7.6875 18.3458 7.65C18.3458 7.65 18.3458 7.65 18.3458 7.6125V7.2375V7.2C18.3458 7.2 18.3458 7.2 18.3458 7.1625C18.3458 7.1625 18.3458 7.1625 18.3832 7.1625C18.3832 7.1625 18.3832 7.1625 18.4206 7.1625H18.4579C18.4579 7.1625 18.4579 7.1625 18.4953 7.1625L18.5327 7.2V7.65Z"
          fill={color ?? 'url(#paint141_linear_486_666)'}
        />
        <path
          d="M19.2056 21.375C19.1682 21.375 19.1682 21.375 19.1309 21.375C19.0935 21.375 19.0935 21.375 19.0561 21.375C19.0187 21.375 19.0187 21.4125 19.0187 21.4125L18.9813 21.45C18.9813 21.4875 18.9813 21.4875 18.9813 21.525V21.6L19.0561 21.5625V21.525C19.0561 21.525 19.0561 21.525 19.0561 21.4875C19.0561 21.4875 19.0561 21.4875 19.0935 21.4875C19.0935 21.4875 19.0935 21.4875 19.1309 21.4875H19.1682H19.2056L19.243 21.45L19.2804 21.4125L19.2056 21.375Z"
          fill={color ?? 'url(#paint142_linear_486_666)'}
        />
        <path
          d="M19.243 9.3H19.1682L19.0561 9.375L19.0934 9.45L19.1682 9.4125V9.9H19.0934V9.975H19.2804V9.9H19.243V9.3Z"
          fill={color ?? 'url(#paint143_linear_486_666)'}
        />
        <path
          d="M19.243 14.85L19.2056 14.8125C19.1682 14.8125 19.1682 14.8125 19.1309 14.8125C19.0935 14.8125 19.0935 14.8125 19.0561 14.8125C19.0187 14.8125 19.0187 14.85 19.0187 14.85L18.9813 14.8875C18.9813 14.925 18.9813 14.925 18.9813 14.9625V15.3375C18.9813 15.375 18.9813 15.375 18.9813 15.4125C18.9813 15.45 19.0187 15.45 19.0187 15.45L19.0561 15.4875C19.0935 15.4875 19.0935 15.4875 19.1309 15.4875C19.1682 15.4875 19.1682 15.4875 19.2056 15.4875L19.243 15.45L19.2804 15.4125C19.2804 15.375 19.2804 15.375 19.2804 15.3375V14.9625C19.2804 14.925 19.2804 14.925 19.2804 14.8875C19.2804 14.85 19.2804 14.85 19.243 14.85ZM19.2056 15.3C19.2056 15.3 19.2056 15.3375 19.2056 15.3C19.2056 15.3375 19.2056 15.3375 19.1682 15.3375C19.1682 15.3375 19.1682 15.3375 19.1309 15.3375C19.1309 15.3375 19.1309 15.3375 19.0935 15.3375H19.0561C19.0561 15.3375 19.0561 15.3375 19.0187 15.3375C19.0187 15.3375 19.0187 15.3375 19.0187 15.3C19.0187 15.3 19.0187 15.3 19.0187 15.2625V14.8875V14.85C19.0187 14.85 19.0187 14.85 19.0187 14.8125C19.0187 14.8125 19.0187 14.8125 19.0561 14.8125C19.0561 14.8125 19.0561 14.8125 19.0935 14.8125H19.1309C19.1309 14.8125 19.1309 14.8125 19.1682 14.8125C19.1682 14.8125 19.1682 14.8125 19.1682 14.85C19.1682 14.85 19.1682 14.85 19.1682 14.8875L19.2056 15.3Z"
          fill={color ?? 'url(#paint144_linear_486_666)'}
        />
        <path
          d="M19.243 8.24999L19.2056 8.21249C19.1682 8.21249 19.1308 8.21249 19.0934 8.21249C19.0561 8.21249 19.0561 8.24999 19.0561 8.24999L19.0187 8.28749C19.0187 8.32499 19.0187 8.32499 19.0187 8.36249V8.73749C19.0187 8.77499 19.0187 8.81249 19.0561 8.84999L19.0934 8.88749C19.1308 8.88749 19.1308 8.88749 19.1682 8.88749C19.2056 8.88749 19.2056 8.88749 19.243 8.88749C19.2804 8.88749 19.2804 8.84999 19.2804 8.84999L19.3177 8.81249C19.3177 8.77499 19.3177 8.77499 19.3177 8.73749V8.36249C19.3177 8.32499 19.3177 8.32499 19.3177 8.28749C19.2804 8.28749 19.2804 8.28749 19.243 8.24999ZM19.2056 8.73749C19.2056 8.77499 19.2056 8.77499 19.1682 8.77499C19.1682 8.77499 19.1682 8.77499 19.1308 8.77499C19.1308 8.77499 19.1308 8.77499 19.0934 8.77499H19.0561C19.0561 8.77499 19.0561 8.77499 19.0187 8.77499C19.0187 8.77499 19.0187 8.77499 19.0187 8.73749C19.0187 8.73749 19.0187 8.73749 19.0187 8.69999V8.32499V8.28749C19.0187 8.28749 19.0187 8.28749 19.0187 8.24999C19.0187 8.24999 19.0187 8.24999 19.0561 8.24999C19.0561 8.24999 19.0561 8.24999 19.0934 8.24999H19.1308C19.1308 8.24999 19.1308 8.24999 19.1682 8.24999C19.1682 8.24999 19.1682 8.24999 19.1682 8.28749C19.1682 8.28749 19.1682 8.28749 19.1682 8.32499L19.2056 8.73749Z"
          fill={color ?? 'url(#paint145_linear_486_666)'}
        />
        <path
          d="M19.243 6.07501L19.2056 6.03751C19.1682 6.03751 19.1682 6.03751 19.1309 6.03751C19.0935 6.03751 19.0935 6.03751 19.0561 6.03751C19.0187 6.03751 19.0187 6.07501 19.0187 6.07501L18.9813 6.11251C18.9813 6.15001 18.9813 6.15001 18.9813 6.18751V6.56251C18.9813 6.60001 18.9813 6.63751 19.0187 6.67501L19.0561 6.71251C19.0935 6.71251 19.0935 6.71251 19.1309 6.71251C19.1682 6.71251 19.1682 6.71251 19.2056 6.71251C19.243 6.71251 19.243 6.67501 19.243 6.67501L19.2804 6.63751C19.2804 6.60001 19.2804 6.60001 19.2804 6.56251V6.18751C19.2804 6.15001 19.2804 6.15001 19.2804 6.11251C19.2804 6.11251 19.2804 6.07501 19.243 6.07501ZM19.2056 6.56251C19.2056 6.60001 19.2056 6.60001 19.1682 6.60001C19.1682 6.60001 19.1682 6.60001 19.1309 6.60001C19.1309 6.60001 19.1309 6.60001 19.0935 6.60001H19.0561C19.0561 6.60001 19.0561 6.60001 19.0187 6.60001C19.0187 6.60001 19.0187 6.60001 19.0187 6.56251C19.0187 6.56251 19.0187 6.56251 19.0187 6.52501V6.15001V6.11251C19.0187 6.11251 19.0187 6.11251 19.0187 6.07501C19.0187 6.07501 19.0187 6.07501 19.0561 6.07501C19.0561 6.07501 19.0561 6.07501 19.0935 6.07501H19.1309L19.1682 6.11251C19.1682 6.11251 19.1682 6.11251 19.1682 6.15001L19.2056 6.56251Z"
          fill={color ?? 'url(#paint146_linear_486_666)'}
        />
        <path
          d="M19.243 7.125H19.1682L19.0561 7.1625L19.0934 7.2375L19.1682 7.2V7.6875H19.0934V7.7625H19.2804V7.6875H19.243V7.125Z"
          fill={color ?? 'url(#paint147_linear_486_666)'}
        />
        <path
          d="M19.243 13.6875H19.1682L19.0561 13.725L19.0934 13.8L19.1682 13.7625V14.25H19.0934V14.325H19.2804V14.25H19.243V13.6875Z"
          fill={color ?? 'url(#paint148_linear_486_666)'}
        />
        <path
          d="M19.243 12.6375L19.2056 12.6C19.1682 12.6 19.1682 12.6 19.1309 12.6C19.0935 12.6 19.0935 12.6 19.0561 12.6C19.0187 12.6 19.0187 12.6375 19.0187 12.6375L18.9813 12.675C18.9813 12.7125 18.9813 12.7125 18.9813 12.75V13.125C18.9813 13.1625 18.9813 13.1625 18.9813 13.2C18.9813 13.2375 19.0187 13.2375 19.0187 13.2375L19.0561 13.275C19.0935 13.275 19.0935 13.275 19.1309 13.275C19.1682 13.275 19.1682 13.275 19.2056 13.275C19.243 13.275 19.243 13.2375 19.243 13.2375L19.2804 13.2C19.2804 13.1625 19.2804 13.1625 19.2804 13.125V12.75C19.2804 12.7125 19.2804 12.7125 19.2804 12.675C19.2804 12.675 19.2804 12.675 19.243 12.6375ZM19.2056 13.125C19.2056 13.1625 19.2056 13.1625 19.1682 13.1625C19.1682 13.1625 19.1682 13.1625 19.1309 13.1625C19.1309 13.1625 19.1309 13.1625 19.0935 13.1625H19.0561C19.0561 13.1625 19.0561 13.1625 19.0187 13.1625C19.0187 13.1625 19.0187 13.1625 19.0187 13.125C19.0187 13.125 19.0187 13.125 19.0187 13.0875V12.7125V12.675C19.0187 12.675 19.0187 12.675 19.0187 12.6375C19.0187 12.6375 19.0187 12.6375 19.0561 12.6375C19.0561 12.6375 19.0561 12.6375 19.0935 12.6375H19.1309C19.1309 12.6375 19.1309 12.6375 19.1682 12.6375C19.1682 12.6375 19.1682 12.6375 19.1682 12.675C19.1682 12.675 19.1682 12.675 19.1682 12.7125L19.2056 13.125Z"
          fill={color ?? 'url(#paint149_linear_486_666)'}
        />
        <path
          d="M19.243 11.5125H19.1682L19.0561 11.55L19.0934 11.625L19.1682 11.5875V12.075H19.0934V12.15H19.2804V12.075H19.243V11.5125Z"
          fill={color ?? 'url(#paint150_linear_486_666)'}
        />
        <path
          d="M19.243 10.4625L19.2056 10.425C19.1682 10.425 19.1682 10.425 19.1309 10.425C19.0935 10.425 19.0935 10.425 19.0561 10.425C19.0187 10.425 19.0187 10.4625 19.0187 10.4625L18.9813 10.5C18.9813 10.5375 18.9813 10.5375 18.9813 10.575V10.95C18.9813 10.9875 18.9813 10.9875 18.9813 11.025L19.0187 11.0625L19.0561 11.1C19.0935 11.1 19.0935 11.1 19.1309 11.1C19.1682 11.1 19.1682 11.1 19.2056 11.1C19.243 11.1 19.243 11.0625 19.243 11.0625L19.2804 11.025C19.2804 10.9875 19.2804 10.9875 19.2804 10.95V10.575C19.2804 10.5375 19.2804 10.5375 19.2804 10.5C19.2804 10.5 19.2804 10.4625 19.243 10.4625ZM19.2056 10.9125C19.2056 10.95 19.2056 10.95 19.2056 10.9125C19.2056 10.95 19.2056 10.95 19.1682 10.95C19.1682 10.95 19.1682 10.95 19.1309 10.95C19.1309 10.95 19.1309 10.95 19.0935 10.95H19.0561C19.0561 10.95 19.0561 10.95 19.0187 10.95C19.0187 10.95 19.0187 10.95 19.0187 10.9125C19.0187 10.9125 19.0187 10.9125 19.0187 10.875V10.5V10.4625C19.0187 10.4625 19.0187 10.4625 19.0187 10.425C19.0187 10.425 19.0187 10.425 19.0561 10.425C19.0561 10.425 19.0561 10.425 19.0935 10.425H19.1309C19.1309 10.425 19.1309 10.425 19.1682 10.425C19.1682 10.425 19.1682 10.425 19.1682 10.4625C19.1682 10.4625 19.1682 10.4625 19.1682 10.5L19.2056 10.9125Z"
          fill={color ?? 'url(#paint151_linear_486_666)'}
        />
        <path
          d="M19.243 18.075H19.1682L19.0561 18.1125L19.0934 18.1875L19.1682 18.15V18.6375H19.0934V18.75H19.2804V18.675H19.243V18.075Z"
          fill={color ?? 'url(#paint152_linear_486_666)'}
        />
        <path
          d="M17.7851 14.85L17.7477 14.8125C17.7103 14.8125 17.7103 14.8125 17.6729 14.8125C17.6355 14.8125 17.6355 14.8125 17.5981 14.8125C17.5608 14.8125 17.5608 14.85 17.5608 14.85C17.5234 14.8875 17.5234 14.925 17.5234 14.9625V15.3375C17.5234 15.375 17.5234 15.375 17.5234 15.4125C17.5234 15.45 17.5608 15.45 17.5608 15.45L17.5981 15.4875C17.6355 15.4875 17.6355 15.4875 17.6729 15.4875C17.7103 15.4875 17.7103 15.4875 17.7477 15.4875L17.7851 15.45L17.8224 15.4125C17.8224 15.375 17.8224 15.375 17.8224 15.3375V14.9625C17.8224 14.925 17.8224 14.925 17.8224 14.8875C17.8224 14.85 17.7851 14.85 17.7851 14.85ZM17.7477 15.3C17.7477 15.3 17.7477 15.3375 17.7477 15.3C17.7477 15.3375 17.7477 15.3375 17.7103 15.3375C17.7103 15.3375 17.7103 15.3375 17.6729 15.3375C17.6729 15.3375 17.6729 15.3375 17.6355 15.3375C17.5981 15.3375 17.5981 15.3375 17.5981 15.3375C17.5981 15.3375 17.5981 15.3375 17.5608 15.3375C17.5608 15.3375 17.5608 15.3375 17.5608 15.3C17.5608 15.3 17.5608 15.3 17.5608 15.2625V14.8875V14.85C17.5608 14.85 17.5608 14.85 17.5608 14.8125C17.5608 14.8125 17.5608 14.8125 17.5981 14.8125C17.5981 14.8125 17.5981 14.8125 17.6355 14.8125H17.6729C17.6729 14.8125 17.6729 14.8125 17.7103 14.8125C17.7103 14.8125 17.7103 14.8125 17.7103 14.85C17.7103 14.85 17.7103 14.85 17.7103 14.8875L17.7477 15.3Z"
          fill={color ?? 'url(#paint153_linear_486_666)'}
        />
        <path
          d="M17.7851 12.6375C17.7477 12.6 17.7477 12.6 17.7103 12.6C17.6729 12.6 17.6355 12.6 17.6355 12.6C17.5981 12.6 17.5981 12.6375 17.5981 12.6375C17.5608 12.675 17.5608 12.7125 17.5608 12.75V13.125C17.5608 13.1625 17.5608 13.1625 17.5608 13.2C17.5608 13.2375 17.5981 13.2375 17.5981 13.2375L17.6355 13.275C17.6729 13.275 17.6729 13.275 17.7103 13.275C17.7477 13.275 17.7477 13.275 17.7851 13.275L17.8224 13.2375L17.8598 13.2C17.8598 13.1625 17.8598 13.1625 17.8598 13.125V12.75C17.8598 12.7125 17.8598 12.7125 17.8598 12.675C17.8224 12.675 17.7851 12.675 17.7851 12.6375ZM17.7477 13.125C17.7477 13.1625 17.7477 13.1625 17.7103 13.1625C17.7103 13.1625 17.7103 13.1625 17.6729 13.1625C17.6729 13.1625 17.6729 13.1625 17.6355 13.1625H17.5981C17.5981 13.1625 17.5981 13.1625 17.5608 13.1625C17.5608 13.1625 17.5608 13.1625 17.5608 13.125C17.5608 13.125 17.5608 13.125 17.5608 13.0875V12.7125V12.675C17.5608 12.675 17.5608 12.675 17.5608 12.6375C17.5608 12.6375 17.5608 12.6375 17.5981 12.6375C17.5981 12.6375 17.5981 12.6375 17.6355 12.6375H17.6729C17.6729 12.6375 17.6729 12.6375 17.7103 12.6375C17.7103 12.6375 17.7103 12.6375 17.7103 12.675C17.7103 12.675 17.7103 12.675 17.7103 12.7125V13.125H17.7477Z"
          fill={color ?? 'url(#paint154_linear_486_666)'}
        />
        <path
          d="M17.7851 13.6875H17.7103L17.5981 13.725L17.6355 13.8L17.7103 13.7625V14.25H17.6355V14.325H17.8224V14.25H17.7851V13.6875Z"
          fill={color ?? 'url(#paint155_linear_486_666)'}
        />
        <path
          d="M17.7851 11.5125H17.7103L17.5981 11.55L17.6355 11.625L17.7103 11.5875V12.075H17.6355V12.15H17.8224V12.075H17.7851V11.5125Z"
          fill={color ?? 'url(#paint156_linear_486_666)'}
        />
        <path
          d="M17.7851 19.2C17.7477 19.1625 17.7477 19.1625 17.7103 19.1625C17.6729 19.1625 17.6355 19.1625 17.6355 19.1625C17.5981 19.1625 17.5981 19.2 17.5981 19.2L17.5608 19.2375C17.5608 19.275 17.5608 19.275 17.5608 19.3125V19.6875C17.5608 19.725 17.5608 19.725 17.5608 19.7625C17.5608 19.8 17.5981 19.8 17.5981 19.8L17.6355 19.8375C17.6729 19.8375 17.6729 19.8375 17.7103 19.8375C17.7477 19.8375 17.7477 19.8375 17.7851 19.8375L17.8224 19.8L17.8598 19.7625C17.8598 19.725 17.8598 19.725 17.8598 19.6875V19.3125C17.8598 19.275 17.8598 19.275 17.8598 19.2375C17.8224 19.2375 17.7851 19.2375 17.7851 19.2ZM17.7477 19.6875C17.7477 19.725 17.7477 19.725 17.7103 19.725C17.7103 19.725 17.7103 19.725 17.6729 19.725C17.6729 19.725 17.6729 19.725 17.6355 19.725H17.5981C17.5981 19.725 17.5981 19.725 17.5608 19.725C17.5608 19.725 17.5608 19.725 17.5608 19.6875C17.5608 19.6875 17.5608 19.6875 17.5608 19.65V19.275V19.2375C17.5608 19.2375 17.5608 19.2375 17.5608 19.2C17.5608 19.2 17.5608 19.2 17.5981 19.2C17.5981 19.2 17.5981 19.2 17.6355 19.2H17.6729C17.6729 19.2 17.6729 19.2 17.7103 19.2C17.7103 19.2 17.7103 19.2 17.7103 19.2375C17.7103 19.2375 17.7103 19.2375 17.7103 19.275V19.6875H17.7477Z"
          fill={color ?? 'url(#paint157_linear_486_666)'}
        />
        <path
          d="M17.7851 18.075H17.7103L17.5981 18.1125L17.6355 18.1875L17.7103 18.15V18.6375H17.6355V18.75H17.8224V18.675H17.7851V18.075Z"
          fill={color ?? 'url(#paint158_linear_486_666)'}
        />
        <path
          d="M17.7851 10.4625C17.7477 10.425 17.7477 10.425 17.7103 10.425C17.6729 10.425 17.6355 10.425 17.6355 10.425C17.5981 10.425 17.5981 10.4625 17.5981 10.4625C17.5608 10.5 17.5608 10.5375 17.5608 10.575V10.95C17.5608 10.9875 17.5608 10.9875 17.5608 11.025C17.5608 11.0625 17.5981 11.0625 17.5981 11.0625L17.6355 11.1C17.6729 11.1 17.6729 11.1 17.7103 11.1C17.7477 11.1 17.7477 11.1 17.7851 11.1L17.8224 11.0625L17.8598 11.025C17.8598 10.9875 17.8598 10.9875 17.8598 10.95V10.575C17.8598 10.5375 17.8598 10.5375 17.8598 10.5C17.8224 10.5 17.7851 10.4625 17.7851 10.4625ZM17.7477 10.9125C17.7477 10.95 17.7477 10.95 17.7477 10.9125C17.7477 10.95 17.7477 10.95 17.7103 10.95C17.7103 10.95 17.7103 10.95 17.6729 10.95C17.6729 10.95 17.6729 10.95 17.6355 10.95C17.5981 10.95 17.5981 10.95 17.5981 10.95C17.5981 10.95 17.5981 10.95 17.5608 10.95C17.5608 10.95 17.5608 10.95 17.5608 10.9125C17.5608 10.9125 17.5608 10.9125 17.5608 10.875V10.5V10.4625C17.5608 10.4625 17.5608 10.4625 17.5608 10.425C17.5608 10.425 17.5608 10.425 17.5981 10.425C17.5981 10.425 17.5981 10.425 17.6355 10.425H17.6729C17.6729 10.425 17.6729 10.425 17.7103 10.425C17.7103 10.425 17.7103 10.425 17.7103 10.4625C17.7103 10.4625 17.7103 10.4625 17.7103 10.5V10.9125H17.7477Z"
          fill={color ?? 'url(#paint159_linear_486_666)'}
        />
        <path
          d="M17.7851 15.9H17.7103L17.5981 15.9375L17.6355 16.0125L17.7103 15.975V16.4625H17.6355V16.5375H17.8224V16.4625H17.7851V15.9Z"
          fill={color ?? 'url(#paint160_linear_486_666)'}
        />
        <path
          d="M17.7851 17.025L17.7477 16.9875C17.7103 16.9875 17.7103 16.9875 17.6729 16.9875C17.6355 16.9875 17.6355 16.9875 17.5981 16.9875C17.5608 16.9875 17.5608 17.025 17.5608 17.025L17.5234 17.0625C17.5234 17.1 17.5234 17.1 17.5234 17.1375V17.5125C17.5234 17.55 17.5234 17.55 17.5234 17.5875C17.5234 17.625 17.5608 17.625 17.5608 17.625L17.5981 17.6625C17.6355 17.6625 17.6355 17.6625 17.6729 17.6625C17.7103 17.6625 17.7103 17.6625 17.7477 17.6625L17.7851 17.625L17.8224 17.5875C17.8224 17.55 17.8224 17.55 17.8224 17.5125V17.1375C17.8224 17.1 17.8224 17.1 17.8224 17.0625L17.7851 17.025ZM17.7477 17.5125C17.7477 17.55 17.7477 17.55 17.7103 17.55C17.7103 17.55 17.7103 17.55 17.6729 17.55C17.6729 17.55 17.6729 17.55 17.6355 17.55H17.5981C17.5981 17.55 17.5981 17.55 17.5608 17.55C17.5608 17.55 17.5608 17.55 17.5608 17.5125C17.5608 17.5125 17.5608 17.5125 17.5608 17.475V17.1V17.0625C17.5608 17.0625 17.5608 17.0625 17.5608 17.025C17.5608 17.025 17.5608 17.025 17.5981 17.025C17.5981 17.025 17.5981 17.025 17.6355 17.025H17.6729C17.6729 17.025 17.6729 17.025 17.7103 17.025C17.7103 17.025 17.7103 17.025 17.7103 17.0625C17.7103 17.0625 17.7103 17.0625 17.7103 17.1V17.5125H17.7477Z"
          fill={color ?? 'url(#paint161_linear_486_666)'}
        />
        <path
          d="M17.7851 4.95H17.7103L17.5981 4.9875L17.6355 5.0625L17.7103 5.025V5.5125H17.6355V5.625H17.8224V5.55H17.7851V4.95Z"
          fill={color ?? 'url(#paint162_linear_486_666)'}
        />
        <path
          d="M17.7851 9.3H17.7103L17.5981 9.375L17.6355 9.45L17.7103 9.4125V9.9H17.6355V9.975H17.8224V9.9H17.7851V9.3Z"
          fill={color ?? 'url(#paint163_linear_486_666)'}
        />
        <path
          d="M17.7477 4.34999C17.7477 4.34999 17.7477 4.38749 17.7477 4.34999C17.7477 4.38749 17.7477 4.38749 17.7103 4.38749C17.7103 4.38749 17.7103 4.38749 17.6729 4.38749C17.6729 4.38749 17.6729 4.38749 17.6355 4.38749C17.5981 4.38749 17.5981 4.38749 17.5981 4.38749C17.5981 4.38749 17.5981 4.38749 17.5608 4.38749C17.5608 4.38749 17.5608 4.38749 17.5608 4.34999C17.5608 4.34999 17.5608 4.34999 17.5608 4.31249V4.12499L17.486 4.08749V4.34999C17.486 4.38749 17.486 4.38749 17.486 4.42499C17.486 4.46249 17.5234 4.46249 17.5234 4.46249L17.5608 4.49999C17.5981 4.49999 17.5981 4.49999 17.6355 4.49999C17.6729 4.49999 17.6729 4.49999 17.7103 4.49999L17.7477 4.46249L17.7851 4.42499C17.7851 4.38749 17.7851 4.38749 17.7851 4.34999V4.23749L17.7103 4.19999L17.7477 4.34999Z"
          fill={color ?? 'url(#paint164_linear_486_666)'}
        />
        <path
          d="M18.5701 20.325L18.5327 20.2875C18.4953 20.2875 18.4579 20.2875 18.4206 20.2875C18.3832 20.2875 18.3832 20.325 18.3832 20.325L18.3458 20.3625C18.3458 20.4 18.3458 20.4 18.3458 20.4375V20.8125C18.3458 20.85 18.3458 20.85 18.3458 20.8875C18.3458 20.925 18.3832 20.925 18.3832 20.925L18.4206 20.9625C18.4579 20.9625 18.4579 20.9625 18.4953 20.9625C18.5327 20.9625 18.5327 20.9625 18.5701 20.9625C18.6075 20.9625 18.6075 20.925 18.6075 20.925L18.6449 20.8875C18.6449 20.85 18.6449 20.85 18.6449 20.8125V20.4375C18.6449 20.4 18.6449 20.4 18.6449 20.3625C18.6075 20.325 18.5701 20.325 18.5701 20.325ZM18.5327 20.775C18.5327 20.775 18.5327 20.8125 18.5327 20.775C18.5327 20.8125 18.5327 20.8125 18.4953 20.8125C18.4953 20.8125 18.4579 20.8125 18.4579 20.85H18.4206C18.4206 20.85 18.4206 20.85 18.3832 20.85C18.3832 20.85 18.3832 20.85 18.3832 20.8125C18.3832 20.8125 18.3832 20.8125 18.3832 20.775V20.4V20.3625C18.3832 20.3625 18.3832 20.3625 18.3832 20.325C18.3832 20.325 18.3832 20.325 18.4206 20.325C18.4206 20.325 18.4206 20.325 18.4579 20.325H18.4953C18.4953 20.325 18.4953 20.325 18.5327 20.325C18.5327 20.325 18.5327 20.325 18.5327 20.3625C18.5327 20.3625 18.5327 20.3625 18.5327 20.4V20.775Z"
          fill={color ?? 'url(#paint165_linear_486_666)'}
        />
        <path
          d="M18.5701 18.1125L18.5327 18.075C18.4953 18.075 18.4953 18.075 18.4579 18.075C18.4206 18.075 18.4206 18.075 18.3832 18.075C18.3458 18.075 18.3458 18.1125 18.3458 18.1125L18.3084 18.15C18.3084 18.1875 18.3084 18.1875 18.3084 18.225V18.6C18.3084 18.6375 18.3084 18.6375 18.3084 18.675C18.3084 18.7125 18.3458 18.7125 18.3458 18.7125L18.3832 18.75C18.4206 18.75 18.4206 18.75 18.4579 18.75C18.4953 18.75 18.4953 18.75 18.5327 18.75C18.5701 18.75 18.5701 18.7125 18.5701 18.7125L18.6075 18.675C18.6075 18.6375 18.6075 18.6375 18.6075 18.6V18.225C18.6075 18.1875 18.6075 18.1875 18.6075 18.15C18.6075 18.15 18.5701 18.15 18.5701 18.1125ZM18.5327 18.6C18.5327 18.6375 18.5327 18.6375 18.4953 18.6375C18.4953 18.6375 18.4953 18.6375 18.4579 18.6375C18.4579 18.6375 18.4579 18.6375 18.4206 18.6375C18.3832 18.6375 18.3832 18.6375 18.3832 18.6375C18.3832 18.6375 18.3832 18.6375 18.3458 18.6375C18.3458 18.6375 18.3458 18.6375 18.3458 18.6C18.3458 18.6 18.3458 18.6 18.3458 18.5625V18.1875V18.15C18.3458 18.15 18.3458 18.15 18.3458 18.1125C18.3458 18.1125 18.3458 18.1125 18.3832 18.1125C18.3832 18.1125 18.3832 18.1125 18.4206 18.1125H18.4579C18.4579 18.1125 18.4579 18.1125 18.4953 18.1125L18.5327 18.15V18.6Z"
          fill={color ?? 'url(#paint166_linear_486_666)'}
        />
        <path
          d="M18.3832 21.375L18.271 21.4125L18.3084 21.4875L18.3832 21.45V21.9L18.4579 21.8625V21.375H18.3832Z"
          fill={color ?? 'url(#paint167_linear_486_666)'}
        />
        <path
          d="M18.5701 15.9375L18.5327 15.9C18.4953 15.9 18.4953 15.9 18.4579 15.9C18.4206 15.9 18.4206 15.9 18.3832 15.9C18.3458 15.9 18.3458 15.9375 18.3458 15.9375L18.3084 15.975C18.3084 16.0125 18.3084 16.0125 18.3084 16.05V16.425C18.3084 16.4625 18.3084 16.4625 18.3084 16.5C18.3084 16.5375 18.3458 16.5375 18.3458 16.5375L18.3832 16.575C18.4206 16.575 18.4206 16.575 18.4579 16.575C18.4953 16.575 18.4953 16.575 18.5327 16.575C18.5701 16.575 18.5701 16.5375 18.5701 16.5375L18.6075 16.5C18.6075 16.4625 18.6075 16.4625 18.6075 16.425V16.05C18.6075 16.0125 18.6075 16.0125 18.6075 15.975L18.5701 15.9375ZM18.5327 16.3875C18.5327 16.425 18.5327 16.425 18.5327 16.3875C18.5327 16.425 18.5327 16.425 18.4953 16.425C18.4953 16.425 18.4953 16.425 18.4579 16.425C18.4579 16.425 18.4579 16.425 18.4206 16.425C18.3832 16.425 18.3832 16.425 18.3832 16.425C18.3832 16.425 18.3832 16.425 18.3458 16.425C18.3458 16.425 18.3458 16.425 18.3458 16.3875C18.3458 16.3875 18.3458 16.3875 18.3458 16.35V15.975V15.9375L18.3832 15.9C18.3832 15.9 18.3832 15.9 18.4206 15.9H18.4579C18.4579 15.9 18.4579 15.9 18.4953 15.9L18.5327 15.9375V16.3875Z"
          fill={color ?? 'url(#paint168_linear_486_666)'}
        />
        <path
          d="M17.7851 7.125H17.7103L17.5981 7.1625L17.6355 7.2375L17.7103 7.2V7.6875H17.6355V7.7625H17.8224V7.6875H17.7851V7.125Z"
          fill={color ?? 'url(#paint169_linear_486_666)'}
        />
        <path
          d="M17.7851 8.24999L17.7477 8.21249C17.7103 8.21249 17.7103 8.21249 17.6729 8.21249C17.6355 8.21249 17.6355 8.21249 17.5981 8.21249C17.5608 8.21249 17.5608 8.24999 17.5608 8.24999L17.5234 8.28749C17.5234 8.32499 17.5234 8.32499 17.5234 8.36249V8.73749C17.5234 8.77499 17.5234 8.77499 17.5234 8.81249C17.5234 8.84999 17.5608 8.84999 17.5608 8.84999L17.5981 8.88749C17.6355 8.88749 17.6355 8.88749 17.6729 8.88749C17.7103 8.88749 17.7103 8.88749 17.7477 8.88749L17.7851 8.84999L17.8224 8.81249C17.8224 8.77499 17.8224 8.77499 17.8224 8.73749V8.36249C17.8224 8.32499 17.8224 8.32499 17.8224 8.28749C17.8224 8.28749 17.7851 8.28749 17.7851 8.24999ZM17.7477 8.73749C17.7477 8.73749 17.7477 8.77499 17.7477 8.73749C17.7477 8.77499 17.7477 8.77499 17.7103 8.77499C17.7103 8.77499 17.7103 8.77499 17.6729 8.77499H17.6355C17.6355 8.77499 17.5981 8.77499 17.5981 8.73749C17.5981 8.73749 17.5981 8.73749 17.5981 8.69999C17.5981 8.69999 17.5981 8.69999 17.5981 8.66249V8.28749V8.24999C17.5981 8.24999 17.5981 8.24999 17.5981 8.21249C17.5981 8.21249 17.5981 8.21249 17.6355 8.21249C17.6355 8.21249 17.6355 8.21249 17.6729 8.21249H17.7103C17.7103 8.21249 17.7103 8.21249 17.7477 8.21249C17.7477 8.21249 17.7477 8.21249 17.7477 8.24999C17.7477 8.24999 17.7477 8.24999 17.7477 8.28749V8.73749Z"
          fill={color ?? 'url(#paint170_linear_486_666)'}
        />
        <path
          d="M17.7851 6.07501L17.7477 6.03751C17.7103 6.03751 17.7103 6.03751 17.6729 6.03751C17.6355 6.03751 17.6355 6.03751 17.5981 6.03751C17.5608 6.03751 17.5608 6.07501 17.5608 6.07501L17.5234 6.11251C17.5234 6.15001 17.5234 6.15001 17.5234 6.18751V6.56251C17.5234 6.60001 17.5234 6.60001 17.5234 6.63751C17.5234 6.67501 17.5608 6.67501 17.5608 6.67501L17.5981 6.71251C17.6355 6.71251 17.6355 6.71251 17.6729 6.71251C17.7103 6.71251 17.7103 6.71251 17.7477 6.71251L17.7851 6.67501L17.8224 6.63751C17.8224 6.60001 17.8224 6.60001 17.8224 6.56251V6.18751C17.8224 6.15001 17.8224 6.15001 17.8224 6.11251L17.7851 6.07501ZM17.7477 6.56251C17.7477 6.60001 17.7477 6.60001 17.7103 6.60001C17.7103 6.60001 17.7103 6.60001 17.6729 6.60001C17.6729 6.60001 17.6729 6.60001 17.6355 6.60001C17.5981 6.60001 17.5981 6.60001 17.5981 6.60001C17.5981 6.60001 17.5981 6.60001 17.5608 6.60001C17.5608 6.60001 17.5608 6.60001 17.5608 6.56251C17.5608 6.56251 17.5608 6.56251 17.5608 6.52501V6.15001V6.11251C17.5608 6.11251 17.5608 6.11251 17.5608 6.07501C17.5608 6.07501 17.5608 6.07501 17.5981 6.07501C17.5981 6.07501 17.5981 6.07501 17.6355 6.07501H17.6729C17.6729 6.07501 17.6729 6.07501 17.7103 6.07501C17.7103 6.07501 17.7103 6.07501 17.7103 6.11251C17.7103 6.11251 17.7103 6.11251 17.7103 6.15001L17.7477 6.56251Z"
          fill={color ?? 'url(#paint171_linear_486_666)'}
        />
        <path
          d="M20.7009 7.125H20.6262L20.514 7.1625L20.5514 7.2375L20.6262 7.2V7.6875H20.5514V7.7625H20.7383V7.6875H20.7009V7.125Z"
          fill={color ?? 'url(#paint172_linear_486_666)'}
        />
        <path
          d="M22.1589 18.075H22.0841L21.972 18.1125L22.0093 18.1875L22.0841 18.15V18.6375H22.0093V18.75H22.1963V18.675H22.1589V18.075Z"
          fill={color ?? 'url(#paint173_linear_486_666)'}
        />
        <path
          d="M21.486 13.725L21.4486 13.6875C21.4112 13.6875 21.3738 13.6875 21.3365 13.6875C21.2991 13.6875 21.2991 13.725 21.2991 13.725L21.2617 13.7625C21.2617 13.8 21.2617 13.8 21.2617 13.8375V14.2125C21.2617 14.25 21.2617 14.25 21.2617 14.2875C21.2617 14.325 21.2991 14.325 21.2991 14.325L21.3365 14.3625C21.3738 14.3625 21.3738 14.3625 21.4112 14.3625C21.4486 14.3625 21.4486 14.3625 21.486 14.3625C21.5234 14.3625 21.5234 14.325 21.5234 14.325L21.5608 14.2875C21.5608 14.25 21.5608 14.25 21.5608 14.2125V13.8375C21.5608 13.8 21.5608 13.8 21.5608 13.7625C21.5234 13.7625 21.5234 13.7625 21.486 13.725ZM21.4486 14.2125C21.4486 14.2125 21.4486 14.25 21.4486 14.2125C21.4486 14.25 21.4486 14.25 21.4112 14.25C21.4112 14.25 21.4112 14.25 21.3738 14.25C21.3738 14.25 21.3738 14.25 21.3365 14.25C21.2991 14.25 21.2991 14.25 21.2991 14.25C21.2991 14.25 21.2991 14.25 21.2617 14.25C21.2617 14.25 21.2617 14.25 21.2617 14.2125C21.2617 14.2125 21.2617 14.2125 21.2617 14.175V13.8V13.7625C21.2617 13.7625 21.2617 13.7625 21.2617 13.725C21.2617 13.725 21.2617 13.725 21.2991 13.725C21.2991 13.725 21.2991 13.725 21.3365 13.725H21.3738C21.3738 13.725 21.3738 13.725 21.4112 13.725C21.4112 13.725 21.4112 13.725 21.4112 13.7625C21.4112 13.7625 21.4112 13.7625 21.4112 13.8L21.4486 14.2125Z"
          fill={color ?? 'url(#paint174_linear_486_666)'}
        />
        <path
          d="M21.486 11.55L21.4486 11.5125C21.4112 11.5125 21.3738 11.5125 21.3365 11.5125C21.2991 11.5125 21.2991 11.55 21.2991 11.55L21.2617 11.5875C21.2617 11.625 21.2617 11.625 21.2617 11.6625V12.0375C21.2617 12.075 21.2617 12.075 21.2617 12.1125C21.2617 12.15 21.2991 12.15 21.2991 12.15L21.3365 12.1875C21.3738 12.1875 21.3738 12.1875 21.4112 12.1875C21.4486 12.1875 21.4486 12.1875 21.486 12.1875C21.5234 12.1875 21.5234 12.15 21.5234 12.15L21.5608 12.1125C21.5608 12.075 21.5608 12.075 21.5608 12.0375V11.6625C21.5608 11.625 21.5608 11.625 21.5608 11.5875C21.5234 11.5875 21.5234 11.55 21.486 11.55ZM21.4486 12.0375C21.4486 12.075 21.4486 12.075 21.4112 12.075C21.4112 12.075 21.4112 12.075 21.3738 12.075C21.3738 12.075 21.3738 12.075 21.3365 12.075H21.2991C21.2991 12.075 21.2991 12.075 21.2617 12.075C21.2617 12.075 21.2617 12.075 21.2617 12.0375C21.2617 12.0375 21.2617 12.0375 21.2617 12V11.625V11.5875C21.2617 11.5875 21.2617 11.5875 21.2617 11.55C21.2617 11.55 21.2617 11.55 21.2991 11.55H21.3365H21.3738C21.3738 11.55 21.3738 11.55 21.4112 11.55L21.4486 11.5875V12.0375Z"
          fill={color ?? 'url(#paint175_linear_486_666)'}
        />
        <path
          d="M21.486 7.1625L21.4486 7.125C21.4112 7.125 21.4112 7.125 21.3738 7.125C21.3365 7.125 21.3365 7.125 21.2991 7.125C21.2617 7.125 21.2617 7.1625 21.2617 7.1625L21.2243 7.2C21.2243 7.2375 21.2243 7.2375 21.2243 7.275V7.65C21.2243 7.6875 21.2243 7.6875 21.2243 7.725C21.2243 7.7625 21.2617 7.7625 21.2617 7.7625L21.2991 7.8C21.3365 7.8 21.3365 7.8 21.3738 7.8C21.4112 7.8 21.4112 7.8 21.4486 7.8C21.486 7.8 21.486 7.7625 21.486 7.7625L21.5234 7.725C21.5234 7.6875 21.5234 7.6875 21.5234 7.65V7.275C21.5234 7.2375 21.5234 7.2375 21.5234 7.2C21.5234 7.2 21.5234 7.2 21.486 7.1625ZM21.4486 7.65C21.4486 7.6875 21.4486 7.6875 21.4112 7.6875C21.4112 7.6875 21.3738 7.6875 21.3738 7.725H21.3365C21.3365 7.725 21.3365 7.725 21.2991 7.725C21.2991 7.725 21.2991 7.725 21.2991 7.6875C21.2991 7.6875 21.2991 7.6875 21.2991 7.65V7.275V7.2375L21.3365 7.2C21.3365 7.2 21.3365 7.2 21.3738 7.2H21.4112C21.4112 7.2 21.4112 7.2 21.4486 7.2C21.4486 7.2 21.4486 7.2 21.4486 7.2375C21.4486 7.2375 21.4486 7.2375 21.4486 7.275V7.65Z"
          fill={color ?? 'url(#paint176_linear_486_666)'}
        />
        <path
          d="M22.1589 19.2L22.1215 19.1625C22.0841 19.1625 22.0841 19.1625 22.0467 19.1625C22.0093 19.1625 22.0093 19.1625 21.972 19.1625C21.9346 19.1625 21.9346 19.2 21.9346 19.2L21.8972 19.2375C21.8972 19.275 21.8972 19.275 21.8972 19.3125V19.6875C21.8972 19.725 21.8972 19.725 21.8972 19.7625C21.8972 19.8 21.9346 19.8 21.9346 19.8C21.9346 19.8 21.972 19.8 21.972 19.8375L22.0841 19.7625L22.0093 19.725C22.0093 19.725 22.0093 19.725 21.972 19.725C21.972 19.725 21.972 19.725 21.972 19.6875C21.972 19.6875 21.972 19.6875 21.972 19.65V19.275V19.2375C21.972 19.2375 21.972 19.2375 21.972 19.2C21.972 19.2 21.972 19.2 22.0093 19.2H22.0467C22.0467 19.2 22.0467 19.2 22.0841 19.2C22.0841 19.2 22.0841 19.2 22.0841 19.2375C22.0841 19.2375 22.0841 19.2375 22.0841 19.275V19.65V19.725L22.1963 19.65V19.275C22.1963 19.2375 22.1963 19.2375 22.1963 19.2C22.1963 19.2375 22.1963 19.2375 22.1589 19.2Z"
          fill={color ?? 'url(#paint177_linear_486_666)'}
        />
        <path
          d="M21.486 9.37499L21.4486 9.33749C21.4112 9.33749 21.4112 9.33749 21.3738 9.33749C21.3365 9.33749 21.3365 9.33749 21.2991 9.33749C21.2617 9.33749 21.2617 9.37499 21.2617 9.37499L21.2243 9.41249C21.2243 9.44999 21.2243 9.44999 21.2243 9.48749V9.86249C21.2243 9.89999 21.2243 9.89999 21.2243 9.93749C21.2243 9.97499 21.2617 9.97499 21.2617 9.97499L21.2991 10.0125C21.3365 10.0125 21.3365 10.0125 21.3738 10.0125C21.4112 10.0125 21.4112 10.0125 21.4486 10.0125C21.486 10.0125 21.486 9.97499 21.486 9.97499L21.5234 9.93749C21.5234 9.89999 21.5234 9.89999 21.5234 9.86249V9.48749C21.5234 9.44999 21.5234 9.44999 21.5234 9.41249C21.5234 9.37499 21.5234 9.37499 21.486 9.37499ZM21.4486 9.82499C21.4486 9.82499 21.4486 9.86249 21.4486 9.82499C21.4486 9.86249 21.4486 9.86249 21.4112 9.86249C21.4112 9.86249 21.4112 9.86249 21.3738 9.86249C21.3738 9.86249 21.3738 9.86249 21.3365 9.86249H21.2991C21.2991 9.86249 21.2991 9.86249 21.2617 9.86249C21.2617 9.86249 21.2617 9.86249 21.2617 9.82499C21.2617 9.82499 21.2617 9.82499 21.2617 9.78749V9.41249V9.37499C21.2617 9.37499 21.2617 9.37499 21.2617 9.33749C21.2617 9.33749 21.2617 9.33749 21.2991 9.33749H21.3365H21.3738C21.3738 9.33749 21.3738 9.33749 21.4112 9.33749C21.4112 9.33749 21.4112 9.33749 21.4112 9.37499C21.4112 9.37499 21.4112 9.37499 21.4112 9.41249L21.4486 9.82499Z"
          fill={color ?? 'url(#paint178_linear_486_666)'}
        />
        <path
          d="M20.7009 6.07501L20.6635 6.03751C20.6262 6.03751 20.6262 6.03751 20.5888 6.03751C20.5514 6.03751 20.5514 6.03751 20.514 6.03751C20.4766 6.03751 20.4766 6.07501 20.4766 6.07501L20.4392 6.11251C20.4392 6.15001 20.4392 6.15001 20.4392 6.18751V6.56251C20.4392 6.60001 20.4392 6.60001 20.4392 6.63751C20.4392 6.67501 20.4766 6.67501 20.4766 6.67501L20.514 6.71251C20.5514 6.71251 20.5514 6.71251 20.5888 6.71251C20.6262 6.71251 20.6262 6.71251 20.6635 6.71251L20.7009 6.67501L20.7383 6.63751C20.7383 6.60001 20.7383 6.60001 20.7383 6.56251V6.18751C20.7383 6.15001 20.7383 6.15001 20.7383 6.11251C20.7383 6.11251 20.7383 6.07501 20.7009 6.07501ZM20.6635 6.56251C20.6635 6.60001 20.6635 6.60001 20.6262 6.60001C20.6262 6.60001 20.6262 6.60001 20.5888 6.60001C20.5888 6.60001 20.5888 6.60001 20.5514 6.60001H20.514C20.514 6.60001 20.514 6.60001 20.4766 6.60001C20.4766 6.60001 20.4766 6.60001 20.4766 6.56251C20.4766 6.56251 20.4766 6.56251 20.4766 6.52501V6.15001V6.11251C20.4766 6.11251 20.4766 6.11251 20.4766 6.07501C20.4766 6.07501 20.4766 6.07501 20.514 6.07501C20.514 6.07501 20.514 6.07501 20.5514 6.07501H20.5888C20.5888 6.07501 20.5888 6.07501 20.6262 6.07501C20.6262 6.07501 20.6262 6.07501 20.6262 6.11251C20.6262 6.11251 20.6262 6.11251 20.6262 6.15001L20.6635 6.56251Z"
          fill={color ?? 'url(#paint179_linear_486_666)'}
        />
        <path
          d="M21.4112 19.1625H21.3365L21.2243 19.2L21.2617 19.275L21.3365 19.2375V19.725H21.2617V19.8H21.4486V19.725H21.4112V19.1625Z"
          fill={color ?? 'url(#paint180_linear_486_666)'}
        />
        <path
          d="M17.7851 20.25H17.7103L17.5981 20.2875L17.6355 20.3625L17.7103 20.325V20.8125H17.6355V20.8875H17.8224V20.8125H17.7851V20.25Z"
          fill={color ?? 'url(#paint181_linear_486_666)'}
        />
        <path
          d="M21.486 15.9375L21.4486 15.9C21.4112 15.9 21.4112 15.9 21.3738 15.9C21.3365 15.9 21.3365 15.9 21.2991 15.9C21.2617 15.9 21.2617 15.9375 21.2617 15.9375L21.2243 15.975C21.2243 16.0125 21.2243 16.0125 21.2243 16.05V16.425C21.2243 16.4625 21.2243 16.4625 21.2243 16.5C21.2243 16.5375 21.2617 16.575 21.2991 16.575C21.3365 16.575 21.3365 16.575 21.3738 16.575C21.4112 16.575 21.4112 16.575 21.4486 16.575C21.486 16.575 21.486 16.5375 21.486 16.5375L21.5234 16.5C21.5234 16.4625 21.5234 16.4625 21.5234 16.425V16.05C21.5234 16.0125 21.5234 16.0125 21.5234 15.975C21.5234 15.975 21.5234 15.9375 21.486 15.9375ZM21.4486 16.3875C21.4486 16.425 21.4486 16.425 21.4486 16.3875C21.4486 16.425 21.4486 16.425 21.4112 16.425C21.4112 16.425 21.4112 16.425 21.3738 16.425C21.3738 16.425 21.3738 16.425 21.3365 16.425H21.2991C21.2991 16.425 21.2991 16.425 21.2617 16.425C21.2617 16.425 21.2617 16.425 21.2617 16.3875C21.2617 16.3875 21.2617 16.3875 21.2617 16.35V15.975V15.9375C21.2617 15.9375 21.2617 15.9375 21.2617 15.9C21.2617 15.9 21.2617 15.9 21.2991 15.9C21.2991 15.9 21.2991 15.9 21.3365 15.9H21.3738C21.3738 15.9 21.3738 15.9 21.4112 15.9C21.4112 15.9 21.4112 15.9 21.4112 15.9375C21.4112 15.9375 21.4112 15.9375 21.4112 15.975L21.4486 16.3875Z"
          fill={color ?? 'url(#paint182_linear_486_666)'}
        />
        <path
          d="M21.486 18.1125L21.4486 18.075C21.4112 18.075 21.4112 18.075 21.3738 18.075C21.3365 18.075 21.3365 18.075 21.2991 18.075C21.2617 18.075 21.2617 18.1125 21.2617 18.1125L21.2243 18.15C21.2243 18.1875 21.2243 18.1875 21.2243 18.225V18.6C21.2243 18.6375 21.2243 18.6375 21.2243 18.675C21.2243 18.7125 21.2617 18.7125 21.2617 18.7125L21.2991 18.75C21.3365 18.75 21.3365 18.75 21.3738 18.75C21.4112 18.75 21.4112 18.75 21.4486 18.75C21.486 18.75 21.486 18.7125 21.486 18.7125L21.5234 18.675C21.5234 18.6375 21.5234 18.6375 21.5234 18.6V18.225C21.5234 18.1875 21.5234 18.1875 21.5234 18.15C21.5234 18.15 21.5234 18.15 21.486 18.1125ZM21.4486 18.6C21.4486 18.6375 21.4486 18.6375 21.4112 18.6375C21.4112 18.6375 21.4112 18.6375 21.3738 18.6375C21.3738 18.6375 21.3738 18.6375 21.3365 18.6375C21.2991 18.6375 21.2991 18.6375 21.2991 18.6375C21.2991 18.6375 21.2991 18.6375 21.2617 18.6375C21.2617 18.6375 21.2617 18.6375 21.2617 18.6C21.2617 18.6 21.2617 18.6 21.2617 18.5625V18.1875V18.15C21.2617 18.15 21.2617 18.15 21.2617 18.1125C21.2617 18.1125 21.2617 18.1125 21.2991 18.1125C21.2991 18.1125 21.2991 18.1125 21.3365 18.1125H21.3738C21.3738 18.1125 21.3738 18.1125 21.4112 18.1125C21.4112 18.1125 21.4112 18.1125 21.4112 18.15C21.4112 18.15 21.4112 18.15 21.4112 18.1875L21.4486 18.6Z"
          fill={color ?? 'url(#paint183_linear_486_666)'}
        />
        <path
          d="M22.1589 8.24999L22.1215 8.21249C22.0841 8.21249 22.0841 8.21249 22.0467 8.21249C22.0093 8.21249 22.0093 8.21249 21.972 8.21249C21.972 8.24999 21.972 8.24999 21.9346 8.24999L21.8972 8.28749C21.8972 8.32499 21.8972 8.32499 21.8972 8.36249V8.73749C21.8972 8.77499 21.8972 8.77499 21.8972 8.81249C21.8972 8.84999 21.9346 8.84999 21.9346 8.84999L21.972 8.88749C22.0093 8.88749 22.0093 8.88749 22.0467 8.88749C22.0841 8.88749 22.0841 8.88749 22.1215 8.88749L22.1589 8.84999L22.1963 8.81249C22.1963 8.77499 22.1963 8.77499 22.1963 8.73749V8.36249C22.1963 8.32499 22.1963 8.32499 22.1963 8.28749C22.1963 8.28749 22.1963 8.28749 22.1589 8.24999ZM22.1215 8.73749C22.1215 8.73749 22.1215 8.77499 22.1215 8.73749C22.1215 8.77499 22.1215 8.77499 22.0841 8.77499C22.0841 8.77499 22.0841 8.77499 22.0467 8.77499C22.0467 8.77499 22.0467 8.77499 22.0093 8.77499H21.972L21.9346 8.73749C21.9346 8.73749 21.9346 8.73749 21.9346 8.69999V8.32499V8.28749C21.9346 8.28749 21.9346 8.28749 21.9346 8.24999C21.9346 8.24999 21.9346 8.24999 21.972 8.24999C21.972 8.24999 21.972 8.24999 22.0093 8.24999H22.0467C22.0467 8.24999 22.0467 8.24999 22.0841 8.24999C22.0841 8.24999 22.0841 8.24999 22.0841 8.28749C22.0841 8.28749 22.0841 8.28749 22.0841 8.32499L22.1215 8.73749Z"
          fill={color ?? 'url(#paint184_linear_486_666)'}
        />
        <path
          d="M22.1589 9.3H22.0841L22.0093 9.375L22.0467 9.45L22.1215 9.4125V9.9H22.0467V9.975H22.2336V9.9H22.1963V9.3H22.1589Z"
          fill={color ?? 'url(#paint185_linear_486_666)'}
        />
        <path
          d="M22.1589 7.725V7.125H22.0841L21.972 7.1625L22.0093 7.2375L22.0841 7.2V7.6875H22.0093V7.7625H22.1963V7.6875H22.1589V7.725Z"
          fill={color ?? 'url(#paint186_linear_486_666)'}
        />
        <path
          d="M22.1589 10.4625L22.1215 10.425C22.0841 10.425 22.0841 10.425 22.0467 10.425C22.0093 10.425 22.0093 10.425 21.972 10.425C21.9346 10.425 21.9346 10.4625 21.9346 10.4625C21.8972 10.5 21.8972 10.5375 21.8972 10.575V10.95C21.8972 10.9875 21.8972 10.9875 21.8972 11.025C21.8972 11.0625 21.9346 11.0625 21.9346 11.0625L21.972 11.1C22.0093 11.1 22.0093 11.1 22.0467 11.1C22.0841 11.1 22.0841 11.1 22.1215 11.1L22.1589 11.0625L22.1963 11.025C22.1963 10.9875 22.1963 10.9875 22.1963 10.95V10.575C22.1963 10.5375 22.1963 10.5375 22.1963 10.5C22.1963 10.5 22.1963 10.4625 22.1589 10.4625ZM22.1215 10.9125C22.1215 10.95 22.1215 10.95 22.1215 10.9125C22.1215 10.95 22.1215 10.95 22.0841 10.95C22.0841 10.95 22.0841 10.95 22.0467 10.95C22.0467 10.95 22.0467 10.95 22.0093 10.95C21.972 10.95 21.972 10.95 21.972 10.95C21.972 10.95 21.972 10.95 21.9346 10.95C21.9346 10.95 21.9346 10.95 21.9346 10.9125C21.9346 10.9125 21.9346 10.9125 21.9346 10.875V10.5V10.4625C21.9346 10.4625 21.9346 10.4625 21.9346 10.425C21.9346 10.425 21.9346 10.425 21.972 10.425C21.972 10.425 21.972 10.425 22.0093 10.425H22.0467C22.0467 10.425 22.0467 10.425 22.0841 10.425C22.0841 10.425 22.0841 10.425 22.0841 10.4625C22.0841 10.4625 22.0841 10.4625 22.0841 10.5L22.1215 10.9125Z"
          fill={color ?? 'url(#paint187_linear_486_666)'}
        />
        <path
          d="M22.1589 17.025L22.1215 16.9875C22.0841 16.9875 22.0841 16.9875 22.0467 16.9875C22.0093 16.9875 22.0093 16.9875 21.972 16.9875C21.9346 16.9875 21.9346 17.025 21.9346 17.025L21.8972 17.0625C21.8972 17.1 21.8972 17.1 21.8972 17.1375V17.5125C21.8972 17.55 21.8972 17.55 21.8972 17.5875C21.8972 17.625 21.9346 17.625 21.9346 17.625L21.972 17.6625C22.0093 17.6625 22.0093 17.6625 22.0467 17.6625C22.0841 17.6625 22.0841 17.6625 22.1215 17.6625L22.1589 17.625L22.1963 17.5875C22.1963 17.55 22.1963 17.55 22.1963 17.5125V17.1375C22.1963 17.1 22.1963 17.1 22.1963 17.0625C22.1963 17.0625 22.1963 17.025 22.1589 17.025ZM22.1215 17.5125C22.1215 17.55 22.1215 17.55 22.0841 17.55C22.0841 17.55 22.0841 17.55 22.0467 17.55C22.0467 17.55 22.0467 17.55 22.0093 17.55H21.972C21.972 17.55 21.972 17.55 21.9346 17.55C21.9346 17.55 21.9346 17.55 21.9346 17.5125C21.9346 17.5125 21.9346 17.5125 21.9346 17.475V17.1V17.0625C21.9346 17.0625 21.9346 17.0625 21.9346 17.025C21.9346 17.025 21.9346 17.025 21.972 17.025C21.972 17.025 21.972 17.025 22.0093 17.025H22.0467C22.0467 17.025 22.0467 17.025 22.0841 17.025C22.0841 17.025 22.0841 17.025 22.0841 17.0625C22.0841 17.0625 22.0841 17.0625 22.0841 17.1L22.1215 17.5125Z"
          fill={color ?? 'url(#paint188_linear_486_666)'}
        />
        <path
          d="M19.8411 19.275V19.7625H19.7664V19.8375H19.9533V19.7625H19.9159V19.1625H19.8411L19.729 19.2L19.7664 19.275H19.8411Z"
          fill={color ?? 'url(#paint189_linear_486_666)'}
        />
        <path
          d="M22.1589 15.9H22.0841L21.972 15.9375L22.0093 16.0125L22.0841 15.975V16.4625H22.0093V16.5375H22.1963V16.4625H22.1589V15.9Z"
          fill={color ?? 'url(#paint190_linear_486_666)'}
        />
        <path
          d="M22.1589 11.5125H22.0841L21.972 11.55L22.0093 11.625L22.0841 11.5875V12.075H22.0093V12.15H22.1963V12.075H22.1589V11.5125Z"
          fill={color ?? 'url(#paint191_linear_486_666)'}
        />
        <path
          d="M22.1589 13.6875H22.0841L21.972 13.725L22.0093 13.8L22.0841 13.7625V14.25H22.0093V14.325H22.1963V14.25H22.1589V13.6875Z"
          fill={color ?? 'url(#paint192_linear_486_666)'}
        />
        <path
          d="M22.1589 14.85C22.1215 14.8125 22.1215 14.8125 22.0841 14.8125C22.0467 14.8125 22.0093 14.8125 22.0093 14.8125C21.972 14.8125 21.972 14.85 21.972 14.85C21.9346 14.8875 21.9346 14.925 21.9346 14.9625V15.3375C21.9346 15.375 21.9346 15.375 21.9346 15.4125C21.9346 15.45 21.972 15.45 21.972 15.45L22.0093 15.4875C22.0467 15.4875 22.0467 15.4875 22.0841 15.4875C22.1215 15.4875 22.1215 15.4875 22.1589 15.4875L22.1963 15.45L22.2336 15.4125C22.2336 15.375 22.2336 15.375 22.2336 15.3375V14.9625C22.2336 14.925 22.2336 14.925 22.2336 14.8875C22.1963 14.85 22.1963 14.85 22.1589 14.85ZM22.1215 15.3C22.1215 15.3 22.1215 15.3375 22.1215 15.3C22.1215 15.3375 22.1215 15.3375 22.0841 15.3375C22.0841 15.3375 22.0841 15.3375 22.0467 15.3375C22.0467 15.3375 22.0467 15.3375 22.0093 15.3375C21.972 15.3375 21.972 15.3375 21.972 15.3375C21.972 15.3375 21.972 15.3375 21.9346 15.3375C21.9346 15.3375 21.9346 15.3375 21.9346 15.3C21.9346 15.3 21.9346 15.3 21.9346 15.2625V14.8875V14.85C21.9346 14.85 21.9346 14.85 21.9346 14.8125C21.9346 14.8125 21.9346 14.8125 21.972 14.8125C21.972 14.8125 21.972 14.8125 22.0093 14.8125H22.0467C22.0467 14.8125 22.0467 14.8125 22.0841 14.8125C22.0841 14.8125 22.0841 14.8125 22.0841 14.85C22.0841 14.85 22.0841 14.85 22.0841 14.8875L22.1215 15.3Z"
          fill={color ?? 'url(#paint193_linear_486_666)'}
        />
        <path
          d="M20.028 11.55L19.9907 11.5125C19.9533 11.5125 19.9533 11.5125 19.9159 11.5125C19.8785 11.5125 19.8785 11.5125 19.8411 11.5125C19.8037 11.5125 19.8037 11.55 19.8037 11.55L19.7664 11.5875C19.7664 11.625 19.7664 11.625 19.7664 11.6625V12.0375C19.7664 12.075 19.7664 12.075 19.7664 12.1125C19.7664 12.15 19.8037 12.15 19.8037 12.15L19.8411 12.1875C19.8785 12.1875 19.8785 12.1875 19.9159 12.1875C19.9533 12.1875 19.9533 12.1875 19.9907 12.1875L20.028 12.15L20.0654 12.1125C20.0654 12.075 20.0654 12.075 20.0654 12.0375V11.6625C20.0654 11.625 20.0654 11.625 20.0654 11.5875L20.028 11.55ZM19.9907 12.0375C19.9907 12.075 19.9907 12.075 19.9533 12.075C19.9533 12.075 19.9533 12.075 19.9159 12.075C19.9159 12.075 19.9159 12.075 19.8785 12.075C19.8411 12.075 19.8411 12.075 19.8411 12.075C19.8411 12.075 19.8411 12.075 19.8037 12.075C19.8037 12.075 19.8037 12.075 19.8037 12.0375C19.8037 12.0375 19.8037 12.0375 19.8037 12V11.625V11.5875C19.8037 11.5875 19.8037 11.5875 19.8037 11.55C19.8037 11.55 19.8411 11.55 19.8411 11.5125H19.8785C19.8785 11.5125 19.8785 11.5125 19.9159 11.5125C19.9159 11.5125 19.9159 11.5125 19.9159 11.55C19.9159 11.55 19.9159 11.55 19.9159 11.5875V12.0375H19.9907Z"
          fill={color ?? 'url(#paint194_linear_486_666)'}
        />
        <path
          d="M20.028 7.1625L19.9907 7.125C19.9533 7.125 19.9533 7.125 19.9159 7.125C19.8785 7.125 19.8785 7.125 19.8411 7.125C19.8037 7.125 19.8037 7.1625 19.8037 7.1625L19.7664 7.2C19.7664 7.2375 19.7664 7.2375 19.7664 7.275V7.65C19.7664 7.6875 19.7664 7.6875 19.7664 7.725C19.7664 7.7625 19.8037 7.7625 19.8037 7.7625L19.8411 7.8C19.8785 7.8 19.8785 7.8 19.9159 7.8C19.9533 7.8 19.9533 7.8 19.9907 7.8C20.028 7.8 20.0654 7.7625 20.0654 7.725C20.0654 7.6875 20.0654 7.6875 20.0654 7.65V7.275C20.0654 7.2375 20.0654 7.2375 20.0654 7.2C20.0654 7.2 20.028 7.2 20.028 7.1625ZM19.9907 7.65C19.9907 7.6875 19.9907 7.6875 19.9533 7.6875C19.9533 7.6875 19.9533 7.6875 19.9159 7.6875C19.9159 7.6875 19.9159 7.6875 19.8785 7.6875C19.8411 7.6875 19.8411 7.6875 19.8411 7.6875C19.8411 7.6875 19.8411 7.6875 19.8037 7.6875C19.8037 7.6875 19.8037 7.6875 19.8037 7.65C19.8037 7.65 19.8037 7.65 19.8037 7.6125V7.2375V7.2C19.8037 7.2 19.8037 7.2 19.8037 7.1625C19.8037 7.1625 19.8037 7.1625 19.8411 7.1625C19.8411 7.1625 19.8411 7.1625 19.8785 7.1625H19.9159C19.9159 7.1625 19.9159 7.1625 19.9533 7.1625C19.9533 7.1625 19.9533 7.1625 19.9533 7.2C19.9533 7.2 19.9533 7.2 19.9533 7.2375L19.9907 7.65Z"
          fill={color ?? 'url(#paint195_linear_486_666)'}
        />
        <path
          d="M20.028 9.375L19.9907 9.3375C19.9533 9.3375 19.9533 9.3375 19.9159 9.3375C19.8785 9.3375 19.8785 9.3375 19.8411 9.3375C19.8037 9.3375 19.8037 9.375 19.8037 9.375L19.7664 9.4125C19.7664 9.45 19.7664 9.45 19.7664 9.4875V9.8625C19.7664 9.9 19.7664 9.9 19.7664 9.9375C19.7664 9.975 19.8037 9.975 19.8037 9.975L19.8411 10.0125C19.8785 10.0125 19.8785 10.0125 19.9159 10.0125C19.9533 10.0125 19.9533 10.0125 19.9907 10.0125L20.028 9.975L20.0654 9.9375C20.0654 9.9 20.0654 9.9 20.0654 9.8625V9.4875C20.0654 9.45 20.0654 9.45 20.0654 9.4125C20.0654 9.375 20.028 9.375 20.028 9.375ZM19.9907 9.825C19.9907 9.825 19.9907 9.8625 19.9907 9.825C19.9907 9.8625 19.9907 9.8625 19.9533 9.8625C19.9533 9.8625 19.9533 9.8625 19.9159 9.8625C19.9159 9.8625 19.9159 9.8625 19.8785 9.8625C19.8411 9.8625 19.8411 9.8625 19.8411 9.8625L19.8037 9.825C19.8037 9.825 19.8037 9.825 19.8037 9.7875V9.4125V9.375C19.8037 9.375 19.8037 9.375 19.8037 9.3375C19.8037 9.3375 19.8411 9.3375 19.8411 9.3H19.8785C19.8785 9.3 19.8785 9.3 19.9159 9.3C19.9159 9.3 19.9159 9.3 19.9159 9.3375C19.9159 9.3375 19.9159 9.3375 19.9159 9.375V9.825H19.9907Z"
          fill={color ?? 'url(#paint196_linear_486_666)'}
        />
        <path
          d="M20.6262 20.2875L20.514 20.325L20.5514 20.4L20.6262 20.3625V20.625L20.7009 20.5875V20.25L20.6262 20.2875Z"
          fill={color ?? 'url(#paint197_linear_486_666)'}
        />
        <path
          d="M20.028 15.9375L19.9907 15.9C19.9533 15.9 19.9533 15.9 19.9159 15.9C19.8785 15.9 19.8785 15.9 19.8411 15.9C19.8037 15.9 19.8037 15.9375 19.8037 15.9375L19.7664 15.975C19.7664 16.0125 19.7664 16.0125 19.7664 16.05V16.425C19.7664 16.4625 19.7664 16.4625 19.7664 16.5C19.7664 16.5375 19.8037 16.5375 19.8037 16.5375L19.8411 16.575C19.8785 16.575 19.8785 16.575 19.9159 16.575C19.9533 16.575 19.9533 16.575 19.9907 16.575L20.028 16.5375L20.0654 16.5C20.0654 16.4625 20.0654 16.4625 20.0654 16.425V16.05C20.0654 16.0125 20.0654 16.0125 20.0654 15.975L20.028 15.9375ZM19.9907 16.3875C19.9907 16.425 19.9907 16.425 19.9907 16.3875C19.9907 16.425 19.9907 16.425 19.9533 16.425C19.9533 16.425 19.9533 16.425 19.9159 16.425H19.8785C19.8785 16.425 19.8411 16.425 19.8411 16.3875C19.8411 16.3875 19.8411 16.3875 19.8411 16.35C19.8411 16.35 19.8411 16.35 19.8411 16.3125V15.9375V15.9C19.8411 15.9 19.8411 15.9 19.8411 15.8625C19.8411 15.8625 19.8411 15.8625 19.8785 15.8625C19.8785 15.8625 19.8785 15.8625 19.9159 15.8625H19.9533C19.9533 15.8625 19.9533 15.8625 19.9907 15.8625C19.9907 15.8625 19.9907 15.8625 19.9907 15.9C19.9907 15.9 19.9907 15.9 19.9907 15.9375V16.3875Z"
          fill={color ?? 'url(#paint198_linear_486_666)'}
        />
        <path
          d="M20.028 20.325L19.9907 20.2875C19.9533 20.2875 19.9533 20.2875 19.9159 20.2875C19.8785 20.2875 19.8785 20.2875 19.8411 20.2875C19.8037 20.2875 19.8037 20.325 19.8037 20.325L19.7664 20.3625C19.7664 20.4 19.7664 20.4 19.7664 20.4375V20.8125C19.7664 20.85 19.7664 20.85 19.7664 20.8875C19.7664 20.925 19.8037 20.925 19.8037 20.925L19.8411 20.9625C19.8785 20.9625 19.8785 20.9625 19.9159 20.9625C19.9533 20.9625 19.9533 20.9625 19.9907 20.9625L20.028 20.925L20.0654 20.8875C20.0654 20.85 20.0654 20.85 20.0654 20.8125V20.4375C20.0654 20.4 20.0654 20.4 20.0654 20.3625C20.0654 20.325 20.028 20.325 20.028 20.325ZM19.9907 20.775C19.9907 20.775 19.9907 20.8125 19.9907 20.775C19.9907 20.8125 19.9907 20.8125 19.9533 20.8125C19.9533 20.8125 19.9533 20.8125 19.9159 20.8125C19.9159 20.8125 19.9159 20.8125 19.8785 20.8125C19.8411 20.8125 19.8411 20.8125 19.8411 20.8125C19.8411 20.8125 19.8411 20.8125 19.8037 20.8125C19.8037 20.8125 19.8037 20.8125 19.8037 20.775C19.8037 20.775 19.8037 20.775 19.8037 20.7375V20.3625V20.325C19.8037 20.325 19.8037 20.325 19.8037 20.2875C19.8037 20.2875 19.8037 20.2875 19.8411 20.2875C19.8411 20.2875 19.8411 20.2875 19.8785 20.2875H19.9159C19.9159 20.2875 19.9159 20.2875 19.9533 20.2875C19.9533 20.2875 19.9533 20.2875 19.9533 20.325C19.9533 20.325 19.9533 20.325 19.9533 20.3625V20.775H19.9907Z"
          fill={color ?? 'url(#paint199_linear_486_666)'}
        />
        <path
          d="M20.028 18.1125L19.9907 18.075C19.9533 18.075 19.9159 18.075 19.9159 18.075C19.8785 18.075 19.8411 18.1125 19.8411 18.1125L19.8037 18.15C19.8037 18.1875 19.8037 18.1875 19.8037 18.225V18.6C19.8037 18.6375 19.8037 18.6375 19.8037 18.675C19.8037 18.7125 19.8411 18.7125 19.8411 18.7125L19.8785 18.75C19.9159 18.75 19.9159 18.75 19.9533 18.75C19.9907 18.75 19.9907 18.75 20.028 18.75L20.0654 18.7125L20.1028 18.675C20.1028 18.6375 20.1028 18.6375 20.1028 18.6V18.225C20.1028 18.1875 20.1028 18.1875 20.1028 18.15C20.0654 18.15 20.028 18.15 20.028 18.1125ZM19.9907 18.6C19.9907 18.6375 19.9907 18.6375 19.9533 18.6375C19.9533 18.6375 19.9533 18.6375 19.9159 18.6375H19.8785C19.8785 18.6375 19.8411 18.6375 19.8411 18.6C19.8411 18.6 19.8411 18.6 19.8411 18.5625C19.8411 18.5625 19.8411 18.5625 19.8411 18.525V18.15V18.1125C19.8411 18.1125 19.8411 18.1125 19.8411 18.075C19.8411 18.075 19.8411 18.075 19.8785 18.075C19.8785 18.075 19.8785 18.075 19.9159 18.075H19.9533L19.9907 18.1125C19.9907 18.1125 19.9907 18.1125 19.9907 18.15V18.6Z"
          fill={color ?? 'url(#paint200_linear_486_666)'}
        />
        <path
          d="M20.028 13.725L19.9907 13.6875C19.9533 13.6875 19.9533 13.6875 19.9159 13.6875C19.8785 13.6875 19.8785 13.6875 19.8411 13.6875C19.8037 13.6875 19.7664 13.725 19.7664 13.7625C19.7664 13.8 19.7664 13.8 19.7664 13.8375V14.2125C19.7664 14.25 19.7664 14.25 19.7664 14.2875C19.7664 14.325 19.8037 14.325 19.8037 14.325L19.8411 14.3625C19.8785 14.3625 19.8785 14.3625 19.9159 14.3625C19.9533 14.3625 19.9533 14.3625 19.9907 14.3625C20.028 14.3625 20.028 14.325 20.028 14.325L20.0654 14.2875C20.0654 14.25 20.0654 14.25 20.0654 14.2125V13.8375C20.0654 13.8 20.0654 13.8 20.0654 13.7625C20.0654 13.7625 20.028 13.7625 20.028 13.725ZM19.9907 14.2125C19.9907 14.2125 19.9907 14.25 19.9907 14.2125C19.9907 14.25 19.9907 14.25 19.9533 14.25C19.9533 14.25 19.9533 14.25 19.9159 14.25C19.9159 14.25 19.9159 14.25 19.8785 14.25C19.8411 14.25 19.8411 14.25 19.8411 14.25C19.8411 14.25 19.8411 14.25 19.8037 14.25C19.8037 14.25 19.8037 14.25 19.8037 14.2125V14.175V13.8V13.7625C19.8037 13.7625 19.8037 13.7625 19.8037 13.725C19.8037 13.725 19.8037 13.725 19.8411 13.725C19.8411 13.725 19.8411 13.725 19.8785 13.725H19.9159L19.9533 13.7625C19.9533 13.7625 19.9533 13.7625 19.9533 13.8V14.2125H19.9907Z"
          fill={color ?? 'url(#paint201_linear_486_666)'}
        />
        <path
          d="M20.7009 19.2L20.6635 19.1625C20.6262 19.1625 20.6262 19.1625 20.5888 19.1625C20.5514 19.1625 20.5514 19.1625 20.514 19.1625C20.4766 19.1625 20.4766 19.2 20.4766 19.2L20.4392 19.2375C20.4392 19.275 20.4392 19.275 20.4392 19.3125V19.6875C20.4392 19.725 20.4392 19.725 20.4392 19.7625C20.4392 19.8 20.4766 19.8375 20.514 19.8375C20.5514 19.8375 20.5514 19.8375 20.5888 19.8375C20.6262 19.8375 20.6262 19.8375 20.6635 19.8375L20.7009 19.8L20.7383 19.7625C20.7383 19.725 20.7383 19.725 20.7383 19.6875V19.3125C20.7383 19.275 20.7383 19.275 20.7383 19.2375C20.7383 19.2375 20.7383 19.2375 20.7009 19.2ZM20.6635 19.6875C20.6635 19.725 20.6635 19.725 20.6262 19.725C20.6262 19.725 20.6262 19.725 20.5888 19.725C20.5888 19.725 20.5888 19.725 20.5514 19.725H20.514C20.514 19.725 20.514 19.725 20.4766 19.725C20.4766 19.725 20.4766 19.725 20.4766 19.6875C20.4766 19.6875 20.4766 19.6875 20.4766 19.65V19.275V19.2375C20.4766 19.2375 20.4766 19.2375 20.4766 19.2C20.4766 19.2 20.4766 19.2 20.514 19.2C20.514 19.2 20.514 19.2 20.5514 19.2H20.5888C20.5888 19.2 20.5888 19.2 20.6262 19.2C20.6262 19.2 20.6262 19.2 20.6262 19.2375C20.6262 19.2375 20.6262 19.2375 20.6262 19.275L20.6635 19.6875Z"
          fill={color ?? 'url(#paint202_linear_486_666)'}
        />
        <path
          d="M20.7009 18.075H20.6262L20.514 18.1125L20.5514 18.1875L20.6262 18.15V18.6375H20.5514V18.75H20.7383V18.675H20.7009V18.075Z"
          fill={color ?? 'url(#paint203_linear_486_666)'}
        />
        <path
          d="M20.7009 11.5125H20.6262L20.514 11.55L20.5514 11.625L20.6262 11.5875V12.075H20.5514V12.15H20.7383V12.075H20.7009V11.5125Z"
          fill={color ?? 'url(#paint204_linear_486_666)'}
        />
        <path
          d="M3.16824 7.125H3.09347L2.98132 7.1625L3.01871 7.2375L3.09347 7.2V7.6875H3.01871V7.7625H3.20562V7.6875H3.16824V7.125Z"
          fill={color ?? 'url(#paint205_linear_486_666)'}
        />
        <path
          d="M20.7009 12.6375L20.6635 12.6C20.6262 12.6 20.6262 12.6 20.5888 12.6C20.5514 12.6 20.5514 12.6 20.514 12.6C20.4766 12.6 20.4766 12.6375 20.4766 12.6375L20.4392 12.675C20.4392 12.7125 20.4392 12.7125 20.4392 12.75V13.125C20.4392 13.1625 20.4392 13.1625 20.4392 13.2C20.4392 13.2375 20.4766 13.2375 20.4766 13.2375L20.514 13.275C20.5514 13.275 20.5514 13.275 20.5888 13.275C20.6262 13.275 20.6262 13.275 20.6635 13.275C20.7009 13.275 20.7009 13.2375 20.7009 13.2375L20.7383 13.2C20.7383 13.1625 20.7383 13.1625 20.7383 13.125V12.75C20.7383 12.7125 20.7383 12.7125 20.7383 12.675C20.7383 12.675 20.7383 12.675 20.7009 12.6375ZM20.6635 13.125C20.6635 13.1625 20.6635 13.1625 20.6262 13.1625C20.6262 13.1625 20.6262 13.1625 20.5888 13.1625C20.5888 13.1625 20.5888 13.1625 20.5514 13.1625C20.514 13.1625 20.514 13.1625 20.514 13.1625C20.514 13.1625 20.514 13.1625 20.4766 13.1625C20.4766 13.1625 20.4766 13.1625 20.4766 13.125C20.4766 13.125 20.4766 13.125 20.4766 13.0875V12.7125V12.675C20.4766 12.675 20.4766 12.675 20.4766 12.6375C20.4766 12.6375 20.4766 12.6375 20.514 12.6375C20.514 12.6375 20.514 12.6375 20.5514 12.6375H20.5888C20.5888 12.6375 20.5888 12.6375 20.6262 12.6375C20.6262 12.6375 20.6262 12.6375 20.6262 12.675C20.6262 12.675 20.6262 12.675 20.6262 12.7125L20.6635 13.125Z"
          fill={color ?? 'url(#paint206_linear_486_666)'}
        />
        <path
          d="M20.7009 8.24999L20.6635 8.21249C20.6262 8.21249 20.5888 8.21249 20.5514 8.21249C20.514 8.21249 20.514 8.24999 20.514 8.24999L20.4766 8.28749C20.4766 8.32499 20.4766 8.32499 20.4766 8.36249V8.73749C20.4766 8.77499 20.4766 8.77499 20.4766 8.81249C20.4766 8.84999 20.514 8.84999 20.514 8.84999L20.5514 8.88749C20.5888 8.88749 20.5888 8.88749 20.6262 8.88749C20.6635 8.88749 20.6635 8.88749 20.7009 8.88749C20.7383 8.88749 20.7383 8.84999 20.7383 8.84999L20.7757 8.81249C20.7757 8.77499 20.7757 8.77499 20.7757 8.73749V8.36249C20.7757 8.32499 20.7757 8.32499 20.7757 8.28749C20.7383 8.28749 20.7383 8.28749 20.7009 8.24999ZM20.6635 8.73749C20.6635 8.73749 20.6635 8.77499 20.6635 8.73749C20.6635 8.77499 20.6635 8.77499 20.6262 8.77499C20.6262 8.77499 20.5888 8.77499 20.5888 8.81249H20.5514C20.5514 8.81249 20.5514 8.81249 20.514 8.81249C20.514 8.81249 20.514 8.81249 20.514 8.77499C20.514 8.77499 20.514 8.77499 20.514 8.73749V8.36249V8.32499C20.514 8.32499 20.514 8.32499 20.514 8.28749C20.514 8.28749 20.514 8.28749 20.5514 8.28749C20.5514 8.28749 20.5514 8.28749 20.5888 8.28749H20.6262C20.6262 8.28749 20.6262 8.28749 20.6635 8.28749C20.6635 8.28749 20.6635 8.28749 20.6635 8.32499C20.6635 8.32499 20.6635 8.32499 20.6635 8.36249V8.73749Z"
          fill={color ?? 'url(#paint207_linear_486_666)'}
        />
        <path
          d="M20.7009 9.3H20.6262L20.514 9.375L20.5514 9.45L20.6262 9.4125V9.9H20.5514V9.975H20.7383V9.9H20.7009V9.3Z"
          fill={color ?? 'url(#paint208_linear_486_666)'}
        />
        <path
          d="M20.7009 17.025L20.6635 16.9875C20.6262 16.9875 20.6262 16.9875 20.5888 16.9875C20.5514 16.9875 20.5514 16.9875 20.514 16.9875C20.4766 16.9875 20.4766 17.025 20.4766 17.025L20.4392 17.0625C20.4392 17.1 20.4392 17.1 20.4392 17.1375V17.5125C20.4392 17.55 20.4392 17.55 20.4392 17.5875L20.4766 17.625L20.514 17.6625C20.5514 17.6625 20.5514 17.6625 20.5888 17.6625C20.6262 17.6625 20.6262 17.6625 20.6635 17.6625C20.7009 17.6625 20.7009 17.625 20.7009 17.625L20.7383 17.5875C20.7383 17.55 20.7383 17.55 20.7383 17.5125V17.1375C20.7383 17.1 20.7383 17.1 20.7383 17.0625C20.7383 17.0625 20.7383 17.025 20.7009 17.025ZM20.6635 17.5125C20.6635 17.55 20.6635 17.55 20.6262 17.55C20.6262 17.55 20.6262 17.55 20.5888 17.55C20.5888 17.55 20.5888 17.55 20.5514 17.55C20.514 17.55 20.514 17.55 20.514 17.55C20.514 17.55 20.514 17.55 20.4766 17.55C20.4766 17.55 20.4766 17.55 20.4766 17.5125C20.4766 17.5125 20.4766 17.5125 20.4766 17.475V17.1V17.0625C20.4766 17.0625 20.4766 17.0625 20.4766 17.025C20.4766 17.025 20.4766 17.025 20.514 17.025C20.514 17.025 20.514 17.025 20.5514 17.025H20.5888C20.5888 17.025 20.5888 17.025 20.6262 17.025C20.6262 17.025 20.6262 17.025 20.6262 17.0625C20.6262 17.0625 20.6262 17.0625 20.6262 17.1L20.6635 17.5125Z"
          fill={color ?? 'url(#paint209_linear_486_666)'}
        />
        <path
          d="M20.7009 13.6875H20.6262L20.514 13.725L20.5514 13.8L20.6262 13.7625V14.25H20.5514V14.325H20.7383V14.25H20.7009V13.6875Z"
          fill={color ?? 'url(#paint210_linear_486_666)'}
        />
        <path
          d="M20.7009 15.9H20.6262L20.514 15.9375L20.5514 16.0125L20.6262 15.975V16.4625H20.5514V16.5375H20.7383V16.4625H20.7009V15.9Z"
          fill={color ?? 'url(#paint211_linear_486_666)'}
        />
        <path
          d="M20.7009 14.85L20.6635 14.8125C20.6262 14.8125 20.6262 14.8125 20.5888 14.8125C20.5514 14.8125 20.5514 14.8125 20.514 14.8125C20.4766 14.8125 20.4766 14.85 20.4766 14.85L20.4392 14.8875C20.4392 14.925 20.4392 14.925 20.4392 14.9625V15.3375C20.4392 15.375 20.4392 15.375 20.4392 15.4125C20.4392 15.45 20.4766 15.45 20.4766 15.45L20.514 15.4875C20.5514 15.4875 20.5514 15.4875 20.5888 15.4875C20.6262 15.4875 20.6262 15.4875 20.6635 15.4875L20.7009 15.45L20.7383 15.4125C20.7383 15.375 20.7383 15.375 20.7383 15.3375V14.9625C20.7383 14.925 20.7383 14.925 20.7383 14.8875C20.7383 14.85 20.7383 14.85 20.7009 14.85ZM20.6635 15.3C20.6635 15.3 20.6635 15.3375 20.6635 15.3C20.6635 15.3375 20.6635 15.3375 20.6262 15.3375C20.6262 15.3375 20.6262 15.3375 20.5888 15.3375C20.5888 15.3375 20.5888 15.3375 20.5514 15.3375H20.514C20.514 15.3375 20.514 15.3375 20.4766 15.3375C20.4766 15.3375 20.4766 15.3375 20.4766 15.3C20.4766 15.3 20.4766 15.3 20.4766 15.2625V14.8875V14.85C20.4766 14.85 20.4766 14.85 20.4766 14.8125C20.4766 14.8125 20.4766 14.8125 20.514 14.8125C20.514 14.8125 20.514 14.8125 20.5514 14.8125H20.5888C20.5888 14.8125 20.5888 14.8125 20.6262 14.8125C20.6262 14.8125 20.6262 14.8125 20.6262 14.85C20.6262 14.85 20.6262 14.85 20.6262 14.8875L20.6635 15.3Z"
          fill={color ?? 'url(#paint212_linear_486_666)'}
        />
        <path
          d="M20.7009 10.4625L20.6635 10.425C20.6262 10.425 20.6262 10.425 20.5888 10.425C20.5514 10.425 20.5514 10.425 20.514 10.425C20.4766 10.425 20.4766 10.4625 20.4766 10.4625L20.4392 10.5C20.4392 10.5375 20.4392 10.5375 20.4392 10.575V10.95C20.4392 10.9875 20.4392 10.9875 20.4392 11.025C20.4392 11.0625 20.4766 11.0625 20.4766 11.0625L20.514 11.1C20.5514 11.1 20.5514 11.1 20.5888 11.1C20.6262 11.1 20.6262 11.1 20.6635 11.1L20.7009 11.0625L20.7383 11.025C20.7383 10.9875 20.7383 10.9875 20.7383 10.95V10.575C20.7383 10.5375 20.7383 10.5375 20.7383 10.5C20.7383 10.5 20.7383 10.4625 20.7009 10.4625ZM20.6635 10.9125C20.6635 10.95 20.6635 10.95 20.6635 10.9125C20.6635 10.95 20.6635 10.95 20.6262 10.95C20.6262 10.95 20.6262 10.95 20.5888 10.95C20.5888 10.95 20.5888 10.95 20.5514 10.95H20.514C20.514 10.95 20.514 10.95 20.4766 10.95C20.4766 10.95 20.4766 10.95 20.4766 10.9125C20.4766 10.9125 20.4766 10.9125 20.4766 10.875V10.5V10.4625C20.4766 10.4625 20.4766 10.4625 20.4766 10.425C20.4766 10.425 20.4766 10.425 20.514 10.425C20.514 10.425 20.514 10.425 20.5514 10.425H20.5888C20.5888 10.425 20.5888 10.425 20.6262 10.425C20.6262 10.425 20.6262 10.425 20.6262 10.4625C20.6262 10.4625 20.6262 10.4625 20.6262 10.5L20.6635 10.9125Z"
          fill={color ?? 'url(#paint213_linear_486_666)'}
        />
        <path
          d="M5.2243 19.275V19.7625H5.14954V19.8375H5.33645V19.7625H5.29907V19.1625H5.2243L5.11215 19.2L5.14954 19.275H5.2243Z"
          fill={color ?? 'url(#paint214_linear_486_666)'}
        />
        <path
          d="M5.2243 21.375L5.14954 21.4125L5.33645 21.525V21.375H5.2243Z"
          fill={color ?? 'url(#paint215_linear_486_666)'}
        />
        <path
          d="M5.41122 20.325L5.37384 20.2875C5.33645 20.2875 5.29907 20.2875 5.26169 20.2875C5.2243 20.2875 5.2243 20.325 5.2243 20.325L5.18692 20.3625C5.18692 20.4 5.18692 20.4 5.18692 20.4375V20.8125C5.18692 20.85 5.18692 20.8875 5.2243 20.925L5.26169 20.9625C5.29907 20.9625 5.29907 20.9625 5.33645 20.9625C5.37384 20.9625 5.37384 20.9625 5.41122 20.9625C5.4486 20.9625 5.4486 20.925 5.4486 20.925L5.48599 20.8875C5.48599 20.85 5.48599 20.85 5.48599 20.8125V20.4375C5.48599 20.4 5.48599 20.4 5.48599 20.3625C5.4486 20.325 5.41122 20.325 5.41122 20.325ZM5.37384 20.775C5.37384 20.775 5.37384 20.8125 5.37384 20.775C5.37384 20.8125 5.37384 20.8125 5.33645 20.8125C5.33645 20.8125 5.33645 20.8125 5.29907 20.8125H5.26169H5.2243C5.2243 20.8125 5.2243 20.8125 5.18692 20.8125C5.18692 20.8125 5.18692 20.8125 5.18692 20.775C5.18692 20.775 5.18692 20.775 5.18692 20.7375V20.3625V20.325C5.18692 20.325 5.18692 20.325 5.18692 20.2875C5.18692 20.2875 5.18692 20.2875 5.2243 20.2875C5.2243 20.2875 5.2243 20.2875 5.26169 20.2875H5.29907C5.29907 20.2875 5.29907 20.2875 5.33645 20.2875C5.33645 20.2875 5.33645 20.2875 5.33645 20.325C5.33645 20.325 5.33645 20.325 5.33645 20.3625L5.37384 20.775Z"
          fill={color ?? 'url(#paint216_linear_486_666)'}
        />
        <path
          d="M5.41122 15.9375L5.37383 15.9C5.33645 15.9 5.33645 15.9 5.29907 15.9C5.26169 15.9 5.26169 15.9 5.2243 15.9C5.18692 15.9 5.18692 15.9375 5.18692 15.9375L5.14954 15.975C5.14954 16.0125 5.14954 16.0125 5.14954 16.05V16.425C5.14954 16.4625 5.14954 16.4625 5.14954 16.5C5.14954 16.5375 5.18692 16.5375 5.18692 16.5375L5.2243 16.575C5.26169 16.575 5.26169 16.575 5.29907 16.575C5.33645 16.575 5.33645 16.575 5.37383 16.575C5.41122 16.575 5.41122 16.5375 5.41122 16.5375L5.4486 16.5C5.4486 16.4625 5.4486 16.4625 5.4486 16.425V16.05C5.4486 16.0125 5.4486 16.0125 5.4486 15.975L5.41122 15.9375ZM5.37383 16.3875C5.37383 16.425 5.37383 16.425 5.37383 16.3875C5.37383 16.425 5.37384 16.425 5.33645 16.425C5.33645 16.425 5.33645 16.425 5.29907 16.425C5.29907 16.425 5.29907 16.425 5.26169 16.425C5.2243 16.425 5.2243 16.425 5.2243 16.425C5.2243 16.425 5.2243 16.425 5.18692 16.425C5.18692 16.425 5.18692 16.425 5.18692 16.3875C5.18692 16.3875 5.18692 16.3875 5.18692 16.35V15.975V15.9375C5.18692 15.9375 5.18692 15.9375 5.18692 15.9C5.18692 15.9 5.18692 15.9 5.2243 15.9C5.2243 15.9 5.2243 15.9 5.26169 15.9H5.29907C5.29907 15.9 5.29907 15.9 5.33645 15.9C5.33645 15.9 5.33645 15.9 5.33645 15.9375C5.33645 15.9375 5.33645 15.9375 5.33645 15.975L5.37383 16.3875Z"
          fill={color ?? 'url(#paint217_linear_486_666)'}
        />
        <path
          d="M5.41122 18.1125L5.37383 18.075C5.33645 18.075 5.33645 18.075 5.29907 18.075C5.26169 18.075 5.26169 18.075 5.2243 18.075C5.18692 18.075 5.18692 18.1125 5.18692 18.1125L5.14954 18.15C5.14954 18.1875 5.14954 18.1875 5.14954 18.225V18.6C5.14954 18.6375 5.14954 18.6375 5.14954 18.675C5.14954 18.7125 5.18692 18.7125 5.18692 18.7125L5.2243 18.75C5.26169 18.75 5.26169 18.75 5.29907 18.75C5.33645 18.75 5.33645 18.75 5.37383 18.75C5.41122 18.75 5.41122 18.7125 5.41122 18.7125L5.4486 18.675C5.4486 18.6375 5.4486 18.6375 5.4486 18.6V18.225C5.4486 18.1875 5.4486 18.1875 5.4486 18.15C5.4486 18.15 5.41122 18.15 5.41122 18.1125ZM5.37383 18.6C5.37383 18.6375 5.37384 18.6375 5.33645 18.6375C5.33645 18.6375 5.33645 18.6375 5.29907 18.6375C5.29907 18.6375 5.29907 18.6375 5.26169 18.6375C5.2243 18.6375 5.2243 18.6375 5.2243 18.6375C5.2243 18.6375 5.2243 18.6375 5.18692 18.6375C5.18692 18.6375 5.18692 18.6375 5.18692 18.6C5.18692 18.6 5.18692 18.6 5.18692 18.5625V18.1875V18.15C5.18692 18.15 5.18692 18.15 5.18692 18.1125C5.18692 18.1125 5.18692 18.1125 5.2243 18.1125C5.2243 18.1125 5.2243 18.1125 5.26169 18.1125H5.29907C5.29907 18.1125 5.29907 18.1125 5.33645 18.1125C5.33645 18.1125 5.33645 18.1125 5.33645 18.15C5.33645 18.15 5.33645 18.15 5.33645 18.1875L5.37383 18.6Z"
          fill={color ?? 'url(#paint218_linear_486_666)'}
        />
        <path
          d="M4.62616 5.39999L4.55139 5.43749V5.51249H4.47662V5.62499H4.66354V5.54999H4.62616V5.39999Z"
          fill={color ?? 'url(#paint219_linear_486_666)'}
        />
        <path
          d="M4.62615 8.24999L4.58877 8.21249C4.55139 8.21249 4.55139 8.21249 4.514 8.21249C4.47662 8.21249 4.47662 8.21249 4.43924 8.21249C4.43924 8.24999 4.40185 8.24999 4.40185 8.24999L4.36447 8.28749C4.36447 8.32499 4.36447 8.32499 4.36447 8.36249V8.73749C4.36447 8.77499 4.36447 8.77499 4.36447 8.81249C4.36447 8.84999 4.40185 8.88749 4.43924 8.88749C4.47662 8.88749 4.47662 8.88749 4.514 8.88749C4.55139 8.88749 4.55139 8.88749 4.58877 8.88749L4.62615 8.84999L4.66354 8.81249C4.66354 8.77499 4.66354 8.77499 4.66354 8.73749V8.36249C4.66354 8.32499 4.66354 8.32499 4.66354 8.28749C4.66354 8.28749 4.62615 8.28749 4.62615 8.24999ZM4.58877 8.73749C4.58877 8.73749 4.58877 8.77499 4.58877 8.73749C4.58877 8.77499 4.58877 8.77499 4.55139 8.77499C4.55139 8.77499 4.55139 8.77499 4.514 8.77499H4.47662C4.47662 8.77499 4.43924 8.77499 4.43924 8.73749C4.43924 8.73749 4.43924 8.73749 4.43924 8.69999V8.66249V8.28749V8.24999C4.43924 8.24999 4.43924 8.24999 4.43924 8.21249C4.43924 8.21249 4.43924 8.21249 4.47662 8.21249C4.47662 8.21249 4.47662 8.21249 4.514 8.21249H4.55139C4.55139 8.21249 4.55139 8.21249 4.58877 8.21249C4.58877 8.21249 4.58877 8.21249 4.58877 8.24999C4.58877 8.24999 4.58877 8.24999 4.58877 8.28749V8.73749Z"
          fill={color ?? 'url(#paint220_linear_486_666)'}
        />
        <path
          d="M17.7851 21.4125C17.7477 21.375 17.7477 21.375 17.7103 21.375C17.6729 21.375 17.6355 21.375 17.6355 21.375C17.5981 21.375 17.5981 21.4125 17.5981 21.4125L17.5608 21.45C17.5608 21.4875 17.5608 21.4875 17.5608 21.525V21.9C17.5608 21.9375 17.5608 21.9375 17.5608 21.975C17.5608 22.0125 17.5981 22.0125 17.5981 22.0125L17.6355 22.05C17.6729 22.05 17.6729 22.05 17.7103 22.05C17.7477 22.05 17.7477 22.05 17.7851 22.05L17.8224 22.0125L17.8598 21.975C17.8598 21.9375 17.8598 21.9375 17.8598 21.9V21.525C17.8598 21.4875 17.8598 21.4875 17.8598 21.45C17.8224 21.45 17.7851 21.4125 17.7851 21.4125ZM17.7477 21.8625C17.7477 21.9 17.7477 21.9 17.7477 21.8625C17.7477 21.9 17.7477 21.9 17.7103 21.9C17.7103 21.9 17.7103 21.9 17.6729 21.9C17.6729 21.9 17.6729 21.9 17.6355 21.9C17.5981 21.9 17.5981 21.9 17.5981 21.9C17.5981 21.9 17.5981 21.9 17.5608 21.9C17.5608 21.9 17.5608 21.9 17.5608 21.8625C17.5608 21.8625 17.5608 21.8625 17.5608 21.825V21.45V21.4125C17.5608 21.4125 17.5608 21.4125 17.5608 21.375C17.5608 21.375 17.5608 21.375 17.5981 21.375C17.5981 21.375 17.5981 21.375 17.6355 21.375H17.6729C17.6729 21.375 17.6729 21.375 17.7103 21.375C17.7103 21.375 17.7103 21.375 17.7103 21.4125C17.7103 21.4125 17.7103 21.4125 17.7103 21.45V21.8625H17.7477Z"
          fill={color ?? 'url(#paint221_linear_486_666)'}
        />
        <path
          d="M4.62616 7.125H4.55139L4.43924 7.1625L4.47662 7.2375L4.55139 7.2V7.6875H4.47662V7.7625H4.66354V7.6875H4.62616V7.125Z"
          fill={color ?? 'url(#paint222_linear_486_666)'}
        />
        <path
          d="M4.62615 6.07501L4.58877 6.03751C4.55139 6.03751 4.55139 6.03751 4.514 6.03751C4.47662 6.03751 4.47662 6.03751 4.43924 6.03751C4.40185 6.03751 4.40185 6.07501 4.40185 6.07501L4.36447 6.11251C4.36447 6.15001 4.36447 6.15001 4.36447 6.18751V6.56251C4.36447 6.60001 4.36447 6.60001 4.36447 6.63751C4.36447 6.67501 4.40185 6.67501 4.40185 6.67501L4.43924 6.71251C4.47662 6.71251 4.47662 6.71251 4.514 6.71251C4.55139 6.71251 4.55139 6.71251 4.58877 6.71251L4.62615 6.67501L4.66354 6.63751C4.66354 6.60001 4.66354 6.60001 4.66354 6.56251V6.18751C4.66354 6.15001 4.66354 6.15001 4.66354 6.11251L4.62615 6.07501ZM4.58877 6.56251C4.58877 6.60001 4.58877 6.60001 4.55139 6.60001C4.55139 6.60001 4.55139 6.60001 4.514 6.60001C4.514 6.60001 4.514 6.60001 4.47662 6.60001H4.43924C4.43924 6.60001 4.43924 6.60001 4.40185 6.60001C4.40185 6.60001 4.40185 6.60001 4.40185 6.56251V6.52501V6.15001V6.11251C4.40185 6.11251 4.40185 6.11251 4.40185 6.07501C4.40185 6.07501 4.40185 6.07501 4.43924 6.07501C4.43924 6.07501 4.43924 6.07501 4.47662 6.07501H4.514C4.514 6.07501 4.514 6.07501 4.55139 6.07501C4.55139 6.07501 4.55139 6.07501 4.55139 6.11251C4.55139 6.11251 4.55139 6.11251 4.55139 6.15001L4.58877 6.56251Z"
          fill={color ?? 'url(#paint223_linear_486_666)'}
        />
        <path
          d="M6.0841 15.9H6.00934L5.89719 15.9375L5.93457 16.0125L6.00934 15.975V16.4625H5.93457V16.5375H6.12149V16.4625H6.0841V15.9Z"
          fill={color ?? 'url(#paint224_linear_486_666)'}
        />
        <path
          d="M6.0841 20.25H6.00934L5.89719 20.2875L5.93457 20.3625L6.00934 20.325V20.8125H5.93457V20.8875H6.12149V20.8125H6.0841V20.25Z"
          fill={color ?? 'url(#paint225_linear_486_666)'}
        />
        <path
          d="M6.0841 18.075H6.00934L5.89719 18.1125L5.93457 18.1875L6.00934 18.15V18.6375H5.93457V18.75H6.12149V18.675H6.0841V18.075Z"
          fill={color ?? 'url(#paint226_linear_486_666)'}
        />
        <path
          d="M6.0841 19.2L6.04672 19.1625C6.00933 19.1625 6.00933 19.1625 5.97195 19.1625C5.93457 19.1625 5.93457 19.1625 5.89718 19.1625C5.8598 19.1625 5.8598 19.2 5.8598 19.2L5.82242 19.2375C5.82242 19.275 5.82242 19.275 5.82242 19.3125V19.6875C5.82242 19.725 5.82242 19.725 5.82242 19.7625C5.82242 19.8 5.8598 19.8375 5.89718 19.8375C5.93457 19.8375 5.93457 19.8375 5.97195 19.8375C6.00933 19.8375 6.00933 19.8375 6.04672 19.8375C6.0841 19.8375 6.0841 19.8 6.0841 19.8L6.12148 19.7625C6.12148 19.725 6.12148 19.725 6.12148 19.6875V19.3125C6.12148 19.275 6.12148 19.275 6.12148 19.2375C6.12148 19.2375 6.0841 19.2375 6.0841 19.2ZM6.04672 19.6875C6.04672 19.725 6.04672 19.725 6.00933 19.725C6.00933 19.725 6.00933 19.725 5.97195 19.725C5.97195 19.725 5.97195 19.725 5.93457 19.725H5.89718C5.89718 19.725 5.89718 19.725 5.8598 19.725C5.8598 19.725 5.8598 19.725 5.8598 19.6875C5.8598 19.6875 5.8598 19.6875 5.8598 19.65V19.275V19.2375C5.8598 19.2375 5.8598 19.2375 5.8598 19.2C5.8598 19.2 5.8598 19.2 5.89718 19.2H5.93457H5.97195C5.97195 19.2 5.97195 19.2 6.00933 19.2C6.00933 19.2 6.00933 19.2 6.00933 19.2375C6.00933 19.2375 6.00933 19.2375 6.00933 19.275L6.04672 19.6875Z"
          fill={color ?? 'url(#paint227_linear_486_666)'}
        />
        <path
          d="M6.0841 17.025L6.04672 16.9875C6.00933 16.9875 6.00933 16.9875 5.97195 16.9875C5.93457 16.9875 5.93457 16.9875 5.89718 16.9875C5.8598 16.9875 5.8598 17.025 5.8598 17.025L5.82242 17.0625C5.82242 17.1 5.82242 17.1 5.82242 17.1375V17.5125C5.82242 17.55 5.82242 17.55 5.82242 17.5875C5.82242 17.625 5.8598 17.625 5.8598 17.625L5.89718 17.6625C5.93457 17.6625 5.93457 17.6625 5.97195 17.6625C6.00933 17.6625 6.00933 17.6625 6.04672 17.6625C6.0841 17.6625 6.0841 17.625 6.0841 17.625L6.12148 17.5875C6.12148 17.55 6.12148 17.55 6.12148 17.5125V17.1375C6.12148 17.1 6.12148 17.1 6.12148 17.0625L6.0841 17.025ZM6.04672 17.5125C6.04672 17.55 6.04672 17.55 6.00933 17.55C6.00933 17.55 6.00933 17.55 5.97195 17.55C5.97195 17.55 5.97195 17.55 5.93457 17.55H5.89718C5.89718 17.55 5.89718 17.55 5.8598 17.55C5.8598 17.55 5.8598 17.55 5.8598 17.5125C5.8598 17.5125 5.8598 17.5125 5.8598 17.475V17.1V17.0625L5.89718 17.025C5.89718 17.025 5.89718 17.025 5.93457 17.025H5.97195C5.97195 17.025 5.97195 17.025 6.00933 17.025C6.00933 17.025 6.00933 17.025 6.00933 17.0625C6.00933 17.0625 6.00933 17.0625 6.00933 17.1L6.04672 17.5125Z"
          fill={color ?? 'url(#paint228_linear_486_666)'}
        />
        <path
          d="M5.41122 9.37499L5.37384 9.33749C5.33645 9.33749 5.29907 9.33749 5.29907 9.33749C5.26169 9.33749 5.2243 9.37499 5.2243 9.37499L5.18692 9.41249C5.18692 9.44999 5.18692 9.44999 5.18692 9.48749V9.86249C5.18692 9.89999 5.18692 9.89999 5.18692 9.93749C5.18692 9.97499 5.2243 9.97499 5.26169 10.0125C5.29907 10.0125 5.33645 10.05 5.33645 10.05C5.37384 10.05 5.37384 10.05 5.41122 10.05C5.4486 10.05 5.4486 10.0125 5.4486 10.0125L5.48599 9.97499C5.48599 9.93749 5.48599 9.93749 5.48599 9.89999V9.52499C5.48599 9.48749 5.48599 9.48749 5.48599 9.44999C5.4486 9.37499 5.41122 9.37499 5.41122 9.37499ZM5.37384 9.82499C5.37384 9.82499 5.37384 9.86249 5.37384 9.82499C5.37384 9.86249 5.37384 9.86249 5.33645 9.86249C5.33645 9.86249 5.33645 9.86249 5.29907 9.86249C5.29907 9.86249 5.29907 9.86249 5.26169 9.86249C5.2243 9.86249 5.2243 9.86249 5.2243 9.86249C5.2243 9.86249 5.2243 9.86249 5.18692 9.86249C5.18692 9.86249 5.18692 9.86249 5.18692 9.82499C5.18692 9.82499 5.18692 9.82499 5.18692 9.78749V9.41249V9.37499C5.18692 9.37499 5.18692 9.37499 5.18692 9.33749C5.18692 9.33749 5.18692 9.33749 5.2243 9.33749C5.2243 9.33749 5.2243 9.33749 5.26169 9.33749H5.29907C5.29907 9.33749 5.29907 9.33749 5.33645 9.33749C5.33645 9.33749 5.33645 9.33749 5.33645 9.37499C5.33645 9.37499 5.33645 9.37499 5.33645 9.41249L5.37384 9.82499Z"
          fill={color ?? 'url(#paint229_linear_486_666)'}
        />
        <path
          d="M5.41122 11.55L5.37384 11.5125C5.33645 11.5125 5.29907 11.5125 5.26169 11.5125C5.2243 11.5125 5.2243 11.55 5.2243 11.55L5.18692 11.5875C5.18692 11.625 5.18692 11.625 5.18692 11.6625V12.0375C5.18692 12.075 5.18692 12.075 5.18692 12.1125C5.18692 12.15 5.2243 12.1875 5.26169 12.1875C5.29907 12.1875 5.29907 12.1875 5.33645 12.1875C5.37384 12.1875 5.37384 12.1875 5.41122 12.1875C5.4486 12.1875 5.4486 12.15 5.4486 12.15L5.48599 12.1125C5.48599 12.075 5.48599 12.075 5.48599 12.0375V11.6625C5.48599 11.625 5.48599 11.625 5.48599 11.5875C5.4486 11.5875 5.41122 11.55 5.41122 11.55ZM5.37384 12.0375C5.37384 12.075 5.37384 12.075 5.33645 12.075C5.33645 12.075 5.33645 12.075 5.29907 12.075C5.29907 12.075 5.29907 12.075 5.26169 12.075C5.2243 12.075 5.2243 12.075 5.2243 12.075C5.2243 12.075 5.2243 12.075 5.18692 12.075C5.18692 12.075 5.18692 12.075 5.18692 12.0375C5.18692 12.0375 5.18692 12.0375 5.18692 12V11.625V11.5875L5.2243 11.55C5.2243 11.55 5.2243 11.55 5.26169 11.55H5.29907C5.29907 11.55 5.29907 11.55 5.33645 11.55C5.33645 11.55 5.33645 11.55 5.33645 11.5875C5.33645 11.5875 5.33645 11.5875 5.33645 11.625L5.37384 12.0375Z"
          fill={color ?? 'url(#paint230_linear_486_666)'}
        />
        <path
          d="M5.41122 7.1625L5.37383 7.125C5.33645 7.125 5.33645 7.125 5.29907 7.125C5.26169 7.125 5.26169 7.125 5.2243 7.125C5.18692 7.125 5.18692 7.1625 5.18692 7.1625L5.14954 7.2C5.14954 7.2375 5.14954 7.2375 5.14954 7.275V7.65C5.14954 7.6875 5.14954 7.6875 5.14954 7.725C5.14954 7.7625 5.18692 7.7625 5.18692 7.7625L5.2243 7.8C5.26169 7.8 5.26169 7.8 5.29907 7.8C5.33645 7.8 5.33645 7.8 5.37383 7.8C5.41122 7.8 5.41122 7.7625 5.41122 7.7625L5.4486 7.725C5.4486 7.6875 5.4486 7.6875 5.4486 7.65V7.275C5.4486 7.2375 5.4486 7.2375 5.4486 7.2C5.4486 7.2 5.41122 7.2 5.41122 7.1625ZM5.37383 7.65C5.37383 7.6875 5.37384 7.6875 5.33645 7.6875C5.33645 7.6875 5.33645 7.6875 5.29907 7.6875C5.29907 7.6875 5.29907 7.6875 5.26169 7.6875H5.2243C5.2243 7.6875 5.2243 7.6875 5.18692 7.6875C5.18692 7.6875 5.18692 7.6875 5.18692 7.65C5.18692 7.65 5.18692 7.65 5.18692 7.6125V7.2375V7.2C5.18692 7.2 5.18692 7.2 5.18692 7.1625C5.18692 7.1625 5.18692 7.1625 5.2243 7.1625C5.2243 7.1625 5.2243 7.1625 5.26169 7.1625H5.29907C5.29907 7.1625 5.29907 7.1625 5.33645 7.1625C5.33645 7.1625 5.33645 7.1625 5.33645 7.2C5.33645 7.2 5.33645 7.2 5.33645 7.2375L5.37383 7.65Z"
          fill={color ?? 'url(#paint231_linear_486_666)'}
        />
        <path
          d="M4.62616 9.3H4.55139L4.43924 9.375L4.47662 9.45L4.55139 9.4125V9.9H4.47662V9.975H4.66354V9.9H4.62616V9.3Z"
          fill={color ?? 'url(#paint232_linear_486_666)'}
        />
        <path
          d="M6.0841 21.4125L6.04672 21.375C6.00933 21.375 6.00933 21.375 5.97195 21.375C5.93457 21.375 5.93457 21.375 5.89718 21.375C5.89718 21.375 5.8598 21.375 5.8598 21.4125L5.82242 21.45C5.82242 21.4875 5.82242 21.4875 5.82242 21.525V21.7875L5.89718 21.825V21.4875V21.45C5.89718 21.45 5.89718 21.45 5.89718 21.4125C5.89718 21.4125 5.89718 21.4125 5.93457 21.4125C5.93457 21.4125 5.93457 21.4125 5.97195 21.4125H6.00933C6.00933 21.4125 6.00933 21.4125 6.04672 21.4125C6.04672 21.4125 6.04672 21.4125 6.04672 21.45C6.04672 21.45 6.04672 21.45 6.04672 21.4875V21.8625C6.04672 21.8625 6.04672 21.8625 6.04672 21.9V21.9375L6.12148 21.975V21.9375C6.12148 21.9 6.12148 21.9 6.12148 21.8625V21.4875C6.12148 21.45 6.12148 21.45 6.12148 21.4125C6.12148 21.45 6.0841 21.4125 6.0841 21.4125Z"
          fill={color ?? 'url(#paint233_linear_486_666)'}
        />
        <path
          d="M5.41122 4.9875L5.29907 5.025L5.33645 5.0625C5.33645 5.0625 5.33645 5.0625 5.33645 5.1C5.33645 5.1 5.33645 5.1 5.33645 5.1375V5.5125V5.55C5.33645 5.55 5.33645 5.55 5.33645 5.5875C5.33645 5.5875 5.33645 5.5875 5.29907 5.5875C5.29907 5.5875 5.29907 5.5875 5.26168 5.5875C5.2243 5.5875 5.2243 5.5875 5.2243 5.5875C5.2243 5.5875 5.2243 5.5875 5.18692 5.5875C5.18692 5.5875 5.18692 5.5875 5.18692 5.55C5.18692 5.55 5.18692 5.55 5.18692 5.5125V5.1375L5.11215 5.175V5.5125C5.11215 5.55 5.11215 5.5875 5.14954 5.625L5.18692 5.6625C5.2243 5.6625 5.2243 5.6625 5.26168 5.6625C5.29907 5.6625 5.29907 5.6625 5.33645 5.6625C5.37383 5.6625 5.37383 5.625 5.37383 5.625L5.41122 5.5875C5.41122 5.55 5.41122 5.55 5.41122 5.5125V5.1375C5.41122 5.1 5.41122 5.1 5.41122 5.0625C5.4486 5.025 5.41122 4.9875 5.41122 4.9875Z"
          fill={color ?? 'url(#paint234_linear_486_666)'}
        />
        <path
          d="M3.95327 11.55L3.91589 11.5125C3.87851 11.5125 3.84112 11.5125 3.80374 11.5125C3.76636 11.5125 3.76636 11.55 3.76636 11.55L3.72897 11.5875C3.72897 11.625 3.72897 11.625 3.72897 11.6625V12.0375C3.72897 12.075 3.72897 12.075 3.72897 12.1125C3.72897 12.15 3.76636 12.15 3.76636 12.15L3.80374 12.1875C3.84112 12.1875 3.84112 12.1875 3.87851 12.1875C3.91589 12.1875 3.91589 12.1875 3.95327 12.1875C3.99066 12.1875 3.99066 12.15 3.99066 12.15L4.02804 12.1125C4.02804 12.075 4.02804 12.075 4.02804 12.0375V11.6625C3.99066 11.625 3.99066 11.625 3.99066 11.5875C3.95327 11.5875 3.95327 11.55 3.95327 11.55ZM3.91589 12.0375C3.91589 12.075 3.91589 12.075 3.87851 12.075C3.87851 12.075 3.87851 12.075 3.84112 12.075C3.84112 12.075 3.84112 12.075 3.80374 12.075H3.76636C3.76636 12.075 3.76636 12.075 3.72897 12.075C3.72897 12.075 3.72897 12.075 3.72897 12.0375C3.72897 12.0375 3.72897 12.0375 3.72897 12V11.625V11.5875C3.72897 11.5875 3.72897 11.5875 3.72897 11.55C3.72897 11.55 3.72897 11.55 3.76636 11.55C3.76636 11.55 3.76636 11.55 3.80374 11.55H3.84112C3.84112 11.55 3.84112 11.55 3.87851 11.55L3.91589 11.5875V12.0375Z"
          fill={color ?? 'url(#paint235_linear_486_666)'}
        />
        <path
          d="M3.95327 13.725L3.91589 13.6875C3.87851 13.6875 3.84112 13.6875 3.80374 13.6875C3.76636 13.6875 3.76636 13.725 3.76636 13.725L3.72897 13.7625C3.72897 13.8 3.72897 13.8 3.72897 13.8375V14.2125C3.72897 14.25 3.72897 14.25 3.72897 14.2875C3.72897 14.325 3.76636 14.325 3.76636 14.325L3.80374 14.3625C3.84112 14.3625 3.84112 14.3625 3.87851 14.3625C3.91589 14.3625 3.91589 14.3625 3.95327 14.3625C3.99066 14.3625 3.99066 14.325 3.99066 14.325L4.02804 14.2875C3.99066 14.25 3.99066 14.25 3.99066 14.2125V13.8375C3.99066 13.8 3.99066 13.8 3.99066 13.7625C3.95327 13.7625 3.95327 13.7625 3.95327 13.725ZM3.91589 14.2125C3.91589 14.2125 3.91589 14.25 3.91589 14.2125C3.91589 14.25 3.91589 14.25 3.87851 14.25C3.87851 14.25 3.87851 14.25 3.84112 14.25C3.84112 14.25 3.84112 14.25 3.80374 14.25H3.76636C3.76636 14.25 3.76636 14.25 3.72897 14.25C3.72897 14.25 3.72897 14.25 3.72897 14.2125C3.72897 14.2125 3.72897 14.2125 3.72897 14.175V13.8V13.7625C3.72897 13.7625 3.72897 13.7625 3.72897 13.725C3.72897 13.725 3.72897 13.725 3.76636 13.725C3.76636 13.725 3.76636 13.725 3.80374 13.725H3.84112C3.84112 13.725 3.84112 13.725 3.87851 13.725C3.87851 13.725 3.87851 13.725 3.87851 13.7625C3.87851 13.7625 3.87851 13.7625 3.87851 13.8L3.91589 14.2125Z"
          fill={color ?? 'url(#paint236_linear_486_666)'}
        />
        <path
          d="M3.95327 9.37499L3.91589 9.33749C3.87851 9.33749 3.87851 9.33749 3.84112 9.33749C3.80374 9.33749 3.80374 9.33749 3.76636 9.33749C3.72897 9.33749 3.72897 9.37499 3.72897 9.37499L3.69159 9.41249C3.69159 9.44999 3.69159 9.44999 3.69159 9.48749V9.86249C3.69159 9.89999 3.69159 9.89999 3.69159 9.93749C3.69159 9.97499 3.72897 9.97499 3.72897 9.97499L3.76636 10.0125C3.80374 10.0125 3.80374 10.0125 3.84112 10.0125C3.87851 10.0125 3.87851 10.0125 3.91589 10.0125C3.95327 10.0125 3.95327 9.97499 3.95327 9.97499L3.99065 9.93749C3.99065 9.89999 3.99065 9.89999 3.99065 9.86249V9.48749C3.99065 9.44999 3.99065 9.44999 3.99065 9.41249C3.95327 9.37499 3.95327 9.37499 3.95327 9.37499ZM3.91589 9.82499C3.91589 9.82499 3.91589 9.86249 3.91589 9.82499C3.91589 9.86249 3.91589 9.86249 3.87851 9.86249C3.87851 9.86249 3.87851 9.86249 3.84112 9.86249C3.84112 9.86249 3.84112 9.86249 3.80374 9.86249H3.76636C3.76636 9.86249 3.76636 9.86249 3.72897 9.86249C3.72897 9.86249 3.72897 9.86249 3.72897 9.82499C3.72897 9.82499 3.72897 9.82499 3.72897 9.78749V9.41249V9.37499C3.72897 9.37499 3.72897 9.37499 3.72897 9.33749C3.72897 9.33749 3.72897 9.33749 3.76636 9.33749C3.76636 9.33749 3.76636 9.33749 3.80374 9.33749H3.84112C3.84112 9.33749 3.84112 9.33749 3.87851 9.33749C3.87851 9.33749 3.87851 9.33749 3.87851 9.37499C3.87851 9.37499 3.87851 9.37499 3.87851 9.41249L3.91589 9.82499Z"
          fill={color ?? 'url(#paint237_linear_486_666)'}
        />
        <path
          d="M3.95327 15.9375L3.91589 15.9C3.87851 15.9 3.87851 15.9 3.84112 15.9C3.80374 15.9 3.80374 15.9 3.76636 15.9C3.72897 15.9 3.72897 15.9375 3.72897 15.9375L3.69159 15.975C3.69159 16.0125 3.69159 16.0125 3.69159 16.05V16.425C3.69159 16.4625 3.69159 16.4625 3.69159 16.5C3.69159 16.5375 3.72897 16.575 3.76636 16.575C3.80374 16.575 3.80374 16.575 3.84112 16.575C3.87851 16.575 3.87851 16.575 3.91589 16.575C3.95327 16.575 3.95327 16.5375 3.95327 16.5375L3.99065 16.5C3.99065 16.4625 3.99065 16.4625 3.99065 16.425V16.05C3.99065 16.0125 3.99065 16.0125 3.99065 15.975C3.95327 15.975 3.95327 15.9375 3.95327 15.9375ZM3.91589 16.3875C3.91589 16.425 3.91589 16.425 3.91589 16.3875C3.91589 16.425 3.91589 16.425 3.87851 16.425C3.87851 16.425 3.87851 16.425 3.84112 16.425C3.84112 16.425 3.84112 16.425 3.80374 16.425H3.76636C3.76636 16.425 3.76636 16.425 3.72897 16.425C3.72897 16.425 3.72897 16.425 3.72897 16.3875C3.72897 16.3875 3.72897 16.3875 3.72897 16.35V15.975V15.9375C3.72897 15.9375 3.72897 15.9375 3.72897 15.9C3.72897 15.9 3.72897 15.9 3.76636 15.9C3.76636 15.9 3.76636 15.9 3.80374 15.9H3.84112C3.84112 15.9 3.84112 15.9 3.87851 15.9C3.87851 15.9 3.87851 15.9 3.87851 15.9375C3.87851 15.9375 3.87851 15.9375 3.87851 15.975L3.91589 16.3875Z"
          fill={color ?? 'url(#paint238_linear_486_666)'}
        />
        <path
          d="M3.95327 18.1125L3.91589 18.075C3.87851 18.075 3.87851 18.075 3.84112 18.075C3.80374 18.075 3.80374 18.075 3.76636 18.075C3.72897 18.075 3.72897 18.1125 3.72897 18.1125L3.69159 18.15C3.69159 18.1875 3.69159 18.1875 3.69159 18.225V18.6C3.69159 18.6375 3.69159 18.6375 3.69159 18.675C3.69159 18.7125 3.72897 18.7125 3.72897 18.7125L3.76636 18.75C3.80374 18.75 3.80374 18.75 3.84112 18.75C3.87851 18.75 3.87851 18.75 3.91589 18.75C3.95327 18.75 3.95327 18.7125 3.95327 18.7125L3.99065 18.675C3.99065 18.6375 3.99065 18.6375 3.99065 18.6V18.225C3.99065 18.1875 3.99065 18.1875 3.99065 18.15C3.95327 18.15 3.95327 18.15 3.95327 18.1125ZM3.91589 18.6C3.91589 18.6375 3.91589 18.6375 3.87851 18.6375C3.87851 18.6375 3.87851 18.6375 3.84112 18.6375C3.84112 18.6375 3.84112 18.6375 3.80374 18.6375C3.76636 18.6375 3.76636 18.6375 3.76636 18.6375C3.76636 18.6375 3.76636 18.6375 3.72897 18.6375C3.72897 18.6375 3.72897 18.6375 3.72897 18.6C3.72897 18.6 3.72897 18.6 3.72897 18.5625V18.1875V18.15C3.72897 18.15 3.72897 18.15 3.72897 18.1125C3.72897 18.1125 3.72897 18.1125 3.76636 18.1125C3.76636 18.1125 3.76636 18.1125 3.80374 18.1125H3.84112C3.84112 18.1125 3.84112 18.1125 3.87851 18.1125C3.87851 18.1125 3.87851 18.1125 3.87851 18.15C3.87851 18.15 3.87851 18.15 3.87851 18.1875L3.91589 18.6Z"
          fill={color ?? 'url(#paint239_linear_486_666)'}
        />
        <path
          d="M4.62615 10.4625L4.58877 10.425C4.55139 10.425 4.55139 10.425 4.514 10.425C4.47662 10.425 4.47662 10.425 4.43924 10.425C4.40185 10.425 4.40185 10.4625 4.40185 10.4625C4.36447 10.5 4.36447 10.5375 4.36447 10.575V10.95C4.36447 10.9875 4.36447 10.9875 4.36447 11.025C4.36447 11.0625 4.40185 11.1 4.43924 11.1C4.47662 11.1 4.47662 11.1 4.514 11.1C4.55139 11.1 4.55139 11.1 4.58877 11.1L4.62615 11.0625L4.66354 11.025C4.66354 10.9875 4.66354 10.9875 4.66354 10.95V10.575C4.66354 10.5375 4.66354 10.5375 4.66354 10.5L4.62615 10.4625ZM4.58877 10.9125C4.58877 10.95 4.58877 10.95 4.58877 10.9125C4.58877 10.95 4.58877 10.95 4.55139 10.95C4.55139 10.95 4.55139 10.95 4.514 10.95C4.514 10.95 4.514 10.95 4.47662 10.95H4.43924C4.43924 10.95 4.43924 10.95 4.40185 10.95C4.40185 10.95 4.40185 10.95 4.40185 10.9125V10.875V10.5V10.4625C4.40185 10.4625 4.40185 10.4625 4.40185 10.425C4.40185 10.425 4.40185 10.425 4.43924 10.425C4.43924 10.425 4.43924 10.425 4.47662 10.425H4.514C4.514 10.425 4.514 10.425 4.55139 10.425C4.55139 10.425 4.55139 10.425 4.55139 10.4625C4.55139 10.4625 4.55139 10.4625 4.55139 10.5V10.9125H4.58877Z"
          fill={color ?? 'url(#paint240_linear_486_666)'}
        />
        <path
          d="M3.95327 7.1625L3.91589 7.125C3.87851 7.125 3.87851 7.125 3.84112 7.125C3.80374 7.125 3.80374 7.125 3.76636 7.125C3.72897 7.125 3.72897 7.1625 3.72897 7.1625L3.69159 7.2C3.69159 7.2375 3.69159 7.2375 3.69159 7.275V7.65C3.69159 7.6875 3.69159 7.6875 3.69159 7.725C3.69159 7.7625 3.72897 7.7625 3.72897 7.7625L3.76636 7.8C3.80374 7.8 3.80374 7.8 3.84112 7.8C3.87851 7.8 3.87851 7.8 3.91589 7.8C3.95327 7.8 3.95327 7.7625 3.95327 7.7625L3.99065 7.725C3.99065 7.6875 3.99065 7.6875 3.99065 7.65V7.275C3.99065 7.2375 3.99065 7.2375 3.99065 7.2C3.95327 7.2 3.95327 7.2 3.95327 7.1625ZM3.91589 7.65C3.91589 7.6875 3.91589 7.6875 3.87851 7.6875C3.87851 7.6875 3.84112 7.6875 3.84112 7.725H3.80374C3.80374 7.725 3.80374 7.725 3.76636 7.725C3.76636 7.725 3.76636 7.725 3.76636 7.6875C3.76636 7.6875 3.76636 7.6875 3.76636 7.65V7.275V7.2375L3.80374 7.2C3.80374 7.2 3.80374 7.2 3.84112 7.2H3.87851C3.87851 7.2 3.87851 7.2 3.91589 7.2C3.91589 7.2 3.91589 7.2 3.91589 7.2375C3.91589 7.2375 3.91589 7.2375 3.91589 7.275V7.65Z"
          fill={color ?? 'url(#paint241_linear_486_666)'}
        />
        <path
          d="M3.13085 6.56251C3.13085 6.60001 3.13085 6.60001 3.09347 6.60001C3.09347 6.60001 3.09347 6.60001 3.05609 6.60001C3.05609 6.60001 3.05609 6.60001 3.0187 6.60001C2.98132 6.60001 2.98132 6.60001 2.98132 6.60001C2.98132 6.60001 2.98132 6.60001 2.94394 6.60001C2.94394 6.60001 2.94394 6.60001 2.94394 6.56251C2.94394 6.56251 2.94394 6.56251 2.94394 6.52501V6.37501L2.86917 6.41251V6.56251C2.86917 6.60001 2.86917 6.60001 2.86917 6.63751C2.86917 6.67501 2.90655 6.67501 2.90655 6.67501L2.94394 6.71251C2.98132 6.71251 2.98132 6.71251 3.0187 6.71251C3.05609 6.71251 3.05609 6.71251 3.09347 6.71251L3.13085 6.67501L3.16824 6.63751C3.16824 6.60001 3.16824 6.60001 3.16824 6.56251V6.22501L3.09347 6.26251V6.56251H3.13085Z"
          fill={color ?? 'url(#paint242_linear_486_666)'}
        />
        <path
          d="M3.95327 20.325L3.91589 20.2875C3.87851 20.2875 3.84112 20.2875 3.80374 20.2875C3.76636 20.2875 3.76636 20.325 3.76636 20.325L3.72897 20.3625C3.72897 20.4 3.72897 20.4 3.72897 20.4375V20.5875L3.80374 20.625V20.4375V20.4C3.80374 20.4 3.80374 20.4 3.80374 20.3625C3.80374 20.3625 3.80374 20.3625 3.84112 20.3625C3.84112 20.3625 3.84112 20.3625 3.87851 20.3625H3.91589C3.91589 20.3625 3.91589 20.3625 3.95327 20.3625L3.99066 20.4V20.6625V20.7375V20.4375C3.99066 20.4 3.99066 20.4 3.99066 20.3625C3.95327 20.325 3.95327 20.325 3.95327 20.325Z"
          fill={color ?? 'url(#paint243_linear_486_666)'}
        />
        <path
          d="M3.76635 19.275V19.7625H3.69159V19.8375H3.8785V19.7625H3.84112V19.1625H3.76635L3.65421 19.2L3.69159 19.275H3.76635Z"
          fill={color ?? 'url(#paint244_linear_486_666)'}
        />
        <path
          d="M4.62615 12.6375L4.58877 12.6C4.55139 12.6 4.55139 12.6 4.514 12.6C4.47662 12.6 4.47662 12.6 4.43924 12.6C4.40185 12.6 4.40185 12.6375 4.40185 12.6375C4.36447 12.675 4.36447 12.7125 4.36447 12.75V13.125C4.36447 13.1625 4.36447 13.1625 4.36447 13.2C4.36447 13.2375 4.40185 13.275 4.43924 13.275C4.47662 13.275 4.47662 13.275 4.514 13.275C4.55139 13.275 4.55139 13.275 4.58877 13.275L4.62615 13.2375L4.66354 13.2C4.66354 13.1625 4.66354 13.1625 4.66354 13.125V12.75C4.66354 12.7125 4.66354 12.7125 4.66354 12.675C4.66354 12.675 4.62615 12.675 4.62615 12.6375ZM4.58877 13.125C4.58877 13.1625 4.58877 13.1625 4.55139 13.1625C4.55139 13.1625 4.55139 13.1625 4.514 13.1625C4.514 13.1625 4.514 13.1625 4.47662 13.1625C4.43924 13.1625 4.43924 13.1625 4.43924 13.1625C4.43924 13.1625 4.43924 13.1625 4.40185 13.1625C4.40185 13.1625 4.40185 13.1625 4.40185 13.125V13.0875V12.7125V12.675C4.40185 12.675 4.40185 12.675 4.40185 12.6375C4.40185 12.6375 4.40185 12.6375 4.43924 12.6375C4.43924 12.6375 4.43924 12.6375 4.47662 12.6375H4.514C4.514 12.6375 4.514 12.6375 4.55139 12.6375C4.55139 12.6375 4.55139 12.6375 4.55139 12.675C4.55139 12.675 4.55139 12.675 4.55139 12.7125V13.125H4.58877Z"
          fill={color ?? 'url(#paint245_linear_486_666)'}
        />
        <path
          d="M4.62616 13.6875H4.55139L4.43924 13.725L4.47662 13.8L4.55139 13.7625V14.25H4.47662V14.325H4.66354V14.25H4.62616V13.6875Z"
          fill={color ?? 'url(#paint246_linear_486_666)'}
        />
        <path
          d="M4.62615 14.85C4.58877 14.8125 4.58877 14.8125 4.55139 14.8125C4.514 14.8125 4.47662 14.8125 4.47662 14.8125C4.43924 14.8125 4.43924 14.85 4.43924 14.85C4.36447 14.85 4.36447 14.8875 4.36447 14.9625V15.3375C4.36447 15.375 4.36447 15.375 4.36447 15.4125C4.36447 15.375 4.36447 15.4125 4.40185 15.4125L4.43924 15.45C4.47662 15.45 4.47662 15.45 4.514 15.45C4.55139 15.45 4.55139 15.45 4.58877 15.45L4.62615 15.4125L4.66354 15.375C4.66354 15.3375 4.66354 15.3375 4.66354 15.3V14.925C4.66354 14.8875 4.66354 14.8875 4.66354 14.85H4.62615ZM4.58877 15.3C4.58877 15.3 4.58877 15.3375 4.58877 15.3C4.58877 15.3375 4.58877 15.3375 4.55139 15.3375C4.55139 15.3375 4.55139 15.3375 4.514 15.3375C4.514 15.3375 4.514 15.3375 4.47662 15.3375H4.43924C4.43924 15.3375 4.43924 15.3375 4.40185 15.3375C4.40185 15.3375 4.40185 15.3375 4.40185 15.3C4.40185 15.3 4.40185 15.3 4.40185 15.2625V14.8875V14.85C4.40185 14.85 4.40185 14.85 4.40185 14.8125C4.40185 14.8125 4.40185 14.8125 4.43924 14.8125C4.43924 14.8125 4.43924 14.8125 4.47662 14.8125H4.514C4.514 14.8125 4.514 14.8125 4.55139 14.8125C4.55139 14.8125 4.55139 14.8125 4.55139 14.85C4.55139 14.85 4.55139 14.85 4.55139 14.8875L4.58877 15.3Z"
          fill={color ?? 'url(#paint247_linear_486_666)'}
        />
        <path
          d="M4.62616 11.5125H4.55139L4.43924 11.55L4.47662 11.625H4.55139V12.1125H4.47662V12.1875H4.66354V12.1125H4.62616V11.5125Z"
          fill={color ?? 'url(#paint248_linear_486_666)'}
        />
        <path
          d="M4.62615 19.2L4.58877 19.1625C4.55139 19.1625 4.55139 19.1625 4.514 19.1625C4.47662 19.1625 4.47662 19.1625 4.43924 19.1625C4.40185 19.1625 4.40185 19.2 4.40185 19.2L4.36447 19.2375C4.36447 19.275 4.36447 19.275 4.36447 19.3125V19.6875C4.36447 19.725 4.36447 19.725 4.36447 19.7625C4.36447 19.8 4.40185 19.8 4.40185 19.8L4.43924 19.8375C4.47662 19.8375 4.47662 19.8375 4.514 19.8375C4.55139 19.8375 4.55139 19.8375 4.58877 19.8375L4.62615 19.8L4.66354 19.7625C4.66354 19.725 4.66354 19.725 4.66354 19.6875V19.3125C4.66354 19.275 4.66354 19.275 4.66354 19.2375C4.66354 19.2375 4.62615 19.2375 4.62615 19.2ZM4.58877 19.6875C4.58877 19.725 4.58877 19.725 4.55139 19.725C4.55139 19.725 4.55139 19.725 4.514 19.725C4.514 19.725 4.514 19.725 4.47662 19.725C4.43924 19.725 4.43924 19.725 4.43924 19.725C4.43924 19.725 4.43924 19.725 4.40185 19.725C4.40185 19.725 4.40185 19.725 4.40185 19.6875V19.65V19.275V19.2375C4.40185 19.2375 4.40185 19.2375 4.40185 19.2C4.40185 19.2 4.40185 19.2 4.43924 19.2C4.43924 19.2 4.43924 19.2 4.47662 19.2C4.514 19.2 4.514 19.2 4.514 19.2C4.514 19.2 4.514 19.2 4.55139 19.2C4.55139 19.2 4.55139 19.2 4.55139 19.2375C4.55139 19.2375 4.55139 19.2375 4.55139 19.275V19.6875H4.58877Z"
          fill={color ?? 'url(#paint249_linear_486_666)'}
        />
        <path
          d="M4.62616 18.075H4.55139L4.43924 18.1125L4.47662 18.1875L4.55139 18.15V18.6375H4.47662V18.75H4.66354V18.675H4.62616V18.075Z"
          fill={color ?? 'url(#paint250_linear_486_666)'}
        />
        <path
          d="M4.62616 20.25H4.55139L4.43924 20.2875L4.47662 20.3625L4.55139 20.325V20.8125H4.47662V20.8875H4.66354V20.8125H4.62616V20.25Z"
          fill={color ?? 'url(#paint251_linear_486_666)'}
        />
        <path
          d="M4.62615 17.025L4.58877 16.9875C4.55139 16.9875 4.55139 16.9875 4.514 16.9875C4.47662 16.9875 4.47662 16.9875 4.43924 16.9875C4.40185 16.9875 4.40185 17.025 4.40185 17.025L4.36447 17.0625C4.36447 17.1 4.36447 17.1 4.36447 17.1375V17.5125C4.36447 17.55 4.36447 17.55 4.36447 17.5875C4.36447 17.5875 4.36447 17.5875 4.40185 17.625L4.43924 17.6625C4.47662 17.6625 4.47662 17.6625 4.514 17.6625C4.55139 17.6625 4.55139 17.6625 4.58877 17.6625L4.62615 17.625L4.66354 17.5875C4.66354 17.55 4.66354 17.55 4.66354 17.5125V17.1375C4.66354 17.1 4.66354 17.1 4.66354 17.0625L4.62615 17.025ZM4.58877 17.5125C4.58877 17.55 4.58877 17.55 4.55139 17.55C4.55139 17.55 4.55139 17.55 4.514 17.55C4.514 17.55 4.514 17.55 4.47662 17.55C4.43924 17.55 4.43924 17.55 4.43924 17.55C4.43924 17.55 4.43924 17.55 4.40185 17.55C4.40185 17.55 4.40185 17.55 4.40185 17.5125V17.475V17.1V17.0625C4.40185 17.0625 4.40185 17.0625 4.40185 17.025C4.40185 17.025 4.40185 17.025 4.43924 17.025C4.43924 17.025 4.43924 17.025 4.47662 17.025C4.514 17.025 4.514 17.025 4.514 17.025C4.514 17.025 4.514 17.025 4.55139 17.025C4.55139 17.025 4.55139 17.025 4.55139 17.0625C4.55139 17.0625 4.55139 17.0625 4.55139 17.1V17.5125H4.58877Z"
          fill={color ?? 'url(#paint252_linear_486_666)'}
        />
        <path
          d="M4.62616 15.9H4.55139L4.43924 15.9375L4.47662 16.0125L4.55139 15.975V16.4625H4.47662V16.5375H4.66354V16.4625H4.62616V15.9Z"
          fill={color ?? 'url(#paint253_linear_486_666)'}
        />
        <path
          d="M5.41122 13.725L5.37384 13.6875C5.33645 13.6875 5.29907 13.6875 5.26169 13.6875C5.2243 13.6875 5.2243 13.725 5.2243 13.725L5.18692 13.7625C5.18692 13.8 5.18692 13.8 5.18692 13.8375V14.2125C5.18692 14.25 5.18692 14.25 5.18692 14.2875C5.18692 14.325 5.2243 14.3625 5.26169 14.3625C5.29907 14.3625 5.29907 14.3625 5.33645 14.3625C5.37384 14.3625 5.37384 14.3625 5.41122 14.3625C5.4486 14.3625 5.4486 14.325 5.4486 14.325L5.48599 14.2875C5.48599 14.25 5.48599 14.25 5.48599 14.2125V13.8375C5.48599 13.8 5.48599 13.8 5.48599 13.7625C5.4486 13.7625 5.41122 13.7625 5.41122 13.725ZM5.37384 14.2125C5.37384 14.2125 5.37384 14.25 5.37384 14.2125C5.37384 14.25 5.37384 14.25 5.33645 14.25C5.33645 14.25 5.33645 14.25 5.29907 14.25H5.26169H5.2243C5.2243 14.25 5.2243 14.25 5.18692 14.25C5.18692 14.25 5.18692 14.25 5.18692 14.2125C5.18692 14.2125 5.18692 14.2125 5.18692 14.175V13.8V13.7625C5.18692 13.7625 5.18692 13.7625 5.18692 13.725C5.18692 13.725 5.18692 13.725 5.2243 13.725C5.2243 13.725 5.2243 13.725 5.26169 13.725H5.29907C5.29907 13.725 5.29907 13.725 5.33645 13.725C5.33645 13.725 5.33645 13.725 5.33645 13.7625C5.33645 13.7625 5.33645 13.7625 5.33645 13.8L5.37384 14.2125Z"
          fill={color ?? 'url(#paint254_linear_486_666)'}
        />
        <path
          d="M16.3271 21.4125L16.2897 21.375C16.2523 21.375 16.215 21.375 16.1776 21.375C16.1402 21.375 16.1402 21.4125 16.1402 21.4125L16.1028 21.45C16.1028 21.6375 16.1028 21.7875 16.1402 21.975L16.1776 22.0125C16.215 22.0125 16.215 22.0125 16.2523 22.0125C16.2897 22.0125 16.2897 22.0125 16.3271 22.0125C16.3645 22.0125 16.3645 21.975 16.3645 21.975L16.4019 21.9375C16.4019 21.9 16.4019 21.9 16.4019 21.8625V21.4875C16.4019 21.45 16.4019 21.45 16.4019 21.4125C16.3645 21.45 16.3271 21.4125 16.3271 21.4125ZM16.2897 21.8625C16.2897 21.9 16.2897 21.9 16.2897 21.8625C16.2897 21.9 16.2897 21.9 16.2523 21.9C16.2523 21.9 16.2523 21.9 16.215 21.9C16.215 21.9 16.215 21.9 16.1776 21.9C16.1402 21.9 16.1402 21.9 16.1402 21.9C16.1402 21.9 16.1402 21.9 16.1028 21.9C16.1028 21.9 16.1028 21.9 16.1028 21.8625C16.1028 21.8625 16.1028 21.8625 16.1028 21.825V21.45V21.4125C16.1028 21.4125 16.1028 21.4125 16.1028 21.375C16.1028 21.375 16.1028 21.375 16.1402 21.375C16.1402 21.375 16.1402 21.375 16.1776 21.375H16.215C16.215 21.375 16.215 21.375 16.2523 21.375L16.2897 21.4125V21.8625Z"
          fill={color ?? 'url(#paint255_linear_486_666)'}
        />
        <path
          d="M16.3271 20.25H16.2523L16.1402 20.2875L16.1776 20.3625L16.2523 20.325V20.8125H16.1776V20.8875H16.3645V20.8125H16.3271V20.25Z"
          fill={color ?? 'url(#paint256_linear_486_666)'}
        />
        <path
          d="M16.3271 18.075H16.2523L16.1402 18.1125L16.1776 18.1875L16.2523 18.15V18.6375H16.1776V18.75H16.3645V18.675H16.3271V18.075Z"
          fill={color ?? 'url(#paint257_linear_486_666)'}
        />
        <path
          d="M16.3271 19.2L16.2897 19.1625C16.2523 19.1625 16.2523 19.1625 16.215 19.1625C16.1776 19.1625 16.1776 19.1625 16.1402 19.1625C16.1028 19.1625 16.1028 19.2 16.1028 19.2L16.0654 19.2375C16.0654 19.275 16.0654 19.275 16.0654 19.3125V19.6875C16.0654 19.725 16.0654 19.725 16.0654 19.7625C16.0654 19.8 16.1028 19.8375 16.1402 19.8375C16.1776 19.8375 16.1776 19.8375 16.215 19.8375C16.2523 19.8375 16.2523 19.8375 16.2897 19.8375C16.3271 19.8375 16.3271 19.8 16.3271 19.8L16.3645 19.7625C16.3645 19.725 16.3645 19.725 16.3645 19.6875V19.3125C16.3645 19.275 16.3645 19.275 16.3645 19.2375C16.3645 19.2375 16.3271 19.2375 16.3271 19.2ZM16.2897 19.6875C16.2897 19.725 16.2897 19.725 16.2523 19.725C16.2523 19.725 16.2523 19.725 16.215 19.725C16.215 19.725 16.215 19.725 16.1776 19.725H16.1402C16.1402 19.725 16.1402 19.725 16.1028 19.725C16.1028 19.725 16.1028 19.725 16.1028 19.6875C16.1028 19.6875 16.1028 19.6875 16.1028 19.65V19.275V19.2375C16.1028 19.2375 16.1028 19.2375 16.1028 19.2C16.1028 19.2 16.1028 19.2 16.1402 19.2C16.1402 19.2 16.1402 19.2 16.1776 19.2C16.215 19.2 16.215 19.2 16.215 19.2C16.215 19.2 16.215 19.2 16.2523 19.2C16.2523 19.2 16.2523 19.2 16.2523 19.2375C16.2523 19.2375 16.2523 19.2375 16.2523 19.275L16.2897 19.6875Z"
          fill={color ?? 'url(#paint258_linear_486_666)'}
        />
        <path
          d="M16.3271 22.4625H16.2523L16.1402 22.5L16.1776 22.575L16.2523 22.5375V23.025H16.1776V23.1H16.3645V23.025H16.3271V22.4625Z"
          fill={color ?? 'url(#paint259_linear_486_666)'}
        />
        <path
          d="M8.32711 15.9375L8.28973 15.9C8.25235 15.9 8.25235 15.9 8.21496 15.9C8.17758 15.9 8.17758 15.9 8.1402 15.9C8.10281 15.9 8.10281 15.9375 8.10281 15.9375L8.06543 15.975C8.06543 16.0125 8.06543 16.0125 8.06543 16.05V16.425C8.06543 16.4625 8.06543 16.5 8.10281 16.5C8.10281 16.5375 8.1402 16.5375 8.17758 16.575C8.21496 16.575 8.21496 16.575 8.25235 16.575C8.28973 16.575 8.28973 16.575 8.32711 16.575C8.3645 16.575 8.3645 16.5375 8.3645 16.5375L8.40188 16.5C8.40188 16.4625 8.40188 16.4625 8.40188 16.425V16.05C8.40188 16.0125 8.40188 16.0125 8.40188 15.975C8.36449 15.975 8.32711 15.9375 8.32711 15.9375ZM8.28973 16.3875C8.28973 16.425 8.28973 16.425 8.28973 16.3875C8.28973 16.425 8.28973 16.425 8.25235 16.425C8.25235 16.425 8.25235 16.425 8.21496 16.425C8.21496 16.425 8.21496 16.425 8.17758 16.425H8.1402C8.1402 16.425 8.1402 16.425 8.10281 16.425C8.10281 16.425 8.10281 16.425 8.10281 16.3875C8.10281 16.3875 8.10281 16.3875 8.10281 16.35V15.975V15.9375C8.10281 15.9375 8.10281 15.9375 8.10281 15.9C8.10281 15.9 8.10281 15.9 8.1402 15.9C8.1402 15.9 8.1402 15.9 8.17758 15.9C8.17758 15.9 8.17758 15.9 8.21496 15.9C8.21496 15.9 8.21496 15.9 8.25235 15.9C8.25235 15.9 8.25235 15.9 8.25235 15.9375C8.25235 15.9375 8.25235 15.9375 8.25235 15.975L8.28973 16.3875Z"
          fill={color ?? 'url(#paint260_linear_486_666)'}
        />
        <path
          d="M8.32711 20.325L8.28973 20.2875C8.25235 20.2875 8.21496 20.2875 8.17758 20.2875C8.1402 20.2875 8.1402 20.325 8.1402 20.325L8.10281 20.3625C8.10281 20.4 8.10281 20.4 8.10281 20.4375V20.8125C8.10281 20.85 8.10281 20.85 8.10281 20.8875C8.10281 20.925 8.1402 20.925 8.1402 20.925L8.17758 20.9625C8.21496 20.9625 8.21496 20.9625 8.25235 20.9625C8.28973 20.9625 8.28973 20.9625 8.32711 20.9625L8.3645 20.925L8.40188 20.8875C8.40188 20.85 8.40188 20.85 8.40188 20.8125V20.4375C8.40188 20.4 8.40188 20.4 8.40188 20.3625C8.3645 20.325 8.32711 20.325 8.32711 20.325ZM8.28973 20.775C8.28973 20.8125 8.28973 20.8125 8.25235 20.8125C8.25235 20.8125 8.25235 20.8125 8.21496 20.8125C8.21496 20.8125 8.21496 20.8125 8.17758 20.8125H8.1402C8.1402 20.8125 8.1402 20.8125 8.10281 20.8125C8.10281 20.8125 8.10281 20.8125 8.10281 20.775C8.10281 20.775 8.10281 20.775 8.10281 20.7375V20.3625V20.325C8.10281 20.325 8.10281 20.325 8.10281 20.2875C8.10281 20.2875 8.10281 20.2875 8.1402 20.2875C8.1402 20.2875 8.1402 20.2875 8.17758 20.2875C8.17758 20.2875 8.17758 20.2875 8.21496 20.2875C8.21496 20.2875 8.21496 20.2875 8.25235 20.2875L8.28973 20.325V20.775Z"
          fill={color ?? 'url(#paint261_linear_486_666)'}
        />
        <path
          d="M8.1402 21.45V21.9375H8.06543V22.0125H8.25234V21.9375H8.21496V21.375H8.1402L8.02805 21.4125L8.06543 21.4875L8.1402 21.45Z"
          fill={color ?? 'url(#paint262_linear_486_666)'}
        />
        <path
          d="M8.32711 18.1125L8.28973 18.075C8.25235 18.075 8.25235 18.075 8.21496 18.075C8.17758 18.075 8.17758 18.075 8.1402 18.075L8.10281 18.1125L8.06543 18.15C8.06543 18.1875 8.06543 18.1875 8.06543 18.225V18.6C8.06543 18.6375 8.06543 18.6375 8.06543 18.675C8.06543 18.7125 8.10281 18.7125 8.10281 18.7125L8.1402 18.75C8.17758 18.75 8.17758 18.75 8.21496 18.75C8.25235 18.75 8.25235 18.75 8.28973 18.75L8.32711 18.7125L8.3645 18.675C8.3645 18.6375 8.3645 18.6375 8.3645 18.6V18.225C8.3645 18.1875 8.3645 18.1875 8.3645 18.15C8.3645 18.15 8.32711 18.15 8.32711 18.1125ZM8.28973 18.6C8.28973 18.6375 8.28973 18.6375 8.25235 18.6375C8.25235 18.6375 8.25235 18.6375 8.21496 18.6375C8.21496 18.6375 8.21496 18.6375 8.17758 18.6375H8.1402C8.1402 18.6375 8.1402 18.6375 8.10281 18.6375C8.10281 18.6375 8.10281 18.6375 8.10281 18.6C8.10281 18.6 8.10281 18.6 8.10281 18.5625V18.1875V18.15C8.10281 18.15 8.10281 18.15 8.10281 18.1125C8.10281 18.1125 8.10281 18.1125 8.1402 18.1125C8.1402 18.1125 8.1402 18.1125 8.17758 18.1125C8.17758 18.1125 8.17758 18.1125 8.21496 18.1125C8.21496 18.1125 8.21496 18.1125 8.25235 18.1125C8.25235 18.1125 8.25235 18.1125 8.25235 18.15V18.1875L8.28973 18.6Z"
          fill={color ?? 'url(#paint263_linear_486_666)'}
        />
        <path
          d="M8.32711 22.5L8.28973 22.4625C8.25235 22.4625 8.21496 22.4625 8.17758 22.4625C8.1402 22.4625 8.10281 22.5 8.10281 22.5L8.06543 22.5375C8.06543 22.575 8.06543 22.575 8.06543 22.6125V22.9875C8.06543 23.025 8.06543 23.025 8.06543 23.0625C8.06543 23.1 8.10281 23.1 8.10281 23.1L8.1402 23.1375C8.17758 23.1375 8.17758 23.1375 8.21496 23.1375C8.25235 23.1375 8.25235 23.1375 8.28973 23.1375C8.32711 23.1375 8.32711 23.1 8.32711 23.1L8.3645 23.0625C8.3645 23.025 8.3645 23.025 8.3645 22.9875V22.6125C8.3645 22.575 8.3645 22.575 8.3645 22.5375L8.32711 22.5ZM8.28973 22.9875C8.28973 23.025 8.28973 23.025 8.25235 23.025C8.25235 23.025 8.25235 23.025 8.21496 23.025C8.21496 23.025 8.21496 23.025 8.17758 23.025H8.1402C8.1402 23.025 8.1402 23.025 8.10281 23.025C8.10281 23.025 8.10281 23.025 8.10281 22.9875C8.10281 22.9875 8.10281 22.9875 8.10281 22.95V22.575V22.5375C8.10281 22.5375 8.10281 22.5375 8.10281 22.5C8.10281 22.5 8.10281 22.5 8.1402 22.5C8.1402 22.5 8.1402 22.5 8.17758 22.5C8.17758 22.5 8.17758 22.5 8.21496 22.5C8.21496 22.5 8.21496 22.5 8.25235 22.5L8.28973 22.5375V22.9875Z"
          fill={color ?? 'url(#paint264_linear_486_666)'}
        />
        <path
          d="M17.1121 20.325L17.0748 20.2875C17.0374 20.2875 17 20.2875 16.9626 20.2875C16.9252 20.2875 16.9252 20.325 16.9252 20.325L16.8878 20.3625C16.8878 20.4 16.8878 20.4 16.8878 20.4375V20.8125C16.8878 20.85 16.8878 20.85 16.8878 20.8875C16.8878 20.925 16.9252 20.925 16.9252 20.925L16.9626 20.9625C17 20.9625 17 20.9625 17.0374 20.9625C17.0748 20.9625 17.0748 20.9625 17.1121 20.9625L17.1495 20.925L17.1869 20.8875C17.1869 20.85 17.1869 20.85 17.1869 20.8125V20.4375C17.1869 20.4 17.1869 20.4 17.1869 20.3625C17.1495 20.325 17.1121 20.325 17.1121 20.325ZM17.0748 20.775C17.0748 20.775 17.0748 20.8125 17.0748 20.775C17.0748 20.8125 17.0748 20.8125 17.0374 20.8125C17.0374 20.8125 17.0374 20.8125 17 20.8125C17 20.8125 17 20.8125 16.9626 20.8125C16.9252 20.8125 16.9252 20.8125 16.9252 20.8125C16.9252 20.8125 16.9252 20.8125 16.8878 20.8125C16.8878 20.8125 16.8878 20.8125 16.8878 20.775C16.8878 20.775 16.8878 20.775 16.8878 20.7375V20.3625V20.325C16.8878 20.325 16.8878 20.325 16.8878 20.2875C16.8878 20.2875 16.8878 20.2875 16.9252 20.2875C16.9252 20.2875 16.9252 20.2875 16.9626 20.2875H17C17 20.2875 17 20.2875 17.0374 20.2875C17.0374 20.2875 17.0374 20.2875 17.0374 20.325C17.0374 20.325 17.0374 20.325 17.0374 20.3625L17.0748 20.775Z"
          fill={color ?? 'url(#paint265_linear_486_666)'}
        />
        <path
          d="M17.1121 15.9375L17.0748 15.9C17.0374 15.9 17.0374 15.9 17 15.9C16.9626 15.9 16.9626 15.9 16.9252 15.9C16.8878 15.9 16.8878 15.9375 16.8878 15.9375L16.8505 15.975C16.8505 16.0125 16.8505 16.0125 16.8505 16.05V16.425C16.8505 16.4625 16.8505 16.5 16.8878 16.5C16.8878 16.5375 16.9252 16.5375 16.9626 16.575C17 16.575 17 16.575 17.0374 16.575C17.0748 16.575 17.0748 16.575 17.1121 16.575L17.1495 16.5375L17.1869 16.5C17.1869 16.4625 17.1869 16.4625 17.1869 16.425V16.05C17.1869 16.0125 17.1869 16.0125 17.1869 15.975C17.1495 15.975 17.1121 15.9375 17.1121 15.9375ZM17.0748 16.3875C17.0748 16.425 17.0748 16.425 17.0748 16.3875C17.0748 16.425 17.0748 16.425 17.0374 16.425C17.0374 16.425 17.0374 16.425 17 16.425C17 16.425 17 16.425 16.9626 16.425C16.9252 16.425 16.9252 16.425 16.9252 16.425C16.9252 16.425 16.9252 16.425 16.8878 16.425C16.8878 16.425 16.8878 16.425 16.8878 16.3875C16.8878 16.3875 16.8878 16.3875 16.8878 16.35V15.975V15.9375C16.8878 15.9375 16.8878 15.9375 16.8878 15.9C16.8878 15.9 16.8878 15.9 16.9252 15.9C16.9252 15.9 16.9252 15.9 16.9626 15.9H17C17 15.9 17 15.9 17.0374 15.9C17.0374 15.9 17.0374 15.9 17.0374 15.9375C17.0374 15.9375 17.0374 15.9375 17.0374 15.975L17.0748 16.3875Z"
          fill={color ?? 'url(#paint266_linear_486_666)'}
        />
        <path
          d="M17.1121 18.1125L17.0748 18.075C17.0374 18.075 17.0374 18.075 17 18.075C16.9626 18.075 16.9626 18.075 16.9252 18.075C16.8878 18.075 16.8878 18.1125 16.8878 18.1125L16.8505 18.15C16.8505 18.1875 16.8505 18.1875 16.8505 18.225V18.6C16.8505 18.6375 16.8505 18.6375 16.8505 18.675C16.8505 18.7125 16.8878 18.7125 16.8878 18.7125L16.9252 18.75C16.9626 18.75 16.9626 18.75 17 18.75C17.0374 18.75 17.0374 18.75 17.0748 18.75L17.1121 18.7125L17.1495 18.675C17.1495 18.6375 17.1495 18.6375 17.1495 18.6V18.225C17.1495 18.1875 17.1495 18.1875 17.1495 18.15C17.1495 18.15 17.1121 18.15 17.1121 18.1125ZM17.0748 18.6C17.0748 18.6375 17.0748 18.6375 17.0374 18.6375C17.0374 18.6375 17.0374 18.6375 17 18.6375C17 18.6375 17 18.6375 16.9626 18.6375C16.9252 18.6375 16.9252 18.6375 16.9252 18.6375C16.9252 18.6375 16.9252 18.6375 16.8878 18.6375C16.8878 18.6375 16.8878 18.6375 16.8878 18.6C16.8878 18.6 16.8878 18.6 16.8878 18.5625V18.1875V18.15C16.8878 18.15 16.8878 18.15 16.8878 18.1125C16.8878 18.1125 16.8878 18.1125 16.9252 18.1125C16.9252 18.1125 16.9252 18.1125 16.9626 18.1125H17C17 18.1125 17 18.1125 17.0374 18.1125C17.0374 18.1125 17.0374 18.1125 17.0374 18.15V18.1875L17.0748 18.6Z"
          fill={color ?? 'url(#paint267_linear_486_666)'}
        />
        <path
          d="M17.1121 13.725L17.0748 13.6875C17.0374 13.6875 17 13.6875 16.9626 13.6875C16.9252 13.6875 16.9252 13.725 16.9252 13.725L16.8878 13.7625C16.8878 13.7625 16.8878 13.8 16.8878 13.8375V14.2125C16.8878 14.25 16.8878 14.25 16.8878 14.2875C16.8878 14.325 16.9252 14.325 16.9252 14.325L16.9626 14.3625C17 14.3625 17 14.3625 17.0374 14.3625C17.0748 14.3625 17.0748 14.3625 17.1121 14.3625L17.1495 14.325L17.1869 14.2875C17.1869 14.25 17.1869 14.25 17.1869 14.2125V13.8375C17.1869 13.8 17.1869 13.8 17.1869 13.7625C17.1495 13.7625 17.1121 13.7625 17.1121 13.725ZM17.0748 14.2125C17.0748 14.2125 17.0748 14.25 17.0748 14.2125C17.0748 14.25 17.0748 14.25 17.0374 14.25C17.0374 14.25 17.0374 14.25 17 14.25C17 14.25 17 14.25 16.9626 14.25H16.9252C16.9252 14.25 16.9252 14.25 16.8878 14.25C16.8878 14.25 16.8878 14.25 16.8878 14.2125C16.8878 14.2125 16.8878 14.2125 16.8878 14.175V13.8V13.7625C16.8878 13.7625 16.8878 13.7625 16.8878 13.725C16.8878 13.725 16.8878 13.725 16.9252 13.725C16.9252 13.725 16.9252 13.725 16.9626 13.725H17C17 13.725 17 13.725 17.0374 13.725C17.0374 13.725 17.0374 13.725 17.0374 13.7625C17.0374 13.7625 17.0374 13.7625 17.0374 13.8L17.0748 14.2125Z"
          fill={color ?? 'url(#paint268_linear_486_666)'}
        />
        <path
          d="M16.3271 17.025L16.2897 16.9875C16.2523 16.9875 16.2523 16.9875 16.215 16.9875C16.1776 16.9875 16.1776 16.9875 16.1402 16.9875C16.1028 16.9875 16.1028 17.025 16.1028 17.025L16.0654 17.0625C16.0654 17.1 16.0654 17.1 16.0654 17.1375V17.5125C16.0654 17.55 16.0654 17.55 16.0654 17.5875C16.0654 17.625 16.1028 17.625 16.1028 17.625L16.1402 17.6625C16.1776 17.6625 16.1776 17.6625 16.215 17.6625C16.2523 17.6625 16.2523 17.6625 16.2897 17.6625C16.2897 17.625 16.3271 17.625 16.3271 17.625L16.3645 17.5875C16.3645 17.55 16.3645 17.55 16.3645 17.5125V17.1375C16.3645 17.1 16.3645 17.1 16.3645 17.0625L16.3271 17.025ZM16.2897 17.5125C16.2897 17.55 16.2897 17.55 16.2523 17.55C16.2523 17.55 16.215 17.55 16.215 17.5875H16.1776C16.1776 17.5875 16.1776 17.5875 16.1402 17.5875C16.1402 17.5875 16.1402 17.5875 16.1402 17.55C16.1402 17.55 16.1402 17.55 16.1402 17.5125V17.1375V17.1C16.1402 17.1 16.1402 17.1 16.1402 17.0625C16.1402 17.0625 16.1402 17.0625 16.1776 17.0625C16.1776 17.0625 16.1776 17.0625 16.215 17.0625H16.2523C16.2523 17.0625 16.2523 17.0625 16.2897 17.0625C16.2897 17.0625 16.2897 17.0625 16.2897 17.1C16.2897 17.1 16.2897 17.1 16.2897 17.1375V17.5125Z"
          fill={color ?? 'url(#paint269_linear_486_666)'}
        />
        <path
          d="M16.3271 14.85C16.3271 14.8125 16.3271 14.8125 16.3271 14.85C16.2897 14.85 16.2897 14.8875 16.2897 14.925C16.2897 14.925 16.2897 14.925 16.2897 14.9625V15.3375V15.375C16.2897 15.375 16.2897 15.375 16.2897 15.4125C16.2897 15.4125 16.2897 15.4125 16.2523 15.4125C16.2523 15.4125 16.2523 15.4125 16.215 15.4125H16.1776C16.1776 15.4125 16.1776 15.4125 16.1402 15.4125V15.375C16.1402 15.4125 16.1028 15.45 16.1028 15.4875L16.1402 15.525C16.1776 15.525 16.1776 15.525 16.215 15.525C16.2523 15.525 16.2523 15.525 16.2897 15.525C16.3271 15.525 16.3271 15.4875 16.3271 15.4875L16.3645 15.45C16.3645 15.4125 16.3645 15.4125 16.3645 15.375V15C16.3645 14.9625 16.3645 14.9625 16.3645 14.925C16.3645 14.85 16.3271 14.85 16.3271 14.85Z"
          fill={color ?? 'url(#paint270_linear_486_666)'}
        />
        <path
          d="M16.3271 15.9H16.2523L16.1402 15.9375L16.1776 16.0125L16.2523 15.975V16.4625H16.1776V16.5375H16.3645V16.4625H16.3271V15.9Z"
          fill={color ?? 'url(#paint271_linear_486_666)'}
        />
        <path
          d="M17.1495 22.5375C17.1495 22.5 17.1121 22.5 17.1121 22.5L17.0748 22.4625C17.0374 22.4625 17 22.4625 16.9626 22.4625C16.9252 22.4625 16.9252 22.5 16.9252 22.5L16.8878 22.5375C16.8878 22.575 16.8878 22.575 16.8878 22.6125V22.9875L16.9626 22.95V22.65V22.6125C16.9626 22.6125 16.9626 22.6125 16.9626 22.575C16.9626 22.575 16.9626 22.575 17 22.575C17 22.575 17 22.575 17.0374 22.575H17.0748C17.0748 22.575 17.0748 22.575 17.1121 22.575C17.1121 22.575 17.1121 22.575 17.1121 22.6125C17.1121 22.6125 17.1121 22.6125 17.1121 22.65V22.875L17.1869 22.8375V22.8C17.1869 22.7625 17.1869 22.7625 17.1869 22.725V22.65C17.1495 22.575 17.1495 22.575 17.1495 22.5375Z"
          fill={color ?? 'url(#paint272_linear_486_666)'}
        />
        <path
          d="M16.9252 21.45V21.9375H16.8505V22.0125H17.0374V21.9375H17V21.375H16.9252L16.8131 21.4125L16.8505 21.4875L16.9252 21.45Z"
          fill={color ?? 'url(#paint273_linear_486_666)'}
        />
        <path
          d="M6.86917 20.325L6.83178 20.2875C6.7944 20.2875 6.7944 20.2875 6.75702 20.2875C6.71963 20.2875 6.71963 20.2875 6.68225 20.2875C6.64487 20.2875 6.64487 20.325 6.64487 20.325L6.60748 20.3625C6.60748 20.4 6.60748 20.4 6.60748 20.4375V20.8125C6.60748 20.85 6.60748 20.85 6.60748 20.8875C6.60748 20.925 6.64487 20.925 6.64487 20.925L6.68225 20.9625C6.71963 20.9625 6.71963 20.9625 6.75702 20.9625C6.7944 20.9625 6.7944 20.9625 6.83178 20.9625L6.86917 20.925L6.90655 20.8875C6.90655 20.85 6.90655 20.85 6.90655 20.8125V20.4375C6.90655 20.4 6.90655 20.4 6.90655 20.3625C6.90655 20.325 6.86917 20.325 6.86917 20.325ZM6.83178 20.775C6.83178 20.775 6.83178 20.8125 6.83178 20.775C6.83178 20.8125 6.83178 20.8125 6.7944 20.8125C6.7944 20.8125 6.7944 20.8125 6.75702 20.8125C6.75702 20.8125 6.75702 20.8125 6.71963 20.8125H6.68225C6.68225 20.8125 6.68225 20.8125 6.64487 20.8125C6.64487 20.8125 6.64487 20.8125 6.64487 20.775C6.64487 20.775 6.64487 20.775 6.64487 20.7375V20.3625V20.325C6.64487 20.325 6.64487 20.325 6.64487 20.2875C6.64487 20.2875 6.64487 20.2875 6.68225 20.2875C6.68225 20.2875 6.68225 20.2875 6.71963 20.2875H6.75702C6.75702 20.2875 6.75702 20.2875 6.7944 20.2875C6.7944 20.2875 6.7944 20.2875 6.7944 20.325C6.7944 20.325 6.7944 20.325 6.7944 20.3625L6.83178 20.775Z"
          fill={color ?? 'url(#paint274_linear_486_666)'}
        />
        <path
          d="M6.75701 21.375H6.68225L6.5701 21.4125L6.60748 21.4875L6.68225 21.45V21.9375H6.60748V22.0125H6.7944V21.9375H6.75701V21.375Z"
          fill={color ?? 'url(#paint275_linear_486_666)'}
        />
        <path
          d="M6.0841 14.85L6.04672 14.8125C6.00933 14.8125 6.00933 14.8125 5.97195 14.8125C5.93457 14.8125 5.93457 14.8125 5.89718 14.8125C5.8598 14.8125 5.8598 14.85 5.8598 14.85L5.82242 14.8875C5.82242 14.925 5.82242 14.925 5.82242 14.9625V15.3375C5.82242 15.375 5.82242 15.375 5.82242 15.4125C5.82242 15.45 5.8598 15.45 5.8598 15.45L5.89718 15.4875C5.93457 15.4875 5.93457 15.4875 5.97195 15.4875C6.00933 15.4875 6.00933 15.4875 6.04672 15.4875L6.0841 15.45L6.12148 15.4125C6.12148 15.375 6.12148 15.375 6.12148 15.3375V14.9625C6.12148 14.925 6.12148 14.925 6.12148 14.8875C6.12148 14.85 6.0841 14.85 6.0841 14.85ZM6.04672 15.3C6.04672 15.3 6.04672 15.3375 6.04672 15.3C6.04672 15.3375 6.04672 15.3375 6.00933 15.3375C6.00933 15.3375 6.00933 15.3375 5.97195 15.3375C5.97195 15.3375 5.97195 15.3375 5.93457 15.3375H5.89718C5.89718 15.3375 5.89718 15.3375 5.8598 15.3375C5.8598 15.3375 5.8598 15.3375 5.8598 15.3C5.8598 15.3 5.8598 15.3 5.8598 15.2625V14.8875V14.85C5.8598 14.85 5.8598 14.85 5.8598 14.8125C5.8598 14.8125 5.8598 14.8125 5.89718 14.8125C5.89718 14.8125 5.89718 14.8125 5.93457 14.8125H5.97195C5.97195 14.8125 5.97195 14.8125 6.00933 14.8125C6.00933 14.8125 6.00933 14.8125 6.00933 14.85C6.00933 14.85 6.00933 14.85 6.00933 14.8875L6.04672 15.3Z"
          fill={color ?? 'url(#paint276_linear_486_666)'}
        />
        <path
          d="M6.0841 9.3H6.00934L5.89719 9.375L5.93457 9.45L6.00934 9.4125V9.9H5.93457V9.975H6.12149V9.9H6.0841V9.3Z"
          fill={color ?? 'url(#paint277_linear_486_666)'}
        />
        <path
          d="M6.86917 18.1125L6.83178 18.075C6.7944 18.075 6.7944 18.075 6.75702 18.075C6.71963 18.075 6.71963 18.075 6.68225 18.075C6.64487 18.075 6.64487 18.1125 6.64487 18.1125L6.60748 18.15C6.60748 18.1875 6.60748 18.1875 6.60748 18.225V18.6C6.60748 18.6375 6.60748 18.6375 6.60748 18.675C6.60748 18.7125 6.64487 18.7125 6.64487 18.7125L6.68225 18.75C6.71963 18.75 6.71963 18.75 6.75702 18.75C6.7944 18.75 6.7944 18.75 6.83178 18.75L6.86917 18.7125L6.90655 18.675C6.90655 18.6375 6.90655 18.6375 6.90655 18.6V18.225C6.90655 18.1875 6.90655 18.1875 6.90655 18.15C6.90655 18.15 6.86917 18.15 6.86917 18.1125ZM6.83178 18.6C6.83178 18.6375 6.83178 18.6375 6.7944 18.6375C6.7944 18.6375 6.7944 18.6375 6.75702 18.6375C6.75702 18.6375 6.75702 18.6375 6.71963 18.6375H6.68225C6.68225 18.6375 6.68225 18.6375 6.64487 18.6375C6.64487 18.6375 6.64487 18.6375 6.64487 18.6C6.64487 18.6 6.64487 18.6 6.64487 18.5625V18.1875V18.15C6.64487 18.15 6.64487 18.15 6.64487 18.1125C6.64487 18.1125 6.64487 18.1125 6.68225 18.1125H6.71963H6.75702C6.75702 18.1125 6.75702 18.1125 6.7944 18.1125C6.7944 18.1125 6.7944 18.1125 6.7944 18.15C6.7944 18.15 6.7944 18.15 6.7944 18.1875L6.83178 18.6Z"
          fill={color ?? 'url(#paint278_linear_486_666)'}
        />
        <path
          d="M6.0841 12.6375L6.04672 12.6C6.00933 12.6 6.00933 12.6 5.97195 12.6C5.93457 12.6 5.93457 12.6 5.89718 12.6C5.8598 12.6 5.8598 12.6375 5.8598 12.6375L5.82242 12.675C5.82242 12.7125 5.82242 12.7125 5.82242 12.75V13.125C5.82242 13.1625 5.82242 13.1625 5.82242 13.2C5.82242 13.2375 5.8598 13.2375 5.8598 13.2375L5.89718 13.275C5.93457 13.275 5.93457 13.275 5.97195 13.275C6.00933 13.275 6.00933 13.275 6.04672 13.275C6.0841 13.275 6.0841 13.2375 6.0841 13.2375C6.12148 13.2 6.12148 13.1625 6.12148 13.125V12.75C6.12148 12.7125 6.12148 12.7125 6.12148 12.675C6.12148 12.675 6.0841 12.675 6.0841 12.6375ZM6.04672 13.125C6.04672 13.1625 6.04672 13.1625 6.00933 13.1625C6.00933 13.1625 6.00933 13.1625 5.97195 13.1625C5.97195 13.1625 5.97195 13.1625 5.93457 13.1625H5.89718C5.89718 13.1625 5.89718 13.1625 5.8598 13.1625C5.8598 13.1625 5.8598 13.1625 5.8598 13.125C5.8598 13.125 5.8598 13.125 5.8598 13.0875V12.7125V12.675C5.8598 12.675 5.8598 12.675 5.8598 12.6375C5.8598 12.6375 5.8598 12.6375 5.89718 12.6375C5.89718 12.6375 5.89718 12.6375 5.93457 12.6375H5.97195C5.97195 12.6375 5.97195 12.6375 6.00933 12.6375C6.00933 12.6375 6.00933 12.6375 6.00933 12.675C6.00933 12.675 6.00933 12.675 6.00933 12.7125L6.04672 13.125Z"
          fill={color ?? 'url(#paint279_linear_486_666)'}
        />
        <path
          d="M6.86917 15.9375L6.83178 15.9C6.7944 15.9 6.7944 15.9 6.75702 15.9C6.71963 15.9 6.71963 15.9 6.68225 15.9C6.64487 15.9 6.64487 15.9375 6.64487 15.9375L6.60748 15.975C6.60748 16.0125 6.60748 16.0125 6.60748 16.05V16.425C6.60748 16.4625 6.60748 16.4625 6.60748 16.5C6.60748 16.5 6.60748 16.5 6.64487 16.5L6.68225 16.5375C6.71963 16.5375 6.71963 16.5375 6.75702 16.5375C6.7944 16.5375 6.7944 16.5375 6.83178 16.5375L6.86917 16.5L6.90655 16.4625C6.90655 16.425 6.90655 16.425 6.90655 16.3875V16.0125C6.90655 15.975 6.90655 15.975 6.90655 15.9375C6.90655 15.975 6.86917 15.9375 6.86917 15.9375ZM6.83178 16.3875C6.83178 16.425 6.83178 16.425 6.83178 16.3875C6.83178 16.425 6.83178 16.425 6.7944 16.425C6.7944 16.425 6.7944 16.425 6.75702 16.425C6.75702 16.425 6.75702 16.425 6.71963 16.425H6.68225C6.68225 16.425 6.68225 16.425 6.64487 16.425C6.64487 16.425 6.64487 16.425 6.64487 16.3875V16.35V15.975V15.9375C6.64487 15.9375 6.64487 15.9375 6.64487 15.9C6.64487 15.9 6.64487 15.9 6.68225 15.9H6.71963H6.75702C6.75702 15.9 6.75702 15.9 6.7944 15.9C6.7944 15.9 6.7944 15.9 6.7944 15.9375C6.7944 15.9375 6.7944 15.9375 6.7944 15.975L6.83178 16.3875Z"
          fill={color ?? 'url(#paint280_linear_486_666)'}
        />
        <path
          d="M6.0841 13.6875H6.00934L5.89719 13.725L5.93457 13.8L6.00934 13.7625V14.25H5.93457V14.325H6.12149V14.25H6.0841V13.6875Z"
          fill={color ?? 'url(#paint281_linear_486_666)'}
        />
        <path
          d="M6.0841 11.5125H6.00934L5.89719 11.55L5.93457 11.625L6.00934 11.5875V12.075H5.93457V12.15H6.12149V12.075H6.0841V11.5125Z"
          fill={color ?? 'url(#paint282_linear_486_666)'}
        />
        <path
          d="M6.0841 10.4625L6.04672 10.425C6.00933 10.425 6.00933 10.425 5.97195 10.425C5.93457 10.425 5.93457 10.425 5.89718 10.425C5.8598 10.425 5.8598 10.4625 5.8598 10.4625L5.82242 10.5C5.82242 10.5375 5.82242 10.5375 5.82242 10.575V10.95C5.82242 10.9875 5.82242 10.9875 5.82242 11.025L5.8598 11.0625L5.89718 11.1C5.93457 11.1 5.93457 11.1 5.97195 11.1C6.00933 11.1 6.00933 11.1 6.04672 11.1C6.0841 11.1 6.0841 11.0625 6.0841 11.0625C6.12148 11.025 6.12148 10.9875 6.12148 10.95V10.575C6.12148 10.5375 6.12148 10.5375 6.12148 10.5L6.0841 10.4625ZM6.04672 10.9125C6.04672 10.95 6.04672 10.95 6.04672 10.9125C6.04672 10.95 6.04672 10.95 6.00933 10.95C6.00933 10.95 6.00933 10.95 5.97195 10.95C5.97195 10.95 5.97195 10.95 5.93457 10.95H5.89718C5.89718 10.95 5.89718 10.95 5.8598 10.95C5.8598 10.95 5.8598 10.95 5.8598 10.9125C5.8598 10.9125 5.8598 10.9125 5.8598 10.875V10.5V10.4625C5.8598 10.4625 5.8598 10.4625 5.8598 10.425C5.8598 10.425 5.8598 10.425 5.89718 10.425H5.93457H5.97195C5.97195 10.425 5.97195 10.425 6.00933 10.425C6.00933 10.425 6.00933 10.425 6.00933 10.4625C6.00933 10.4625 6.00933 10.4625 6.00933 10.5L6.04672 10.9125Z"
          fill={color ?? 'url(#paint283_linear_486_666)'}
        />
        <path
          d="M7.54205 15.9H7.46728L7.35513 15.9375L7.39252 16.0125L7.46728 15.975V16.4625H7.39252V16.5375H7.57943V16.4625H7.54205V15.9Z"
          fill={color ?? 'url(#paint284_linear_486_666)'}
        />
        <path
          d="M7.54205 17.025L7.50466 16.9875C7.46728 16.9875 7.46728 16.9875 7.4299 16.9875C7.39252 16.9875 7.39251 16.9875 7.35513 16.9875C7.31775 16.9875 7.31775 17.025 7.31775 17.025L7.28036 17.0625C7.28036 17.1 7.28036 17.1 7.28036 17.1375V17.5125C7.28036 17.55 7.28036 17.55 7.28036 17.5875L7.31775 17.625C7.35513 17.625 7.35513 17.625 7.35513 17.625C7.39251 17.625 7.39252 17.625 7.4299 17.625C7.46728 17.625 7.46728 17.625 7.50466 17.625C7.54205 17.625 7.54205 17.5875 7.54205 17.5875L7.57943 17.55C7.57943 17.5125 7.57943 17.5125 7.57943 17.475V17.1C7.57943 17.0625 7.57943 17.0625 7.57943 17.025C7.57943 17.0625 7.57943 17.025 7.54205 17.025ZM7.50466 17.5125C7.50466 17.55 7.50466 17.55 7.46728 17.55C7.46728 17.55 7.4299 17.55 7.4299 17.5875H7.39251C7.39251 17.5875 7.39251 17.5875 7.35513 17.5875C7.35513 17.5875 7.35513 17.5875 7.35513 17.55C7.35513 17.55 7.35513 17.55 7.35513 17.5125V17.1375V17.1C7.35513 17.1 7.35513 17.1 7.35513 17.0625C7.35513 17.0625 7.35513 17.0625 7.39251 17.0625C7.39251 17.0625 7.39252 17.0625 7.4299 17.0625C7.4299 17.0625 7.4299 17.0625 7.46728 17.0625C7.46728 17.0625 7.46728 17.0625 7.50466 17.0625C7.50466 17.0625 7.50466 17.0625 7.50466 17.1C7.50466 17.1 7.50466 17.1 7.50466 17.1375V17.5125Z"
          fill={color ?? 'url(#paint285_linear_486_666)'}
        />
        <path
          d="M7.54205 13.6875H7.46728L7.35513 13.725L7.39252 13.8L7.46728 13.7625V14.25H7.39252V14.325H7.57943V14.25H7.54205V13.6875Z"
          fill={color ?? 'url(#paint286_linear_486_666)'}
        />
        <path
          d="M7.54205 14.85L7.50466 14.8125C7.46728 14.8125 7.46728 14.8125 7.4299 14.8125C7.39252 14.8125 7.39251 14.8125 7.35513 14.8125C7.31775 14.8125 7.31775 14.85 7.31775 14.85L7.28036 14.8875C7.28036 14.925 7.28036 14.925 7.28036 14.9625V15.3375C7.28036 15.375 7.28036 15.375 7.28036 15.4125C7.28036 15.45 7.31775 15.45 7.31775 15.45L7.35513 15.4875C7.39251 15.4875 7.39252 15.4875 7.4299 15.4875C7.46728 15.4875 7.46728 15.4875 7.50466 15.4875C7.54205 15.4875 7.54205 15.45 7.54205 15.45L7.57943 15.4125C7.57943 15.375 7.57943 15.375 7.57943 15.3375V14.9625C7.57943 14.925 7.57943 14.925 7.57943 14.8875C7.57943 14.85 7.57943 14.85 7.54205 14.85ZM7.50466 15.3C7.50466 15.3 7.50466 15.3375 7.50466 15.3C7.50466 15.3375 7.50466 15.3375 7.46728 15.3375C7.46728 15.3375 7.46728 15.3375 7.4299 15.3375C7.4299 15.3375 7.4299 15.3375 7.39251 15.3375H7.35513C7.35513 15.3375 7.35513 15.3375 7.31775 15.3375C7.31775 15.3375 7.31775 15.3375 7.31775 15.3C7.31775 15.3 7.31775 15.3 7.31775 15.2625V14.8875V14.85L7.35513 14.8125C7.35513 14.8125 7.35513 14.8125 7.39251 14.8125C7.39251 14.8125 7.39252 14.8125 7.4299 14.8125C7.4299 14.8125 7.4299 14.8125 7.46728 14.8125C7.46728 14.8125 7.46728 14.8125 7.46728 14.85C7.46728 14.85 7.46728 14.85 7.46728 14.8875L7.50466 15.3Z"
          fill={color ?? 'url(#paint287_linear_486_666)'}
        />
        <path
          d="M7.54205 18.075H7.46728L7.35513 18.1125L7.39252 18.1875L7.46728 18.15V18.6375H7.39252V18.75H7.57943V18.675H7.54205V18.075Z"
          fill={color ?? 'url(#paint288_linear_486_666)'}
        />
        <path
          d="M7.54205 19.2L7.50466 19.1625C7.46728 19.1625 7.46728 19.1625 7.4299 19.1625C7.39252 19.1625 7.39251 19.1625 7.35513 19.1625C7.31775 19.1625 7.31775 19.2 7.31775 19.2L7.28036 19.2375C7.28036 19.275 7.28036 19.275 7.28036 19.3125V19.6875C7.28036 19.725 7.28036 19.725 7.28036 19.7625C7.28036 19.8 7.31775 19.8375 7.35513 19.8375C7.39251 19.8375 7.39252 19.8375 7.4299 19.8375C7.46728 19.8375 7.46728 19.8375 7.50466 19.8375C7.54205 19.8375 7.54205 19.8 7.54205 19.8L7.57943 19.7625C7.57943 19.725 7.57943 19.725 7.57943 19.6875V19.3125C7.57943 19.275 7.57943 19.275 7.57943 19.2375C7.57943 19.2375 7.57943 19.2375 7.54205 19.2ZM7.50466 19.6875C7.50466 19.725 7.50466 19.725 7.46728 19.725C7.46728 19.725 7.46728 19.725 7.4299 19.725C7.4299 19.725 7.4299 19.725 7.39251 19.725H7.35513C7.35513 19.725 7.35513 19.725 7.31775 19.725C7.31775 19.725 7.31775 19.725 7.31775 19.6875C7.31775 19.6875 7.31775 19.6875 7.31775 19.65V19.275V19.2375C7.31775 19.2375 7.31775 19.2375 7.31775 19.2C7.31775 19.2 7.31775 19.2 7.35513 19.2H7.39251C7.39251 19.2 7.39252 19.2 7.4299 19.2C7.4299 19.2 7.4299 19.2 7.46728 19.2C7.46728 19.2 7.46728 19.2 7.46728 19.2375C7.46728 19.2375 7.46728 19.2375 7.46728 19.275L7.50466 19.6875Z"
          fill={color ?? 'url(#paint289_linear_486_666)'}
        />
        <path
          d="M7.46728 22.4625L7.35513 22.5L7.39252 22.575L7.46728 22.5375V22.725L7.54205 22.7625V22.425L7.46728 22.4625Z"
          fill={color ?? 'url(#paint290_linear_486_666)'}
        />
        <path
          d="M7.54205 21.4125L7.50466 21.375C7.46728 21.375 7.46728 21.375 7.4299 21.375C7.39252 21.375 7.39251 21.375 7.35513 21.375C7.35513 21.375 7.35513 21.375 7.31775 21.4125L7.28036 21.45C7.28036 21.4875 7.28036 21.4875 7.28036 21.525V21.9C7.28036 21.9375 7.28036 21.9375 7.28036 21.975L7.31775 22.0125L7.35513 22.05C7.39251 22.05 7.39252 22.05 7.4299 22.05C7.46728 22.05 7.46728 22.05 7.50466 22.05C7.54205 22.05 7.54205 22.0125 7.54205 22.0125L7.57943 21.975C7.57943 21.9375 7.57943 21.9375 7.57943 21.9V21.525C7.57943 21.4875 7.57943 21.4875 7.57943 21.45C7.57943 21.45 7.57943 21.4125 7.54205 21.4125ZM7.50466 21.8625C7.50466 21.9 7.50466 21.9 7.50466 21.8625C7.50466 21.9 7.50466 21.9 7.46728 21.9C7.46728 21.9 7.46728 21.9 7.4299 21.9C7.4299 21.9 7.4299 21.9 7.39251 21.9H7.35513C7.35513 21.9 7.35513 21.9 7.31775 21.9C7.31775 21.9 7.31775 21.9 7.31775 21.8625C7.31775 21.8625 7.31775 21.8625 7.31775 21.825V21.45V21.4125C7.31775 21.4125 7.31775 21.4125 7.31775 21.375C7.31775 21.375 7.31775 21.375 7.35513 21.375H7.39251C7.39251 21.375 7.39252 21.375 7.4299 21.375C7.4299 21.375 7.4299 21.375 7.46728 21.375L7.50466 21.4125V21.8625Z"
          fill={color ?? 'url(#paint291_linear_486_666)'}
        />
        <path
          d="M7.54205 20.25H7.46728L7.35513 20.325L7.39252 20.4L7.46728 20.3625V20.85H7.39252V20.925H7.57943V20.85H7.54205V20.25Z"
          fill={color ?? 'url(#paint292_linear_486_666)'}
        />
        <path
          d="M6.86917 13.725C6.83178 13.6875 6.83178 13.6875 6.7944 13.6875C6.75702 13.6875 6.71963 13.6875 6.71963 13.6875C6.68225 13.6875 6.68225 13.725 6.68225 13.725C6.60748 13.7625 6.60748 13.8 6.60748 13.8375V14.2125C6.60748 14.25 6.60748 14.25 6.60748 14.2875C6.60748 14.325 6.64487 14.325 6.64487 14.325L6.68225 14.3625C6.71963 14.3625 6.71963 14.3625 6.75702 14.3625C6.7944 14.3625 6.7944 14.3625 6.83178 14.3625L6.86917 14.325L6.90655 14.2875C6.90655 14.25 6.90655 14.25 6.90655 14.2125V13.8375C6.90655 13.8 6.90655 13.8 6.90655 13.7625C6.90655 13.7625 6.86917 13.7625 6.86917 13.725ZM6.83178 14.2125C6.83178 14.2125 6.83178 14.25 6.83178 14.2125C6.83178 14.25 6.83178 14.25 6.7944 14.25C6.7944 14.25 6.7944 14.25 6.75702 14.25C6.75702 14.25 6.75702 14.25 6.71963 14.25H6.68225C6.68225 14.25 6.68225 14.25 6.64487 14.25C6.64487 14.25 6.64487 14.25 6.64487 14.2125V14.175V13.8V13.7625C6.64487 13.7625 6.64487 13.7625 6.64487 13.725C6.64487 13.725 6.64487 13.725 6.68225 13.725C6.68225 13.725 6.68225 13.725 6.71963 13.725H6.75702C6.75702 13.725 6.75702 13.725 6.7944 13.725C6.7944 13.725 6.7944 13.725 6.7944 13.7625C6.7944 13.7625 6.7944 13.7625 6.7944 13.8L6.83178 14.2125Z"
          fill={color ?? 'url(#paint293_linear_486_666)'}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_486_666"
          x1="12.2133"
          y1="4.39756"
          x2="12.2133"
          y2="20.1732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004E54" />
          <stop offset="0.3" stopColor="#00C6C1" />
          <stop offset="0.48" stopColor="#00FFFF" />
          <stop offset="0.7" stopColor="#00C6C1" />
          <stop offset="1" stopColor="#004E54" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_486_666"
          x1="17.79"
          y1="6.59104"
          x2="7.23945"
          y2="19.3128"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00C6C1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_486_666"
          x1="2.31185"
          y1="2.8127"
          x2="2.31185"
          y2="23.7618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_486_666"
          x1="5.2363"
          y1="83.3629"
          x2="5.2363"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_486_666"
          x1="2.36658"
          y1="108.564"
          x2="2.36658"
          y2="609.082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_486_666"
          x1="3.04681"
          y1="114.239"
          x2="3.04681"
          y2="616.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_486_666"
          x1="6.67672"
          y1="92.0007"
          x2="6.67672"
          y2="516.214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_486_666"
          x1="3.77435"
          y1="78.9901"
          x2="3.77435"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_486_666"
          x1="3.09247"
          y1="77.8605"
          x2="3.09247"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_486_666"
          x1="6.01775"
          y1="71.3258"
          x2="6.01775"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_486_666"
          x1="2.36601"
          y1="117.306"
          x2="2.36601"
          y2="617.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_486_666"
          x1="2.36601"
          y1="119.54"
          x2="2.36601"
          y2="619.976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_486_666"
          x1="6.71388"
          y1="38.9036"
          x2="6.71388"
          y2="297.622"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_486_666"
          x1="3.77435"
          y1="72.4207"
          x2="3.77435"
          y2="566.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_486_666"
          x1="3.09247"
          y1="75.6705"
          x2="3.09247"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_486_666"
          x1="7.43551"
          y1="72.0052"
          x2="7.43551"
          y2="397.507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_486_666"
          x1="3.77435"
          y1="76.7722"
          x2="3.77435"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_486_666"
          x1="6.75504"
          y1="106.362"
          x2="6.75504"
          y2="606.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_486_666"
          x1="2.28953"
          y1="82.0155"
          x2="2.28953"
          y2="550.013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_486_666"
          x1="3.04681"
          y1="112.055"
          x2="3.04681"
          y2="613.635"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_486_666"
          x1="3.77435"
          y1="74.5755"
          x2="3.77435"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_486_666"
          x1="5.2363"
          y1="74.5755"
          x2="5.2363"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_486_666"
          x1="2.31185"
          y1="74.5755"
          x2="2.31185"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_486_666"
          x1="5.2363"
          y1="78.9901"
          x2="5.2363"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_486_666"
          x1="2.31184"
          y1="81.1803"
          x2="2.31184"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_486_666"
          x1="3.09247"
          y1="84.4301"
          x2="3.09247"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_486_666"
          x1="3.04682"
          y1="118.323"
          x2="3.04682"
          y2="618.986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_486_666"
          x1="3.09247"
          y1="82.2467"
          x2="3.09247"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_486_666"
          x1="3.77436"
          y1="81.1803"
          x2="3.77436"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_486_666"
          x1="3.77436"
          y1="83.3629"
          x2="3.77436"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_486_666"
          x1="5.2363"
          y1="76.7722"
          x2="5.2363"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_486_666"
          x1="2.36602"
          y1="112.956"
          x2="2.36602"
          y2="613.425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_486_666"
          x1="5.2363"
          y1="72.4207"
          x2="5.2363"
          y2="566.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_486_666"
          x1="2.31185"
          y1="78.9901"
          x2="2.31185"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_486_666"
          x1="3.09247"
          y1="80.0573"
          x2="3.09247"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_486_666"
          x1="2.36658"
          y1="115.16"
          x2="2.36658"
          y2="615.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_486_666"
          x1="5.97106"
          y1="107.407"
          x2="5.97106"
          y2="607.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_486_666"
          x1="2.36602"
          y1="110.783"
          x2="2.36602"
          y2="611.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_486_666"
          x1="3.04682"
          y1="120.629"
          x2="3.04682"
          y2="621.128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_486_666"
          x1="5.95611"
          y1="109.619"
          x2="5.95611"
          y2="609.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_486_666"
          x1="3.04682"
          y1="116.161"
          x2="3.04682"
          y2="616.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_486_666"
          x1="2.31185"
          y1="76.7722"
          x2="2.31185"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_486_666"
          x1="5.2363"
          y1="81.1803"
          x2="5.2363"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_486_666"
          x1="10.4057"
          y1="69.1354"
          x2="10.4057"
          y2="563.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_486_666"
          x1="6.69978"
          y1="81.1803"
          x2="6.69978"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_486_666"
          x1="6.69978"
          y1="78.9901"
          x2="6.69978"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_486_666"
          x1="6.69978"
          y1="83.3628"
          x2="6.69978"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_486_666"
          x1="6.69978"
          y1="85.5318"
          x2="6.69978"
          y2="579.716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_486_666"
          x1="8.16184"
          y1="85.5318"
          x2="8.16184"
          y2="579.716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_486_666"
          x1="6.01774"
          y1="73.4805"
          x2="6.01774"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_486_666"
          x1="16.9378"
          y1="85.5318"
          x2="16.9378"
          y2="579.716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_486_666"
          x1="8.16184"
          y1="83.3628"
          x2="8.16184"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_486_666"
          x1="8.78976"
          y1="115.849"
          x2="8.78976"
          y2="582.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_486_666"
          x1="8.16184"
          y1="81.1803"
          x2="8.16184"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_486_666"
          x1="14.7938"
          y1="71.3258"
          x2="14.7938"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_486_666"
          x1="15.5297"
          y1="106.362"
          x2="15.5297"
          y2="606.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_486_666"
          x1="16.2565"
          y1="71.3258"
          x2="16.2565"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_486_666"
          x1="8.9351"
          y1="118.054"
          x2="8.9351"
          y2="611.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_486_666"
          x1="3.04681"
          y1="109.619"
          x2="3.04681"
          y2="609.983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_486_666"
          x1="8.87596"
          y1="37.8518"
          x2="8.87596"
          y2="124.581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_486_666"
          x1="14.8214"
          y1="34.652"
          x2="14.8214"
          y2="175.764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_486_666"
          x1="11.8683"
          y1="69.1354"
          x2="11.8683"
          y2="563.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_486_666"
          x1="13.3313"
          y1="71.3258"
          x2="13.3313"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_486_666"
          x1="16.9378"
          y1="83.3628"
          x2="16.9378"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_486_666"
          x1="13.3313"
          y1="69.1354"
          x2="13.3313"
          y2="563.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_486_666"
          x1="8.94385"
          y1="82.2469"
          x2="8.94385"
          y2="576.431"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_486_666"
          x1="19.9035"
          y1="40.4553"
          x2="19.9035"
          y2="213.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_486_666"
          x1="21.3255"
          y1="83.3629"
          x2="21.3255"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_486_666"
          x1="19.8635"
          y1="74.5755"
          x2="19.8635"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_486_666"
          x1="19.8635"
          y1="72.4207"
          x2="19.8635"
          y2="566.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_486_666"
          x1="21.3255"
          y1="81.1803"
          x2="21.3255"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_486_666"
          x1="21.3255"
          y1="74.5755"
          x2="21.3255"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_486_666"
          x1="19.8635"
          y1="76.7722"
          x2="19.8635"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_486_666"
          x1="21.3407"
          y1="48.4642"
          x2="21.3407"
          y2="362.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_486_666"
          x1="21.3255"
          y1="78.9901"
          x2="21.3255"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_486_666"
          x1="16.9378"
          y1="81.1803"
          x2="16.9378"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_486_666"
          x1="21.3255"
          y1="76.7722"
          x2="21.3255"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_486_666"
          x1="18.4004"
          y1="78.9901"
          x2="18.4004"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_486_666"
          x1="18.4004"
          y1="81.1803"
          x2="18.4004"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_486_666"
          x1="19.8635"
          y1="78.9901"
          x2="19.8635"
          y2="573.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_486_666"
          x1="18.4004"
          y1="85.532"
          x2="18.4004"
          y2="579.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_486_666"
          x1="18.4004"
          y1="76.7722"
          x2="18.4004"
          y2="570.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_486_666"
          x1="18.4004"
          y1="83.3629"
          x2="18.4004"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_486_666"
          x1="19.8635"
          y1="81.1803"
          x2="19.8635"
          y2="575.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_486_666"
          x1="19.8635"
          y1="83.3629"
          x2="19.8635"
          y2="577.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_486_666"
          x1="18.4004"
          y1="72.4207"
          x2="18.4004"
          y2="566.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_486_666"
          x1="18.4004"
          y1="74.5755"
          x2="18.4004"
          y2="568.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint87_linear_486_666"
          x1="16.9674"
          y1="49.4769"
          x2="16.9674"
          y2="229.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_486_666"
          x1="11.8229"
          y1="103.09"
          x2="11.8229"
          y2="603.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint89_linear_486_666"
          x1="11.8229"
          y1="105.248"
          x2="11.8229"
          y2="605.655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint90_linear_486_666"
          x1="11.0917"
          y1="68.034"
          x2="11.0917"
          y2="562.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint91_linear_486_666"
          x1="14.0122"
          y1="70.2304"
          x2="14.0122"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_486_666"
          x1="12.5497"
          y1="70.2304"
          x2="12.5497"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint93_linear_486_666"
          x1="11.0875"
          y1="70.2304"
          x2="11.0875"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_486_666"
          x1="12.5497"
          y1="68.034"
          x2="12.5497"
          y2="562.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_486_666"
          x1="13.2856"
          y1="102.94"
          x2="13.2856"
          y2="602.962"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_486_666"
          x1="13.2856"
          y1="105.255"
          x2="13.2856"
          y2="605.546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_486_666"
          x1="12.6044"
          y1="104.222"
          x2="12.6044"
          y2="604.928"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint98_linear_486_666"
          x1="11.1417"
          y1="104.168"
          x2="11.1417"
          y2="604.598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_486_666"
          x1="8.16184"
          y1="70.2304"
          x2="8.16184"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint100_linear_486_666"
          x1="8.24117"
          y1="32.1533"
          x2="8.24117"
          y2="174.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint101_linear_486_666"
          x1="7.48059"
          y1="71.3258"
          x2="7.48059"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint102_linear_486_666"
          x1="8.13967"
          y1="51.9843"
          x2="8.13967"
          y2="278.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint103_linear_486_666"
          x1="8.89705"
          y1="105.161"
          x2="8.89705"
          y2="604.988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint104_linear_486_666"
          x1="9.62446"
          y1="70.2304"
          x2="9.62446"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint105_linear_486_666"
          x1="10.3601"
          y1="105.244"
          x2="10.3601"
          y2="605.636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint106_linear_486_666"
          x1="9.67911"
          y1="104.135"
          x2="9.67911"
          y2="604.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint107_linear_486_666"
          x1="10.3603"
          y1="52.5521"
          x2="10.3603"
          y2="302.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint108_linear_486_666"
          x1="8.95827"
          y1="57.7185"
          x2="8.95827"
          y2="466.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint109_linear_486_666"
          x1="14.0274"
          y1="29.9722"
          x2="14.0274"
          y2="237.955"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint110_linear_486_666"
          x1="16.9378"
          y1="70.2304"
          x2="16.9378"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint111_linear_486_666"
          x1="8.21623"
          y1="106.33"
          x2="8.21623"
          y2="606.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint112_linear_486_666"
          x1="8.12662"
          y1="43.0925"
          x2="8.12662"
          y2="185.757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint113_linear_486_666"
          x1="14.0669"
          y1="104.135"
          x2="14.0669"
          y2="604.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint114_linear_486_666"
          x1="16.9921"
          y1="106.329"
          x2="16.9921"
          y2="606.596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint115_linear_486_666"
          x1="8.85981"
          y1="69.1242"
          x2="8.85981"
          y2="335.852"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint116_linear_486_666"
          x1="12.6058"
          y1="69.1823"
          x2="12.6058"
          y2="386.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint117_linear_486_666"
          x1="8.87001"
          y1="120.975"
          x2="8.87001"
          y2="623.059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint118_linear_486_666"
          x1="17.0367"
          y1="58.0294"
          x2="17.0367"
          y2="309.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint119_linear_486_666"
          x1="14.0663"
          y1="106.332"
          x2="14.0663"
          y2="606.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint120_linear_486_666"
          x1="7.43495"
          y1="105.246"
          x2="7.43495"
          y2="605.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint121_linear_486_666"
          x1="15.4751"
          y1="70.2304"
          x2="15.4751"
          y2="564.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint122_linear_486_666"
          x1="16.9378"
          y1="72.4207"
          x2="16.9378"
          y2="566.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint123_linear_486_666"
          x1="15.4521"
          y1="80.7551"
          x2="15.4521"
          y2="449.419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint124_linear_486_666"
          x1="8.89745"
          y1="118.4"
          x2="8.89745"
          y2="619.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint125_linear_486_666"
          x1="14.7483"
          y1="105.246"
          x2="14.7483"
          y2="605.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint126_linear_486_666"
          x1="14.7938"
          y1="69.1354"
          x2="14.7938"
          y2="563.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint127_linear_486_666"
          x1="16.2105"
          y1="105.246"
          x2="16.2105"
          y2="605.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint128_linear_486_666"
          x1="16.2738"
          y1="11.9117"
          x2="16.2738"
          y2="75.8043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint129_linear_486_666"
          x1="15.5304"
          y1="89.2804"
          x2="15.5304"
          y2="515.764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint130_linear_486_666"
          x1="16.2114"
          y1="89.1825"
          x2="16.2114"
          y2="499.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint131_linear_486_666"
          x1="22.0615"
          y1="114.251"
          x2="22.0615"
          y2="615.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint132_linear_486_666"
          x1="19.1359"
          y1="120.628"
          x2="19.1359"
          y2="621.117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint133_linear_486_666"
          x1="19.1816"
          y1="86.6265"
          x2="19.1816"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint134_linear_486_666"
          x1="19.1359"
          y1="118.322"
          x2="19.1359"
          y2="618.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint135_linear_486_666"
          x1="18.4545"
          y1="115.115"
          x2="18.4545"
          y2="615.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint136_linear_486_666"
          x1="19.1968"
          y1="61.6688"
          x2="19.1968"
          y2="483.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint137_linear_486_666"
          x1="18.4545"
          y1="112.918"
          x2="18.4545"
          y2="613.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint138_linear_486_666"
          x1="19.1816"
          y1="82.2467"
          x2="19.1816"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint139_linear_486_666"
          x1="18.4533"
          y1="110.857"
          x2="18.4533"
          y2="611.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint140_linear_486_666"
          x1="18.4549"
          y1="106.459"
          x2="18.4549"
          y2="607.369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint141_linear_486_666"
          x1="18.4547"
          y1="108.595"
          x2="18.4547"
          y2="609.498"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint142_linear_486_666"
          x1="19.1181"
          y1="55.4737"
          x2="19.1181"
          y2="223.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint143_linear_486_666"
          x1="19.1816"
          y1="75.6705"
          x2="19.1816"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint144_linear_486_666"
          x1="19.1359"
          y1="116.163"
          x2="19.1359"
          y2="616.721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint145_linear_486_666"
          x1="19.1358"
          y1="109.664"
          x2="19.1358"
          y2="610.249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint146_linear_486_666"
          x1="19.1359"
          y1="107.536"
          x2="19.1359"
          y2="608.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint147_linear_486_666"
          x1="19.1816"
          y1="73.4805"
          x2="19.1816"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint148_linear_486_666"
          x1="19.1816"
          y1="80.0573"
          x2="19.1816"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint149_linear_486_666"
          x1="19.1361"
          y1="114.071"
          x2="19.1361"
          y2="615.035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint150_linear_486_666"
          x1="19.1816"
          y1="77.8605"
          x2="19.1816"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint151_linear_486_666"
          x1="19.1359"
          y1="111.841"
          x2="19.1359"
          y2="612.364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint152_linear_486_666"
          x1="19.1816"
          y1="84.4301"
          x2="19.1816"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint153_linear_486_666"
          x1="17.6734"
          y1="116.329"
          x2="17.6734"
          y2="617.163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint154_linear_486_666"
          x1="17.6734"
          y1="114.235"
          x2="17.6734"
          y2="615.586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint155_linear_486_666"
          x1="17.7198"
          y1="80.0573"
          x2="17.7198"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint156_linear_486_666"
          x1="17.7198"
          y1="77.8605"
          x2="17.7198"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint157_linear_486_666"
          x1="17.6728"
          y1="120.803"
          x2="17.6728"
          y2="622.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint158_linear_486_666"
          x1="17.7198"
          y1="84.4301"
          x2="17.7198"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint159_linear_486_666"
          x1="17.6734"
          y1="112.051"
          x2="17.6734"
          y2="613.459"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint160_linear_486_666"
          x1="17.7198"
          y1="82.2467"
          x2="17.7198"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint161_linear_486_666"
          x1="17.6734"
          y1="118.4"
          x2="17.6734"
          y2="619.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint162_linear_486_666"
          x1="17.7198"
          y1="71.3258"
          x2="17.7198"
          y2="565.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint163_linear_486_666"
          x1="17.7198"
          y1="75.6705"
          x2="17.7198"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint164_linear_486_666"
          x1="17.6738"
          y1="69.2535"
          x2="17.6738"
          y2="390.746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint165_linear_486_666"
          x1="18.4547"
          y1="121.699"
          x2="18.4547"
          y2="622.036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint166_linear_486_666"
          x1="18.4545"
          y1="119.535"
          x2="18.4545"
          y2="620.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint167_linear_486_666"
          x1="18.378"
          y1="77.4597"
          x2="18.378"
          y2="494.937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint168_linear_486_666"
          x1="18.4545"
          y1="117.234"
          x2="18.4545"
          y2="617.887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint169_linear_486_666"
          x1="17.7198"
          y1="73.4805"
          x2="17.7198"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint170_linear_486_666"
          x1="17.6734"
          y1="109.655"
          x2="17.6734"
          y2="610.317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint171_linear_486_666"
          x1="17.6734"
          y1="107.456"
          x2="17.6734"
          y2="607.867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint172_linear_486_666"
          x1="20.6441"
          y1="73.4805"
          x2="20.6441"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint173_linear_486_666"
          x1="22.1075"
          y1="84.4301"
          x2="22.1075"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint174_linear_486_666"
          x1="21.3797"
          y1="115.113"
          x2="21.3797"
          y2="615.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint175_linear_486_666"
          x1="21.3797"
          y1="112.916"
          x2="21.3797"
          y2="613.241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint176_linear_486_666"
          x1="21.38"
          y1="108.596"
          x2="21.38"
          y2="609.506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint177_linear_486_666"
          x1="22.0612"
          y1="118.532"
          x2="22.0612"
          y2="608.979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint178_linear_486_666"
          x1="21.38"
          y1="110.743"
          x2="21.38"
          y2="611.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint179_linear_486_666"
          x1="20.5992"
          y1="107.534"
          x2="20.5992"
          y2="608.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint180_linear_486_666"
          x1="21.3255"
          y1="85.5319"
          x2="21.3255"
          y2="579.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint181_linear_486_666"
          x1="17.7198"
          y1="86.6265"
          x2="17.7198"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint182_linear_486_666"
          x1="21.3807"
          y1="117.362"
          x2="21.3807"
          y2="618.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint183_linear_486_666"
          x1="21.3803"
          y1="119.536"
          x2="21.3803"
          y2="620.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint184_linear_486_666"
          x1="22.0615"
          y1="109.657"
          x2="22.0615"
          y2="610.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint185_linear_486_666"
          x1="22.1075"
          y1="75.6705"
          x2="22.1075"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint186_linear_486_666"
          x1="22.1075"
          y1="73.4805"
          x2="22.1075"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint187_linear_486_666"
          x1="22.0615"
          y1="111.989"
          x2="22.0615"
          y2="613.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint188_linear_486_666"
          x1="22.0615"
          y1="118.402"
          x2="22.0615"
          y2="619.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint189_linear_486_666"
          x1="19.8635"
          y1="85.532"
          x2="19.8635"
          y2="579.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint190_linear_486_666"
          x1="22.1075"
          y1="82.2467"
          x2="22.1075"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint191_linear_486_666"
          x1="22.1075"
          y1="77.8605"
          x2="22.1075"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint192_linear_486_666"
          x1="22.1075"
          y1="80.0573"
          x2="22.1075"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint193_linear_486_666"
          x1="22.0618"
          y1="116.438"
          x2="22.0618"
          y2="617.809"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint194_linear_486_666"
          x1="19.9166"
          y1="112.956"
          x2="19.9166"
          y2="613.425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint195_linear_486_666"
          x1="19.9172"
          y1="108.691"
          x2="19.9172"
          y2="609.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint196_linear_486_666"
          x1="19.9166"
          y1="110.782"
          x2="19.9166"
          y2="611.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint197_linear_486_666"
          x1="20.6219"
          y1="56.2492"
          x2="20.6219"
          y2="323.938"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint198_linear_486_666"
          x1="19.9166"
          y1="117.306"
          x2="19.9166"
          y2="617.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint199_linear_486_666"
          x1="19.9166"
          y1="121.855"
          x2="19.9166"
          y2="622.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint200_linear_486_666"
          x1="19.9166"
          y1="119.581"
          x2="19.9166"
          y2="620.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint201_linear_486_666"
          x1="19.9163"
          y1="115.16"
          x2="19.9163"
          y2="615.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint202_linear_486_666"
          x1="20.5996"
          y1="120.757"
          x2="20.5996"
          y2="621.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint203_linear_486_666"
          x1="20.6441"
          y1="84.4301"
          x2="20.6441"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint204_linear_486_666"
          x1="20.6441"
          y1="77.8605"
          x2="20.6441"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint205_linear_486_666"
          x1="3.09247"
          y1="73.4805"
          x2="3.09247"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint206_linear_486_666"
          x1="20.597"
          y1="113.984"
          x2="20.597"
          y2="614.517"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint207_linear_486_666"
          x1="20.5995"
          y1="109.746"
          x2="20.5995"
          y2="610.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint208_linear_486_666"
          x1="20.6441"
          y1="75.6705"
          x2="20.6441"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint209_linear_486_666"
          x1="20.5992"
          y1="118.154"
          x2="20.5992"
          y2="617.977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint210_linear_486_666"
          x1="20.6441"
          y1="80.0573"
          x2="20.6441"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint211_linear_486_666"
          x1="20.6441"
          y1="82.2467"
          x2="20.6441"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint212_linear_486_666"
          x1="20.5992"
          y1="116.246"
          x2="20.5992"
          y2="617.212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint213_linear_486_666"
          x1="20.5992"
          y1="111.927"
          x2="20.5992"
          y2="612.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint214_linear_486_666"
          x1="5.2363"
          y1="85.532"
          x2="5.2363"
          y2="579.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint215_linear_486_666"
          x1="5.21997"
          y1="35.3762"
          x2="5.21997"
          y2="139.454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint216_linear_486_666"
          x1="5.29103"
          y1="121.741"
          x2="5.29103"
          y2="622.287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint217_linear_486_666"
          x1="5.29133"
          y1="117.234"
          x2="5.29133"
          y2="617.887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint218_linear_486_666"
          x1="5.29133"
          y1="119.535"
          x2="5.29133"
          y2="620.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint219_linear_486_666"
          x1="4.57031"
          y1="25.6692"
          x2="4.57031"
          y2="176.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint220_linear_486_666"
          x1="4.50996"
          y1="109.657"
          x2="4.50996"
          y2="610.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint221_linear_486_666"
          x1="17.6734"
          y1="122.895"
          x2="17.6734"
          y2="623.614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint222_linear_486_666"
          x1="4.55607"
          y1="73.4805"
          x2="4.55607"
          y2="567.671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint223_linear_486_666"
          x1="4.50967"
          y1="107.458"
          x2="4.50967"
          y2="607.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint224_linear_486_666"
          x1="6.01774"
          y1="82.2467"
          x2="6.01774"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint225_linear_486_666"
          x1="6.01774"
          y1="86.6265"
          x2="6.01774"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint226_linear_486_666"
          x1="6.01774"
          y1="84.4301"
          x2="6.01774"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint227_linear_486_666"
          x1="5.97146"
          y1="120.757"
          x2="5.97146"
          y2="621.886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint228_linear_486_666"
          x1="5.97106"
          y1="118.324"
          x2="5.97106"
          y2="618.986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint229_linear_486_666"
          x1="5.29076"
          y1="110.772"
          x2="5.29076"
          y2="611.464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint230_linear_486_666"
          x1="5.29133"
          y1="113.046"
          x2="5.29133"
          y2="614.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint231_linear_486_666"
          x1="5.29103"
          y1="108.552"
          x2="5.29103"
          y2="609.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint232_linear_486_666"
          x1="4.55607"
          y1="75.6705"
          x2="4.55607"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint233_linear_486_666"
          x1="5.97064"
          y1="112.228"
          x2="5.97064"
          y2="559.964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint234_linear_486_666"
          x1="5.29114"
          y1="101.387"
          x2="5.29114"
          y2="577.106"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint235_linear_486_666"
          x1="3.82842"
          y1="112.916"
          x2="3.82842"
          y2="613.241"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint236_linear_486_666"
          x1="3.82842"
          y1="115.113"
          x2="3.82842"
          y2="615.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint237_linear_486_666"
          x1="3.82872"
          y1="110.743"
          x2="3.82872"
          y2="611.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint238_linear_486_666"
          x1="3.82942"
          y1="117.362"
          x2="3.82942"
          y2="618.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint239_linear_486_666"
          x1="3.82902"
          y1="119.536"
          x2="3.82902"
          y2="620.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint240_linear_486_666"
          x1="4.50997"
          y1="111.989"
          x2="4.50997"
          y2="613.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint241_linear_486_666"
          x1="3.82871"
          y1="108.596"
          x2="3.82871"
          y2="609.506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint242_linear_486_666"
          x1="3.04536"
          y1="78.1316"
          x2="3.04536"
          y2="433.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint243_linear_486_666"
          x1="3.82785"
          y1="91.1461"
          x2="3.82785"
          y2="441.135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint244_linear_486_666"
          x1="3.77435"
          y1="85.532"
          x2="3.77435"
          y2="579.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint245_linear_486_666"
          x1="4.50997"
          y1="114.26"
          x2="4.50997"
          y2="615.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint246_linear_486_666"
          x1="4.55606"
          y1="80.0573"
          x2="4.55606"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint247_linear_486_666"
          x1="4.50967"
          y1="116.353"
          x2="4.50967"
          y2="617.307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint248_linear_486_666"
          x1="4.55607"
          y1="77.8605"
          x2="4.55607"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint249_linear_486_666"
          x1="4.50967"
          y1="120.681"
          x2="4.50967"
          y2="621.308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint250_linear_486_666"
          x1="4.55607"
          y1="84.4301"
          x2="4.55607"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint251_linear_486_666"
          x1="4.55606"
          y1="86.6265"
          x2="4.55606"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint252_linear_486_666"
          x1="4.50966"
          y1="118.402"
          x2="4.50966"
          y2="619.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint253_linear_486_666"
          x1="4.55606"
          y1="82.2467"
          x2="4.55606"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint254_linear_486_666"
          x1="5.29133"
          y1="115.242"
          x2="5.29133"
          y2="616.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint255_linear_486_666"
          x1="16.2189"
          y1="122.792"
          x2="16.2189"
          y2="623.119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint256_linear_486_666"
          x1="16.2565"
          y1="86.6265"
          x2="16.2565"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint257_linear_486_666"
          x1="16.2565"
          y1="84.4301"
          x2="16.2565"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint258_linear_486_666"
          x1="16.2105"
          y1="120.758"
          x2="16.2105"
          y2="621.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint259_linear_486_666"
          x1="16.2565"
          y1="88.8096"
          x2="16.2565"
          y2="583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint260_linear_486_666"
          x1="8.21623"
          y1="117.235"
          x2="8.21623"
          y2="617.898"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint261_linear_486_666"
          x1="8.21679"
          y1="121.696"
          x2="8.21679"
          y2="622.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint262_linear_486_666"
          x1="8.16184"
          y1="87.7219"
          x2="8.16184"
          y2="581.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint263_linear_486_666"
          x1="8.21731"
          y1="119.578"
          x2="8.21731"
          y2="620.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint264_linear_486_666"
          x1="8.21624"
          y1="123.949"
          x2="8.21624"
          y2="624.795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint265_linear_486_666"
          x1="16.9922"
          y1="121.696"
          x2="16.9922"
          y2="622.021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint266_linear_486_666"
          x1="16.9921"
          y1="117.235"
          x2="16.9921"
          y2="617.895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint267_linear_486_666"
          x1="16.9921"
          y1="119.578"
          x2="16.9921"
          y2="620.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint268_linear_486_666"
          x1="16.9921"
          y1="115.198"
          x2="16.9921"
          y2="615.941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint269_linear_486_666"
          x1="16.2109"
          y1="118.324"
          x2="16.2109"
          y2="618.986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint270_linear_486_666"
          x1="16.2348"
          y1="111.461"
          x2="16.2348"
          y2="588.518"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint271_linear_486_666"
          x1="16.2565"
          y1="82.2467"
          x2="16.2565"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint272_linear_486_666"
          x1="16.9921"
          y1="101.352"
          x2="16.9921"
          y2="489.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint273_linear_486_666"
          x1="16.9378"
          y1="87.7219"
          x2="16.9378"
          y2="581.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint274_linear_486_666"
          x1="6.75358"
          y1="121.775"
          x2="6.75358"
          y2="622.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint275_linear_486_666"
          x1="6.69978"
          y1="87.7219"
          x2="6.69978"
          y2="581.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint276_linear_486_666"
          x1="5.97135"
          y1="116.161"
          x2="5.97135"
          y2="616.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint277_linear_486_666"
          x1="6.01774"
          y1="75.6705"
          x2="6.01774"
          y2="569.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint278_linear_486_666"
          x1="6.75357"
          y1="119.579"
          x2="6.75357"
          y2="620.212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint279_linear_486_666"
          x1="5.97105"
          y1="113.984"
          x2="5.97105"
          y2="614.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint280_linear_486_666"
          x1="6.75358"
          y1="117.304"
          x2="6.75358"
          y2="617.958"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint281_linear_486_666"
          x1="6.01774"
          y1="80.0573"
          x2="6.01774"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint282_linear_486_666"
          x1="6.01774"
          y1="77.8605"
          x2="6.01774"
          y2="572.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint283_linear_486_666"
          x1="5.97105"
          y1="111.843"
          x2="5.97105"
          y2="612.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint284_linear_486_666"
          x1="7.48059"
          y1="82.2467"
          x2="7.48059"
          y2="576.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint285_linear_486_666"
          x1="7.43551"
          y1="118.154"
          x2="7.43551"
          y2="617.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint286_linear_486_666"
          x1="7.48059"
          y1="80.0573"
          x2="7.48059"
          y2="574.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint287_linear_486_666"
          x1="7.43525"
          y1="116.161"
          x2="7.43525"
          y2="616.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint288_linear_486_666"
          x1="7.48059"
          y1="84.4301"
          x2="7.48059"
          y2="578.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint289_linear_486_666"
          x1="7.43595"
          y1="120.757"
          x2="7.43595"
          y2="621.886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint290_linear_486_666"
          x1="7.45838"
          y1="56.5058"
          x2="7.45838"
          y2="311.411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint291_linear_486_666"
          x1="7.43525"
          y1="122.809"
          x2="7.43525"
          y2="623.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint292_linear_486_666"
          x1="7.48059"
          y1="86.6265"
          x2="7.48059"
          y2="580.811"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint293_linear_486_666"
          x1="6.75357"
          y1="115.222"
          x2="6.75357"
          y2="616.005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="1" stopColor="#00FFFF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_486_666">
          <rect
            width="22.4299"
            height="24"
            fill={color ?? 'white'}
            transform="translate(1)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
